export default {
  seleccionaNegocio: "Selecciona negoci...",
  filtraPorEtiqueta: "Filtra per etiqueta",
  noEncontramosResultadosPara: "No hem trobat resultats per a ",
  mostrando: "Mostrant",
  resultado: "resultat",
  resultados: "resultats",

  // ALMACÉN
  totalAlmacen: "Total Magatzem",
  totalAlmacenDto: "Total Magatzem Dto",
  existenciasTeoricas: "Existències Teòriques",
  diferencia: "Diferència",
  noContabilizado: "No comptabilitzat",
  seleccioneUnaFechaDeInicioYUnaFechaDeFin:
    "Seleccioneu una data d'inici i una data de finalització",

  // INFORMES
  inicio: "Inici",
  informes: "Informes",
  productos: "Productes",
  ventasPorNegocio: "Vendes per negoci",
  casas: "Cases",
  facturasSimplificadas: "Factures simplificades",
  comprasPorNegocio: "Compres per negoci",
  comprasPorCasas: "Compres per cases",
  gastosPorProveedor: "Despeses per proveïdor",
  gastosPorSubproductos: "Despeses per matèries primeres",
  sage: "SAGE",
  sageplancuentas: "Pla de Comptes",
  sageclientes: "Clients",
  sageefectos: "Efectes",
  sageasientos: "Assentament Comptable",

  // CASAS
  nuevaCasa: "Nova casa",
  casa: "Casa",
  negocio: "Negoci",
  desde: "Des de",
  hasta: "Fins a",
  consultar: "Consultar",
  infoCasas:
    "Aquest consum de cases prové de les despeses introduïdes en el rang de dates seleccionat",
  exportarInforme: "Exportar informe",
  exportarPdf: "Exportar com PDF",
  exportarExcel: "Exportar com Excel",
  exportarExcelSinSubproductos: "Exportar com Excel amb matèries primeres",

  // TABLA
  fecha: "Data",
  subproductos: "Matèries primeres",
  subproducto: "Matèria primera",
  unidades: "Unitats",
  partes: "Parts",
  precio: "Preu",
  total: "Total",
  infoConsumo:
    "Aquest consum de cases prové de les despeses introduïdes en el rang de dates seleccionat",
  noHay: "No hi ha",
  gastos: "Despeses",
  rangoDeFechas: "en aquest rang de dates.",
  clickConsultarParaRealizarBusqueda: "Feu clic al botó Consultar per realitzar la cerca",
  avisoDatosUltimaConsulta: "Aquestes dades són de l'última consulta realitzada. Si has canviat de negoci, TPV o dates, prem \"Consultar\" per actualitzar-les.",
  ultimaActualizacion: "Última actualització",
  negocioBloqueadoConsultasEnCurso: "Hi ha consultes en curs. Espera que acabin per canviar de negoci.",
  configuracion: "Configuració",
  datosFiscales: "Dades Fiscals",

  // DATOS FISCALES
  nombreFiscal: "Nom fiscal",

  // FORM CASA
  nombreCasa: "Nom Casa",
  cifNif: "CIF NIF",
  direccion: "Adreça",
  provincia: "Província",
  ciudad: "Ciutat",
  codigoPostal: "Codi postal",
  pais: "País",
  telefono: "Telèfon",
  correoElectronico: "Correu electrònic",
  iban: "IBAN",
  numeroRegistroSanitario: "Número registre sanitari",
  baja: "Baixa",
  guardar: "Guardar",
  cancelar: "Cancel·lar",
  replicar: "Replicar en altres negocis",
  replicarCasa: "Replicar casa en altres negocis",
  seleccionarTodos: "Seleccionar tots",
  aceptar: "Acceptar",
  casaMin: "cases",

  compras: "Compres",
  agregarCasa: "Afegir Casa",
  email: "Email",
  acciones: "Accions",
  turnos: "Torns",
  editar: "Editar",
  enEsteNegocio: " en aquest negoci.",

  // PLACEHOLDER
  introduzcaNombre: "Introduïu nom",
  introduzcaCifNif: "Introduïu CIF / NIF",
  introduzcaDireccion: "Introduïu adreça",
  introduzcaProvincia: "Introduïu província",
  introduzcaCiudad: "Introduïu ciutat",
  introduzcaCodigoPostal: "Introduïu codi postal",
  introduzcaTelefono: "Introduïu telèfon",
  introduzcaCorreo: "Introduïu correu electrònic",
  introduzcaIban: "Introduïu IBAN",
  introduzcaNumeroRegistroSanitario: "Introduïu número registre sanitari",
  buscar: "Cercar...",

  // PROVEEDORES
  proveedores: "Proveïdors",
  agregarProveedor: "Afegir Proveïdor",
  categoria: "Categoria",
  proveedoresMin: "proveïdors",

  // FORM
  nombreProveedor: "Nom Proveïdor",
  acreedor: "Acreedor",
  infoAcreedor: "(Si un proveïdor és acreedor no apareixerà a Numier TPV)",
  replicarProveedor: "Replicar proveïdor en altres negocis",
  category: "Categoria",
  replicarCategory: "Replicar etiqueta en altres negocis",

  // ETIQUETAS
  etiquetas: "Etiquetes",
  etiqueta: "Etiqueta",
  sinEtiqueta: "Sense etiqueta",
  nuevaEtiqueta: "Nova etiqueta",
  agregarEtiqueta: "Afegir etiqueta",
  tipo: "Tipus",
  etiquetaPadre: "Etiqueta Pare",
  tipoPadre: "Tipus Pare",

  // FORM
  nombreEtiqueta: "Nom Etiqueta",

  // SUBPRODUCTOS
  agregarSubproducto: "Afegir Matèria primera",
  precioCompra: "Preu de compra",
  escandallo: "Escandall",
  subproductosCreados: "Matèries Primeres Creades",
  nuevaCategoria: "Nova categoria",
  materiaPrima: "Matèria primera",
  materiasPrimas: "Matèries primeres",

  // FORM
  nuevoProveedor: "Nou Proveïdor",
  nombreSubproducto: "Nom Matèria primera",
  codigoBarra: "Codi de barres",
  descripcion: "Descripció",
  tipoIva: "Tipus I.V.A.",
  cuotaIVA: "Quota IVA",
  ivaIncluido: "(IVA inclòs)",
  descuentoCompra: "Descompte compra",
  porcentaje: "(% Percentatge)",
  guardarEnAlmacen: "Guardar a magatzem",
  stockMinimo: "Stock mínim",
  stockOptimo: "Stock òptim",
  gastosPorProveedoresUnidos: "Despeses per proveïdors units",
  caracteresRestantes: "Caràcters restants",

  // INFORME SUBPRODUCTO
  referencia: "Referència",
  uds: "Uds",
  iva: "IVA",
  importe: "Import",
  imp: "Imp.",
  sinDto: "SENSE DTO.",
  importeConIva: "Import amb IVA",
  importeSinIva: "Import sense IVA",
  importeSinIvaDto: "Import sense IVA amb Dto",
  precioUdSinIva: "Preu / ud sense IVA",
  dto: "Dto",
  ttal: "Total",

  // PRODUCTOS
  producto: "Producte",
  precioDeCoste: "Preu de cost",
  tarifa1: "Tarifa 1",
  tarifa2: "Tarifa 2",
  tarifa3: "Tarifa 3",
  tarifa4: "Tarifa 4",
  agregarProductos: "Afegir producte",
  noHayProductosEnEsteNegocio: "No hi ha productes en aquest negoci",
  sinCategoria: "Sense categoria",
  cliente: "Client",

  // FORM
  nombreProducto: "Nom del producte",
  codigoDeBarra: "Codi de barres",
  colorBoton: "Color del botó",
  descuento: "Descompte",
  precioCoste: "Preu cost",
  opcionesAlSeleccionarElArticulo: "Opcions al seleccionar el producte",
  numeroDeOpcionales: "Nombre de matèries primeres opcionals",
  impresoraComandasTPV: "Impressora comandes TPV",
  impresoraComandasPDA: "Impressora comandes PDA",
  copiaImpresoraComandasTPV: "Còpia impressora comandes TPV",
  copiaImpresoraComandasPDA: "Còpia impressora comandes PDA",
  impresionPlano: "Impressora pla",
  impresionPlanoKDS: "Impressora pla KDS",
  copiaImpresionPlano: "Còpia impressora pla",
  copiaImpresionPlanoKDS: "Còpia impressora pla KDS",
  impresionPlano1: "Impressora pla 1",
  impresionPlano2: "Impressora pla 2",
  impresionPlano3: "Impressora pla 3",
  impresionKDSTPV: "Enviar comanda des de TPV",
  impresionKDSPDA: "Enviar comanda des de PDA",
  copiaImpresionKDSTPV: "Còpia comanda des de TPV",
  copiaImpresionKDSPDA: "Còpia comanda des de PDA",
  pedirPrecio: "Demanar preu",
  pedirPeso: "Demanar pes",
  pedirImporte: "Demanar import",
  promocionable: "Promocionable",
  mostrarPC: "Mostrar a PC",
  mostrarPDA: "Mostrar a PDA",
  noImprimir: "No imprimir",
  numeroPlato: "Número de plat per defecte",
  seleccionIngredientes: "Activar selecció d'ingredients",
  introduzcaDescripcion: "Introduïu descripció",
  introduzcaCodigoDeBarras: "Introduïu codi de barres",
  introduzcaPrecioCoste: "Introduïu preu cost",
  opcion1: "Opció 1",
  opcion2: "Opció 2",
  opcion3: "Opció 3",
  opcion4: "Opció 4",
  opcion5: "Opció 5",
  numOpcionales: "Nombre de matèries primeres opcionals",

  // OPERARIOS
  operarios: "Operaris",
  agregarOperario: "Afegir operari",
  apellido: "Cognom",
  nombreOperarios: "Nom operaris",
  pass: "Contrasenya",
  salario: "Sou",
  passTurn: "Contrasenya de torn",
  hombre: "Home",
  mujer: "Dona",
  replicarProducto: "Replicar producte en altres negocis",
  introduzcaEscandallo: "Introduïu escandall",
  introduzcaStockMinimo: "Introduïu stock mínim",
  introduzcaStockOptimo: "Introduïu stock òptim",
  introduzcaPrecioCompra: "Introduïu preu compra",
  introduzcaApellido: "Introduïu cognom",
  introduzcaPass: "Introduïu contrasenya",
  introduzcaEmail: "Introduïu email",
  introduzcaSalario: "Introduïu sou",
  introduzcapassTurn: "Introduïu contrasenya de torn",
  replicarOperario: "Replicar operari en un altre negoci",
  TPV: "TPV",
  precioMed: "Preu mitjà",
  precioMedSinIva: "Preu mitjà sense IVA",
  porUnidad: "Per unitats",
  porImporte: "Per import",
  contrasenya: "Contrasenya PDA",
  repartidor: "Repartidor",
  buscaRepartidor: "Cerca repartidor",
  noMostrarEnVentas: "No mostrar a vendes",
  noHayOperariosEnEsteNegocio: "No hi ha operaris en aquest negoci",
  VerDetalles: "Veure detalls",
  codigoTurno: "Codi de torn",
  operarioDatosIncompletos: "Tots els camps són obligatoris",
  enviarQR: "Enviar QR de torns",
  descargarTurnoQR: "Descarregar PDF amb QR de torns",
  enviarEmailTurnoQR: "Enviar per email QR de torns",
  emailEnviado: "L'email s'ha enviat correctament",
  enviado: "Enviat",
  errorActualizar: "Error al actualitzar l'operari",
  errorEnviarEmail: "No s'ha pogut enviar l'email",
  accesoDenegado: "Accés denegat",
  noTienesPermisosParaRealizar: "No tens permisos per realitzar aquesta acció",
  emailNoValido: "L'email no té un format vàlid",
  gestionTurnos: "Torns per operari",
  gestionTurnosSubtitle: "Consulta i gestió dels fitxatges dels operaris",
  gestionTurnosSubtitleConsulta: "Consulta i gestió",
  gestionTurnosSubtitleDeLos: "dels",
  gestionTurnosSubtitleFichajes: "fitxatges",
  gestionTurnosSubtitleOperarios: "dels operaris",

  // CLIENTES
  clientes: "Clients",
  companyia: "Campanya",
  agregarCliente: "Afegir client",
  nombreCliente: "Nom client",
  saldo: "Saldo",
  infoCliente: "En cas d'utilitzar targetes de saldo",
  tarifa: "Tarifa",
  descuentoImporte: "Descompte import",
  noHayClientesEnEsteNegocio: "No hi ha clients en aquest negoci",
  barCode: "Codi de barres",
  cuentaContableSocio: "Compte comptable Soci",
  cuentaContableLevy: "Compte comptable Levy",

  // IMPRESION
  impresionDeComandas: "Impressió de comandes",
  copiaDeImpresionDeComandas: "Còpia impressió de comandes",
  impresionPorPlana: "Impressió per pla",
  impresionPorKDS: "Impressió per KDS",
  monitorDeCocina: "Monitor de cuina",

  // INFORMES
  ventas: "Vendes",
  tarjetas: "Targetes",
  cheque: "Xec",
  cambio: "Canvi",
  recuento: "Comptatge",
  descuadre: "Desquadre",
  siguienteDia: "Següent dia",
  incidencias: "Incidències",
  recaudado: "Recaptat",
  noHayVentasEnEsteRangoDeFechas: "No hi ha vendes en aquest rang de dates",
  tickets: "Tiquets",
  factura: "Factura",
  noHayFormasDePagoEnEsteRangoDeFecha:
    "No hi ha formes de pagament en aquest rang de dates",
  desglose: "Desglossament",
  sinBase: "Sense base",
  base: "Base",
  baseTotal: "Base total",
  impuesto: "Impost",
  facturasEmitidas: "Factures nominatives",
  mesa: "Taula",
  cifnif: "CIF/NIF",
  cobro: "Cobrament",
  noHayFacturasEmitidasEnEsteRangoDeFecha:
    "No hi ha factures emeses en aquest rang de dates",
  estadisticasAgencias: "Estadístiques agències",
  agencia: "Agència",
  comentario: "Comentari",
  noHayEstadisticasDeAgenciaEnEsteRangoDeFechas:
    "No hi ha estadístiques d'agències en aquest rang de dates",
  desglosesImpuestos: "Impostos per tancament de caixa",
  desglosesImpuestosAgencia: "Impostos per agència",
  noHayFormasDePagoEnEsteRangoDeFechas:
    "No hi ha formes de pagament en aquest rang de dates",
  cuentasAparcadas: "Comptes a crèdit",
  operacion: "Operació",
  operario: "Operari",
  noExisteDesgloseImpuestos: "No existeix desglossament d'impostos",
  noHayCuentasAparcadasEnEsteRangoDeFechas:
    "No hi ha comptes a crèdit en aquest rang de dates",
  noHayCuentasAnuladasEnEsteRangoDeFechas:
    "No hi ha comptes anul·lats en aquest rang de dates",
  cierreCaja: "Tancament caixa",
  fechaCierre: "Data tancament",
  venta: "Venda",
  totalRecaudado: "Total recaptat",
  noHayCierresDeCajaEnEsteRangoDeFecha:
    "No hi ha tancaments de caixa en aquest rang de dates",
  cierreCajaZ: "Tancament de Caixa Z",

  // MODAL
  n: "Núm.",
  apertura: "Apertura",
  cierre: "Tancament",
  totalVenta: "Total venda",
  efectivo: "Efectiu",
  tarjetaCheques: "Tarc+Xecs",
  totalTeorico: "Total teòric",
  totalEnArqueo: "Total en arqueig",
  cambioSig: "Canvi sig",
  volver: "Tornar",
  confirmacionImportacionHeader: "Confirmació d'importació",
  confirmacionImportacionText: "Estàs segur que vols importar?",
  confirmar: "Confirmar",
  registros: "registres",
  headerError: "ERROR",
  bodyError: "Si us plau, inseriu un arxiu amb menys de 10.000 registres",
  en: "En ",

  // OPERARIOS
  ventasPorOperarios: "Comptes cobrats per operari",
  invitaciones: "Invitacions",
  horas: "Hores",
  sueldo: "Sou",
  categorias: "Categories",

  // CLIENTES
  ventasPorClientes: "Vendes per client",
  companya: "Empresa",
  consumiciones: "Consumicions",
  media: "Mitjana",
  valorMedioDelTicket: "Valor mitjà del tiquet",
  todosLosClientes: "Tots els clients",
  todosLosOperarios: "Tots els operaris",
  operariosAplicar: "Operaris als quals s'aplicarà",
  rentabilidadInfo: "Preu mitjà menys el cost de les seves matèries primeres (preu de cost del producte)",
  sinPrecioDeCoste: "Sense preu de cost: calculeu-lo des d'Eines o a la fitxa del producte",
  buscarCliente: "Cerca client per nom, codi o CIF…",
  clientesConVentasEnElPeriodo: "amb vendes en el període",
  noHayClientesConVentas: "No hi ha clients amb vendes en el període",
  ningunClienteCoincide: "Cap client coincideix amb la cerca",
  seleccionados: "seleccionats",
  clientesSeleccionados: "clients seleccionats",
  quitarFiltro: "Treure filtre",
  deLosClientes: "de {total} clients",
  buscarOperario: "Cercar operari...",
  ninguno: "Cap",
  mas: "més",
  ningunOperarioCoincide: "No hi ha operaris que coincideixin",
  ningunOperario: "Cap operari",
  deOperarios: "de {total} operaris",
  eligeAlMenosUnOperario: "Tria almenys un operari per aplicar les restriccions",
  mediaSesion: "Mitjana sessió",

  // AGENCIAS
  noHayAgenciasEnEsteMomento: "No hi ha agències en aquest moment",
  agencias: "Agències",
  nombreAgencia: "Nom agència",
  comision: "Comissió",
  replicarAgencias: "Replicar agència",
  agregarAgencias: "Afegir agència",

  // MODIFICADORES
  nombreModificador: "Nom modificador",
  grupos: "Grups",
  variacion: "Variació",
  resta: "Resta",
  suma: "Suma",
  modificador: "Modificador",
  modificadores: "Modificadors",
  agregarModificador: "Afegir modificador",
  grupo: "Grup",
  noHayModificadoresEnEsteNegocio: "No hi ha modificadors en aquest negoci",
  almacen: "Magatzem",
  todos: "Tots",
  precioCompraConIva: "Preu compra AMB IVA",
  precioCompraSinIva: "Preu compra SENSE IVA",
  precioDescuentoSinIva: "Preu amb descompte SENSE IVA",
  codigoIdentificacion: "Codi identificació",
  replicarModificador: "Replicar modificador",

  // SOPORTE ONLINE
  soporteOnline: "Suport Online",
  soporteOnlineDetails: "Suport Online - Detalls",
  abierto: "Obert",
  esperandoRespuesta: "Esperant resposta",
  respondido: "Respost",
  cerrado: "Tancat",
  tecnico: "Tècnic",
  comercial: "Comercial",
  facturacion: "Facturació",
  noTicketsEnNegocio: "No hi ha tiquets en aquest negoci",
  responderTicket: "Respondre tiquet",
  mensaje: "Missatge",
  cerrar: "Tancar",
  enviarTicket: "Enviar tiquet",
  nuevoTicket: "Nou tiquet",
  asunto: "Assumpte",
  estado: "Estat",
  departamento: "Departament",
  visitas: "Visites",
  verTicket: "Veure tiquet",
  tarjeta: "Targeta",

  // FORMAS DE PAGO
  nueva: "Nova",
  replicarFormaDePago: "Replicar Forma de pagament",
  nombreFormaPago: "Nom forma de pagament",
  formaDePago: "Forma de pagament",
  formasDePago: "Formes de pagament",
  agregarFormaDePago: "Afegir forma de pagament",
  noHayFormasDePagoEnEsteNegocio:
    "No hi ha formes de pagament en aquest negoci",
  nuevo: "Nou",
  renovado: "Renovat",

  // EDICIÓN MASIVA
  transferirProductosDeCategoria: "Transferir productes de categoria",
  tranferir: "Transferir",
  impresionDeProductosDeCategorias: "Impressió de productes de categories",
  impresoraComanda: "Impressora comanda",
  impresoraComandaTpv: "Impressora comanda TPV",
  impresoraComandaPda: "Impressora comanda PDA",
  copiaImpresionDeComanda: "Còpia impressió de comandes",
  copiaImpresoraComandasTpv: "Còpia impressora comandes TPV",
  copiaImpresoraComandasPda: "Còpia impressora comandes PDA",
  impresionPorPlano: "Impressió per pla",
  enviarComandaDesdeTpv: "Enviar comanda des de TPV",
  enviarComandaDesdePda: "Enviar comanda des de PDA",
  respetarOtrasImpresiones: "Respectar altres impressions?",
  cambioDePrecioProductos: "Canvi de preu productes",
  opcion: "Opció",
  tipoDeTarifa: "Tipus de tarifa",
  cambiarPrecio: "Canviar preu",
  ajustes: "Ajustos",
  cambiarImpresionDeGrupo: "Canviar impressió de grup",
  tranferirProductosDeUnaCategoriaAOtra:
    "Transferir productes d'una categoria a una altra",
  cambiarPreciosAProductos: "Canviar preus a productes",

  // WIDGETS
  consumoPorHoras: "Vendes per hores",
  productosMasVendidos: "Productes més venuts",
  ultimosTickets: "Últims tiquets",
  verTodos: "Veure Tots",
  arqueoDeCaja: "Arqueig de caixa",
  cobrado: "Cobrat",

  cajaCerrada: "Caixa Tancada",
  licenciaCaducada: "Llicència Caducada",
  cajonInteligente: "Calaix intel·ligent",
  moneda: "Moneda",
  nivelReciclador: "Nivell Recicl.",
  totalReciclador: "Total Recicl.",
  nivelCasete: "Nivell Caset",
  totalCasete: "Total Caset",
  totalMonedas: "Total monedes",
  totalBilletes: "Total bitllets",
  totalEnDirectoPorNegocio: "Vendes en directe per negocis/s",
  enCuenta: "En compte",
  cajaOnline: "Caixes Online",
  planoDeMesas: "Pla de taules",
  planoDeTaquillas: "Pla de taquilles",
  nombrePlano: "Nom pla",
  mesas: "Taules",
  taquillas: "Taquilles",
  ocupacion: "Ocupació",
  enPlano: "En pla",
  desgloseTicket: "Desglossament de tiquet",
  precioMedio: "Preu mitjà",
  apuntado: "Apuntat",
  anulado: "Anulat",
  aparcado: "A crèdit",
  indicencias: "Incidències",
  filtrarOperario: "Filtrar operari",
  situacionActualDeLosNivelesDelCajonInteligente:
    "Situació actual dels nivells del calaix intel·ligent",
  verDetallesDeNiveles: "Veure detalls de nivells",
  noHayCajonInteligenteParaMostrar: "No hi ha calaix intel·ligent per mostrar",
  consulteConSuDistribuidor: "Consulti amb el seu distribuïdor",
  comparativaVentasAnteriores: "Comparativa vendes anteriors",
  graficaDeConsumoRespectoAHistoricoDeSesiones:
    "Gràfica de consum respecte a l'històric de sessions",
  graficaDeConsumoAgrupadaPorTramosHorarios:
    "Gràfica de consum agrupada per trams",
  situacionActualDeOcupacionDeMesas: "Situació actual d'ocupació de taules",
  situacionActualDeOcupacionDeTaquillas:
    "Situació actual d'ocupació de taquilles",
  verPlanoCompleto: "Veure pla complet",
  rankingDeLaSesionActual: "Ranking de la sessió actual",
  ultimosMovimientosDeLaCajaPorOperario:
    "Últims moviments de la caixa per operari",
  estadoActualDeLaCaja: "Estat actual de la caixa",
  turnosDeOperarios: "Torns d'operaris",
  relacionDeHorasTrabajadasYVentasRealizadasPorOperario:
    "Relació d'hores treballades i vendes realitzades per operari",
  horarioInicio: "Hora inici",
  horaFin: "Hora fi",
  horasTrabajadas: "Hores treballades",
  noHayTurnosDeOperarioParaMostrar: "No hi ha torns d'operaris per mostrar",
  propuestaDePedido: "Proposta de comanda",
  pedidoAProveedor: "Comanda a proveïdor",
  atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio:
    "Atenció, hi ha moviments de magatzem que no s'han descarregat en el negoci",
  seleccionarNegocio: "Seleccionar negoci",
  seleccionarProveedor: "Seleccionar proveïdor",
  generarPedidoEnBlanco: "Generar comanda en blanc",
  generarPedido: "Generar comanda",
  propuestaDePedidoA: "Proposta de comanda a ",
  buscarMateriaPrimaEnElMismoProveedor:
    "Buscar matèria primera en el mateix proveïdor",
  precioIVAIncluido: "Preus IVA inclòs",
  ref: "Ref",
  nombre: "Nom",
  existencias: "Existències",
  pedido: "Comanda",
  precioArticuloUnidad: "Preu article / unitat",
  precioPedido: "Preu Comanda",
  sinIVA: "Sense IVA",
  porcentajeIVA: "% IVA",
  precioIVA: "Preu IVA",
  porcentajeDto: "% Dto",
  totalIVA: "Total IVA",
  observaciones: "Observacions",
  noHaySubproductosEnEsteNegocioParaRealizarElPedido:
    "No hi ha matèries primeres en aquest negoci per fer la comanda",
  recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo:
    "Recordeu que per a que apareguin les matèries primeres han d'estar associades a un proveïdor i configurat el stock mínim i òptim",
  guardarPedido: "Guardar comanda",
  totalIVAInc: "Total IVA Inc.",
  pedidosAProveedor: "Comanda a proveïdor",
  fechaInicio: "Data inici",
  fechaFin: "Data fi",
  pedidosConvertidos: "Comandes convertides",
  nuevoPedido: "Nova comanda",
  enviarPedidos: "Enviar comandes",
  convertido: "Convertit",
  convertirEnGasto: "Convertir en despesa",
  modificar: "Modificar",
  eliminar: "Eliminar",
  descargarComoPDF: "Descarregar com PDF",
  descargarComoPDFSinPrecios: "Descarregar com PDF sense preus",
  descargarComoExcel: "Descarregar com Excel",
  descargarComoExcelSinPrecios: "Descarregar com Excel sense preus",
  enviarPorCorreo: "Enviar per correu",
  eliminarListaCorreo: "Eliminar llista correu",
  anyadirListaCorreo: "Afegir llista correu",
  noHayPedidosAEsteProveedorEnEsteRangoDeFecha:
    "No hi ha comandes a aquest proveïdor en aquest rang de dates",
  enviarPedido: "Enviar comanda",
  enviarPedidoA: "Enviar comanda a",
  formato: "Format",
  PDF: "PDF",
  excel: "Excel",
  conPrecios: "Amb preus",
  sinPrecios: "Sense preus",
  convertirPedido: "Convertir comanda",
  tipoDeDocumento: "Tipus de document",
  albaran: "Albarà",
  generarEntradaEnAlmacenAlVerificar:
    "Generar entrada en magatzem en verificar",
  gastosDeCasas: "Despeses de cases",
  gastosPorCasa: "Despeses per casa",
  noHayGastosPorCasasEnEsteRangoDeFechas:
    "No hi ha despeses per cases en aquest rang de dates",
  ventasDeCategorias: "Vendes de categories",
  ventasCategoriaDe: "Vendes categoria de ",
  volverAGeneral: "Tornar a general",
  ventasDeProductos: "Vendes de productes",
  filtrarPorTPV: "Filtrar per TPV",
  filtrarTPV: "Filtrar TPV",
  turnosDe: "Torns de ",
  enActivo: "En actiu",
  ventasDeProductosDe: "Productes de comptes cobrats per ",
  ignorarRecuentosNegativos: "Ignorar recomptes negatius",
  ventasOperarios: "Comptes cobrats",
  costesDeProductos: "Costos de productes",
  totalImportesVentas: "Total imports vendes",
  totalCoste: "Cost total",
  costes: "Costos",
  costeUd: "Cost unitat",
  coste: "Cost",
  porcentajeCosto: "% Cost",
  varCostoMed: "Var. Cost Mitj.",
  listaDeInvitaciones: "Llista d'invitacions",
  valor: "Valor",
  volverALaLista: "Tornar a la llista",
  ventasDeProductosGlobal: "Vendes de productes global",
  porUnidades: "Per unitats",
  gastosPorEtiquetas: "Despeses per etiquetes",
  desgloseDeGastos: "Desglossament de despeses",
  referencias: "Referències",
  concepto: "Concepte",
  gastosDeProveedores: "Despeses de proveïdors",
  sinProveedor: "Sense proveïdor",
  sinCasas: "Sense cases",
  cierreDeCaja: "Tancament de caixa",
  primerTicket: "Primer tiquet",
  ultimoTicket: "Últim tiquet",
  cheques: "Xecs",
  cambioSigDia: "Canvi sig. dia",
  ventasPorAgencias: "Vendes per agències",
  ventasPorFormasDePago: "Vendes per forma de pagament",
  exportarComoHTML: "Exportar com HTML",
  pendiente: "Pendent",
  gasto: "Despesa",
  desgloseDeImpuestos: "Desglossament d'impostos",
  desgloseDelTicket: "Desglossament del tiquet",
  cuentasAnuladas: "Comptes anul·lades",
  buscarPorHoras: "Cercar per hores",
  buscarBaja: "Mostrar productes de baixa",
  buscarSubProductoBaja: "Mostrar matèries primeres de baixa",
  buscarCategoriasBaja: "Mostrar categories de baixa",
  buscarEtiquetasBaja: "Mostrar etiquetes de baixa",
  mostrarClientesBaja: "Mostrar clients de baixa",
  deBaja: "de baixa",
  mostrarVentasAcumuladasPorDia: "Mostrar vendes acumulades per dia",
  seleccionaUnTpv: "Has de seleccionar un TPV per veure els seus detalls",
  deshabilitarCheckboxVentasAcumuladasPorDia:
    "Deshabilita la checkbox 'Mostrar vendes acumulades per dia' per veure els detalls.",
  graficas: "Gràfiques",
  dias: "Dies",
  semanas: "Setmanes",
  meses: "Mesos",
  ventasPorComensales: "Vendes per comensals",
  numeroDeComensales: "Nombre de comensals",
  precioMedioPorComensal: "Preu mitjà per comensal",
  ventasPorRangosHorarios: "Vendes per rangs horaris",
  ops: "Ops",
  comensales: "Comensals",
  detalleDeOperaciones: "Detall d'operacions",
  operaciones: "Operacions",
  operacionMedia: "Operació mitjana",
  detalleDeComensales: "Detall de comensals",
  comensalMedio: "Comensal mitjà",
  noHayVentasEnLosRangosDeFechasDefinidos:
    "No hi ha vendes en els rangs de dates definits",
  transferencia: "Transferència",
  domiciliacion: "Domiciliació",
  fechaGasto: "Data despesa",
  generarEntradaDeAlmacenAlVerificar:
    "Generar entrada en magatzem en verificar",
  listaDeMateriaPrima: "Llista de matèria prima",
  preciosIVAIncluido: "Preus IVA inclòs",
  precioSinIVA: "Preu sense IVA",
  precioIVAInc: "Preu IVA inc",
  IVA: "IVA",
  totalBase: "Total base",
  totalDocumento: "Total document",
  seleccioneUnaCasa: "Seleccioneu una casa",
  anyadirNuevoSubproducto: "Afegir nou subproducte",
  gestionDeGastos: "Gestió de despeses",
  deCaja: "De caixa",
  fueraDeCaja: "Fora de caixa",
  contabilizado: "Comptabilitzat",
  si: "Sí",
  no: "No",
  grafica: "Gràfica",
  lista: "Llista",
  avanzado: "Avançat",
  noHayVentasDeProductosEnEsteRangoDeFechas:
    "No hi ha vendes de productes en aquest rang de dates",
  historicoDeProductos: "Històric de productes",
  volverA: "Tornar a",
  general: "General",
  historialAlmacen: "Historial magatzem",
  listadoDeExistencia: "Llistat d'existència",
  listadoDeAlmacen: "Llistat de Magatzem",
  listadoHastaStockOptimo: "Llistat fins stock òptim",
  listadoExistenciaBajoMinimo: "Llistat existència sota mínim",
  exportarValoracion: "Exportar valoració",
  importeDto: "Importe Dto",
  detalleDelSubproducto: "Detall del subproducte",
  nombreNegocio: "Nom negoci",
  noHaySubproductosConElMismoNombreEnTusOtrosNegocios:
    "No hi ha subproductes amb el mateix nom en els teus altres negocis",
  detalleAlmacen: "Detall magatzem",
  entrada: "Entrada",
  inventario: "Inventari",
  salida: "Sortida",
  valorDto: "Valor Dto.",
  noHayDatosEnEsteMovimientoDeAlmacen:
    "No hi ha dades en aquest moviment de magatzem",
  historial: "Historial",
  noHayMovimientoEnEstaMateriaPrima:
    "No hi ha moviment en aquesta matèria prima",
  dia: "Dia",
  historialDeAlmacen: "Historial de magatzem",
  inventarios: "Inventaris",
  entradas: "Entrades",
  salidas: "Sortides",
  completado: "Completat",
  verificado: "Verificat",
  descargado: "Descarregat",
  diaActual: "Dia actual",
  movimientos: "Moviments",
  enEsteRangoDeFechas: "en aquest rang de dates",
  rangosHorarios: "Rangs horaris",
  nuevoRangoHorario: "Nou rang horari",
  verUnInformeDeRangosHorarios: "Veure informe de rangs horaris",
  noHayRangosHorariosEnEsteNegocio: "No hi ha rangs horaris en aquest negoci",
  nombreRangosHorarios: "Nom rangs horaris",
  vistaMosaico: "Vista mosaic",
  vistaLista: "Vista llista",
  ordenarProductos: "Ordenar productes",
  BAJA: "BAIXA",
  frontalDeVenta: "Frontal de venda",
  agregarGasto: "Afegir despesa",
  entrAlmac: "Entr. Mag.",
  contab: "Contab",
  tranferencia: "Transferència",
  verificar: "Verificar",
  entradaAlmacen: "Entrada de magatzem",
  preciosIVAInluido: "Preus IVA inclòs",
  estaEntradaNoContieneNingunSubproducto:
    "Aquesta entrada no conté cap subproducte",
  cajasOnline: "Caixes online",
  minimo: "Mínim",
  optimo: "Òptim",
  posicionGlobal: "Posició global",
  empresa: "Empresa",
  todasLasEmpresas: "Totes les empreses",
  ventasSinIVA: "Vendes sense IVA",
  neto: "Net",
  fechaDeCumpleanyos: "Data de aniversari",
  recargoEquivalencia: "Recàrrec equivalència",
  anyadirMateriaPrima: "Afegir Matèria prima",
  partesT1: "Parts T1",
  partesT2: "Parts T2",
  partesT3: "Parts T3",
  partesT4: "Parts T4",
  costeDto: "Cost Dto",
  agregarMateriasPrimas: "Afegir Matèries primeres",
  frontalDeVentas: "Frontal de vendes",
  unidadesEnOtroNegocios: "Unitats en altres negocis",
  historialMateriaPrima: "Historial matèria prima",

  borrarRangoHorario: "Esborrar rang horari",
  detallesDeLaEntradaEnAlmacen: "Detalls de l'entrada a magatzem",
  desgloseHorasTrabajadas: "Desglossament hores treballades",
  verProductosVendidos: "Veure productes venuts",
  verTicketsDelProducto: "Veure tiquets del producte",
  verTicketsDeEsasInvitaciones: "Veure tiquets d'aquestes invitacions",
  verTicketsDeEsaAgencia: "Veure tiquets d'aquesta agència",
  gastosPorMateriasPrimas: "Despeses per matèries primeres",
  alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta:
    "En donar de baixa un producte desapareix del TPV per a la venda però continua apareixent als informes de venda",
  cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta:
    "Quan un producte és de tipus descompte, el seu preu es descompta del total del compte",
  alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo:
    "En activar aquesta opció apareixen els ingredients del producte per seleccionar-los",
  alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo:
    "En activar aquesta opció pot seleccionar el preu del producte en marcar-lo",
  alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo:
    "En activar aquesta opció pot seleccionar el pes del producte en marcar-lo",
  alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo:
    "En activar aquesta opció pot seleccionar l'import del producte en marcar-lo",
  alActivarEstaOpcionElProductoNoApareceraEnNumierTPV:
    "En activar aquesta opció el producte no apareixerà al TPV Numier",
  alActivarEstaOpcionElProductoNoApareceraEnLaPda:
    "En activar aquesta opció el producte no apareixerà a la PDA Numier",
  alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada:
    "En activar aquesta opció el producte no s'imprimirà en el pendent de cobrament ni a la factura simplificada",
  guardarMateriaPrima: "Desar matèria primera",
  copiarMateriaPrima: "Copiar matèria primera",
  seleccioneQueTipoDeMateriasPrimasQuiereCopiar:
    "Seleccioneu quin tipus de matèries primeres voleu copiar",
  seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas:
    "Seleccioneu a quines categories voleu copiar les matèries primeres",
  copiaMateriaPrima: "Còpia matèria primera",
  notas: "Notes",
  pedidos: "Comandes",
  atencionLaMediaSinContarLosDiasConVentas:
    "Atenció: La mitjana sense comptar els dies amb vendes a 0€ és de: ",
  verDesgloseDeImpuestos: "Veure desglossament d'impostos",
  verDetallesDetTicket: "Veure detalls del tiquet",
  facturasNominativas: "Factures nominatives",
  verDetallesDeGasto: "Veure detalls de despesa",
  desgloseDeGastosPorEtiquetasHijas:
    "Desglossament de despeses per etiquetes filles",
  procedencia: "Procedència",
  suLicenciaDeNumierOnlineEstaAPuntoDeCaducar:
    "La seva llicència de Numier Online està a punt de caducar",
  cajasOnlineTickets: "Caixes Online Tiquets",
  cajasOnlineDetalles: "Caixes Online Detalls",
  cajasOnlinePlano: "Caixes Online Pla",
  cajasOnlineProductos: "Caixes Online Productes",
  transferir: "Transferir",
  herramientas: "Eines",
  ver: "Veure",
  detallesDeLaentradaEnAlmacen: "Detalls de l'entrada al magatzem",
  ups: "Ups",
  laFechaDeInicioNoPuedeSerPosteriorALaDeFin:
    "La data d'inici no pot ser posterior a la de finalització",
  exportarContabilidad: "Exportar comptabilitat",

  seleccioneUnProveedor: "Seleccioneu un proveïdor",
  detallesDelPedido: "Detalls de la comanda",
  correoEnviadoCorrectamente: "Correu enviat correctament",
  atencion: "Atenció",
  debeIntroducirUnEmailParaEnviarElPedido:
    "Heu d'introduir un email per enviar la comanda",
  detalles: "Detalls",
  gastoVerificadoCorrectamente: "Despesa verificada correctament",
  estasSeguroDeEliminarElPedido: "Estàs segur d'eliminar la comanda?",

  // BUSINESS CENTRAL - MATERIAS PRIMAS
  noSeEncontraronMateriasPrimas: "No s'han trobat matèries primeres",
  noSeEncontraronProductos: "No s'han trobat productes",
  seleccionar: "Seleccionar",
  estado: "Estat",
  noDisponible: "No disponible",
  downgradedProducts: "Productes desactualitzats",
  unknownProduct: "Producte desconegut",
  affectedRecipes: "Receptes afectades",
  noRecipesAffected: "No hi ha receptes afectades",
  detalle: "Detall",
  noHayBajasQueMostrar: "No hi ha baixes per mostrar",
  resumenBajas: "Resum de baixes",
  eliminado: "Eliminat",
  consultarTodo: "Consultar-ho tot",
  desplegar: "Exibir informações",
  estaOperacionNoSePuedeDeshacer: "Aquesta operació no es pot desfer",
  siEliminarPedido: "Sí, eliminar comanda",
  pedidoEliminadoCorrectamente: "Comanda eliminada correctament",
  laReferenciaEsObligatoria: "La referència és obligatòria",
  seleccioneLosNegociosParaHacerelPedido:
    "Seleccioneu els negocis per fer la comanda",
  noTienesNingunNegocioAsignado: "No tens cap negoci assignat",
  noHayProveedoresEnEsteNegocio: "No hi ha proveïdors en aquest negoci",
  cuentasRectificadas: "Factures rectificatives",
  noHayCuentasRectificadasEnEsteRangoDeFechas:
    "No hi ha comptes rectificats en aquest rang de dates",
  pedidosProveedor: "Comandes proveïdor",
  gestionDePersonal: "Gestió de personal",
  configuracionCarta: "Configuració carta",
  importacionExcels: "Importació Excels",
  carta: "Carta digital",
  camaras: "Càmeres",
  perfil: "Perfil",
  cerrarSesion: "Tancar sessió",
  desarrolladoPorNexodoDigitalSL: "Desenvolupat per Nexodo Digital S.L.",
  totalValores: "Total Valors",
  totalValoresDto: "Total Valors Dto.",
  totalValoresRecuento: "Total Valors de Comptatge",
  ultimoInventario: "Últim inventari",
  filtrarEntreInventarios: "Filtrar entre inventaris",
  ultInventario: "Ult. inventari",
  primerInventario: "Primer inventari",
  marcaDosInventariosParaVerLosDetallesEntreEllos:
    "Marqueu dos inventaris per veure els detalls entre ells",
  salir: "Sortir",
  anadirMovimientoAlmacen: "Afegir Moviment Magatzem",
  nuevoInventario: "Nou Inventari",
  tienesUnInventarioSinTerminarElDia: "Teniu un inventari sense acabar el dia",
  pulseElBotonRealizarInventarioPara:
    "Premeu el botó 'Realitzar inventari' per",
  volverARealizarlo: "tornar a realitzar-lo",
  siDeseas: "Si voleu",
  comenzarElInventarioDeNuevo: "començar l'inventari de nou",
  comaMarqueLaCasillaEliminarDatosDeInventarioActual:
    ", marqueu la casella 'Eliminar dades de l'inventari actual'",
  eliminarDatosDelInventarioActual: "Eliminar dades de l'inventari actual",
  realizarInventario: "Realitzar inventari",
  accesoDenegado: "Accés denegat",
  soloPuedeComprobar2InventariosAlMismoTiempo:
    "Només podeu comprovar 2 inventaris al mateix temps",
  cargando: "Carregant...",
  configuracionAlmacen: "Configuració magatzem",
  actualizada: "actualitzada",
  correctamente: "correctament",
  noSeAdmitenCamposEnBlanco: "No s'admeten camps en blanc",
  todas: "Totes",
  categoriaClientes: "Categoria clients",
  seleccionaCompania: "Seleccioneu companyia",
  agregarCategoriaDeClientes: "Afegir categoria de clients",
  categoriaPadre: "Categoria pare",
  elCampoNombreFiscalEsObligatorio: "El camp nom fiscal és obligatori",
  elCampoCifNifEsObligatorio: "El camp CIF/NIF és obligatori",
  datosActualizados: "Dades actualitzades correctament",
  elCampoNombreEsRequerido: "El camp nom és requerit",
  creada: "creada",
  rangoHorario: "Rang horari",
  soloPuedeCrearUnMaximoDeXRangosHorarios:
    "Només podeu crear un màxim de 12 rangs horaris",
  deAcuerdo: "D'acord",
  eliminado: "eliminat",
  deseaEliminarEsteRangoHorario: "Voleu eliminar aquest rang horari?",
  siBorrarRangoHorario: "Sí, esborrar rang horari",
  ordenarProductosAlfabeticamente: "Ordenar productes alfabèticament",
  ordenarMateriasPrimasAlfabeticamente:
    "Ordenar matèries primeres alfabèticament",
  asignarImpresorasSeleccionadasEnBlanco:
    "Assignar impressores seleccionades en blanc",
  aplicarCambios: "Aplicar canvis",
  ordenarAlfabeticamenteProductos: "Ordenar alfabèticament productes",
  ordenar: "Ordenar",
  ordenarAlfabeticamenteSubproductos: "Ordenar alfabèticament subproductes",
  seleccioneElTipo: "Seleccioneu el tipus",
  impresionDeProductosEfectuadaCorrectamente:
    "Impressió de productes efectuada correctament",
  tienesQueSeleccionarUnaCategoria: "Heu de seleccionar una categoria",
  ningunaSeleccionada: "Cap seleccionada",
  transferenciaDeProductosEfectuadaCorrectamente:
    "Transferència de productes efectuada correctament",
  relleneLosCamposObligatorios: "Ompliu els camps obligatoris",
  vistaFrontalTpv: "Vista frontal TPV",
  editarPrecios: "Editar preus",
  cancelarEdicion: "Cancel·lar edició",
  guardarOrden: "Desar ordre",
  bajaConBrackets: "[BAIXA]",
  seleccionaUnaCategoria: "Seleccioneu una categoria...",
  cambiarImpresorasAProductos: "Canviar impressores a productes",
  igualar: "Igualar",
  sumar: "Sumar",
  restar: "Restar",
  multiplicar: "Multiplicar",
  todasLasTarifas: "Totes les tarifes",
  productosEditadosCorrectamente: "Productes editats correctament",
  ordenActualizadoCorrectamente: "Ordre actualitzada correctament",
  componentesDeVenta: "Components de venda",
  delNegocioAClientes: "del negoci a clients",
  clasificacionDe: "Classificació de",
  productosPorFamilia: "productes per família",
  elementosQue: "Elements que",
  varianALosProductos: "variïn als productes",
  paraLaComanda: "per a la comanda",
  componentesComprados: "Components comprats",
  aProveedoresQueComponenProductos: "a proveïdors que componen productes",
  empresas: "Empreses",
  proveedorasDeMateriasPrimasYServicios:
    "proveïdores de matèries primeres i/o serveis",
  alNegocio: "al negoci",
  fabricantesDeMateriasPrimas: "fabricants de matèries primeres",
  aProveedores: "a proveïdors",
  categoriasQueClasifican: "Categories que classifiquen",
  materiasPrimasYProveedores: "matèries primeres i proveïdors",
  personalCon: "Personal amb",
  acceso: "accés",
  alSistema: "al sistema",
  baseDeDatosDe: "Base de dades de",
  consumidores: "consumidors",
  enElNegocio: "al negoci",
  clasificacionDeLa: "Classificació de la",
  deLasVentas: "de les vendes",
  metodosDeCobro: "Mètodes de cobrament",
  enElFrontalDeVenta: "al frontal de venda",
  intervaloDeHorasParaConsultarVentas: "Interval d'hores per consultar vendes",
  configurarAlmacén: "Configurar magatzem",
  relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen:
    "Relació de matèries primeres per a la configuració del magatzem",
  herramientasGenerales: "Eines generals",
  edicionMasiva: "Edició massiva",
  categoriasCarta: "Categories carta",
  categoriaCarta: "categoria carta",
  orden: "Ordre",
  editada: "editada",
  anadirCategoria: "Afegir categoria",
  esteNegocioNoTieneAccesoAEsteModulo:
    "Aquest negoci no té accés a aquest mòdul",
  paraMasInformacionContacteConSu: "Per a més informació contacti amb el seu",
  distribuidor: "distribuïdor",
  formasDePagoCarta: "Formes de pagament carta",
  formaDePagoCarta: "forma de pagament carta",
  informacionCarta: "Informació carta",
  datosDelNegocio: "Dades del negoci",
  nombreMostrado: "Nom mostrat",
  telefonoWhatsapp: "Telèfon WhatsApp",
  datosPedidos: "Dades comandes",
  tiempoMedioDePreparacionRecogidaMin:
    "Temps mitjà de preparació recollida (min)",
  tiempoMedioDePreparacionDomicilioMin:
    "Temps mitjà de preparació domicili (min)",
  gastosDeEnvio: "Despeses d'enviament",
  pedidoMinimo: "Comanda mínima",
  interfaz: "Interfície",
  textoEntrega: "Text lliurament",
  textoPresentacion: "Text presentació",
  textoFormasDePago: "Text formes de pagament",
  textoHorarios: "Text horaris",
  datosGuardadosCorrectamente: "Dades desades correctament",
  materiasPrimasCarta: "Matèries primeres carta",
  materiaPrimaCarta: "matèria primera carta",
  referenciaMateriasPrimasTpv: "Referència matèries primeres TPV",
  nombreDeLaMateriaPrimaEnElTpv: "Nom de la matèria primera al TPV",
  disponible: "Disponible",
  replicarMateriaPrima: "Replicar matèria primera",
  replicarMateriasPrimas: "Replicar matèries primeres",
  nombreTpv: "Nom TPV",
  noDisponible: "No disponible",
  replicarTodasLasMateriasPrimas: "Replicar totes les matèries primeres",
  estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados:
    "Esteu segur de replicar totes les matèries primeres als negocis seleccionats?",
  estaAccionNoSePuedeDeshacer: "Aquesta acció no es pot desfer!",
  siReplicar: "Sí, replicar",
  productosCarta: "Productes carta",
  productoCarta: "producte carta",
  referenciaProductoTpv: "Referència producte TPV",
  nombreDelProductoEnElTpv: "Nom del producte al TPV",
  seleccionaCategoria: "Seleccioneu categoria",
  edicionRapida: "Edició ràpida",
  supraCategoria: "SupraCategoria",
  supraCategoriaObligatoria: "Has de seleccionar una SupraCategoria per poder desar aquest producte.",
  seleccionaTipo: "Seleccioneu tipus",
  nIngredientesSinCosto: "Nº ingredients sense cost",
  maximoExtras: "Màxim extres",
  alergenos: "Al·lèrgens",
  nombreTarifa1: "Nom tarifa 1",
  precioTarifa1: "Preu tarifa 1",
  nombreTarifa2: "Nom tarifa 2",
  precioTarifa2: "Preu tarifa 2",
  nombreTarifa3: "Nom tarifa 3",
  precioTarifa3: "Preu tarifa 3",
  nombreTarifa4: "Nom tarifa 4",
  precioTarifa4: "Preu tarifa 4",
  imagen: "Imatge",
  copiarMateriasPrimas: "Copiar matèries primeres",
  basico: "Bàsic",
  buscarNombreDeLaMateriaPrima: "Buscar nom de la matèria primera",
  seleccionaTipoPunto: "Seleccioneu tipus...",
  bases: "Bases",
  opcionales: "Opcions",
  extras: "Extres",
  cereales: "Cereals",
  crustaceos: "Crustacis",
  huevos: "Ous",
  pescado: "Peix",
  cacahuetes: "Cacauets",
  soja: "Soia",
  leche: "Llet",
  frutosDeCascara: "Fruits de closca",
  apio: "Api",
  mostaza: "Mostassa",
  granosDeSesamo: "Llavor de sèsam",
  dioxidoDeAzufre: "Diòxid de sofre",
  altramuces: "Altramuces",
  moluscos: "Mol·luscos",
  cartaASecas: "Carta",
  extra: "Extra",
  opcional: "Opcional",

  estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos:
    "Aquest procés esborrarà les matèries primeres actuals a les categories seleccionades dels tipus escollits",
  aceptarProceso: "Acceptar procés",
  necesitasMarcarAlMenosUnTipoYUnaCategoria:
    "Necessites marcar almenys un tipus i una categoria",
  materiaPrimaCopiadaCorrectamente: "Matèria primera copiada correctament",
  editado: "editat",
  agregada: "afegida",
  relacion: "Relació",
  noPuedeHaberDosMateriasPrimasConElMismoTipo:
    "No poden haver-hi dues matèries primeres amb el mateix tipus",
  estasSeguroDeBorrarLaMateriaPrima:
    "Esteu segur de borrar la matèria primera?",
  siDeseoBorrarlo: "Sí, desitjo borrar-la",
  seleccionaUnaCarta: "Seleccioneu una carta",
  replicarProductos: "Replicar productes",
  verCarta: "Veure carta",
  verPedido: "Veure comanda",
  verQR: "Veure QR",
  nombreEnTpv: "Nom al TPV",
  cartaYPedido: "Carta i Comanda",
  replicarTodosLosProductos: "Replicar tots els productes",
  editarImagen: "Editar imatge",
  esteNegocioNoContieneNingunaCarta: "Aquest negoci no conté cap carta",
  estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados:
    "Esteu segur de replicar tots els productes als negocis seleccionats?",
  sustanciasQue: "Substàncies que",
  componenALosProductos: "componen els productes",
  informacionAcercaDel: "Informació sobre",
  negocioMinuscula: "negoci",
  actualizarPedidos: "Actualitzar comandes",
  pendienteDeConfirmacion: "Pendent de confirmació",
  confirmados: "Confirmats",
  enPreparacion: "En preparació",
  finalizados: "Finalitzats",
  recogida: "Recollida",
  domicilio: "Domicili",
  noHayPedidosPendientesDeConfirmacion:
    "No hi ha comandes pendents de confirmació",
  noHayPedidosConfirmados: "No hi ha comandes confirmades",
  noHayPedidosEnPreparacion: "No hi ha comandes en preparació",
  noHayPedidosTerminados: "No hi ha comandes finalitzades",
  siBorrarPedido: "Sí, borrar comanda",
  estasSeguroDeSuspenderElServicioEnMesas:
    "Esteu segur de suspendre el servei a taules?",
  siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo:
    "Si suspendiu el servei a taules, no entraran més comandes fins que s'activi de nou",
  siSuspenderElServicioEnMesa: "Sí, suspendre el servei a taula",
  estasSeguroDeActivarElServicioEnMesas:
    "Esteu segur d'activar el servei a taules?",
  siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa:
    "Si activeu el servei a taules, tornaran a entrar comandes a taula",
  siActivarElServicioEnMesa: "Sí, activar el servei a taula",
  estasSeguroDeSuspenderElServicio: "Esteu segur de suspendre el servei?",
  siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo:
    "Si suspendiu el servei, no entraran més comandes fins que s'activi de nou",
  siSuspenderElServicio: "Sí, suspendre el servei",
  estasSeguroDeActivarElServicio: "Esteu segur d'activar el servei?",
  siActivaElServicioVolveranAEntrarPedidos:
    "Si activeu el servei, tornaran a entrar comandes",
  siActivarElServicio: "Sí, activar el servei",
  pedidoAceptadoCorrectamente: "Comanda acceptada correctament",
  pedidoEnPreparacion: "Comanda en preparació",
  pedidoFinalizado: "Comanda finalitzada",
  pedidoArchivado: "Comanda arxivada",
  servicioActualizadoCorrectamente: "Servei actualitzat correctament",
  estasSeguroDeEditarLaObservacion: "Esteu segur d'editar l'observació?",
  siEditarObservacion: "Sí, editar observació",
  mesasActivadas: "TAULES⠀ACTIVADES⠀",
  mesasDesactivadas: "TAULES⠀DESACTIVADES⠀",
  crearNuevoProveedor: "Crear nou proveïdor",
  crearMateriaPrima: "Crear matèria primera",
  eliminarMateriaPrima: "Eliminar matèria primera",
  sinCasaAsignada: "Sense casa assignada",
  buscarPorRefONombreDeLaMateriaPrima:
    "Buscar per Ref. o Nom de la matèria primera",
  mensajePorcentajeCompraDisminuido:
    "El preu ha disminuït respecte al percentatge de compra establert",

  seleccioneEtiqueta: "Seleccioneu etiqueta...",
  unidadesStockMinimo: "Unitats stock mínim",
  partesStockMinimo: "Parts stock mínim",
  anadirProveedor: "Afegir proveïdor",
  amarillo: "groc",
  cajas: "Caixes",
  botellas: "Ampolles",
  barriles: "Barrils",
  palets: "Palets",
  bolsas: "Bosses",
  litros: "Litres",
  rollos: "Rotllos",
  visualizar: "Visualitzar",
  sinCasa: "Sense casa",
  elProveedorEsObligatorio: "El proveïdor és obligatori",
  laFechaEsObligatoria: "La data és obligatòria",
  hayUnaMateriaPrimaSinUnidades: "Hi ha una matèria primera sense unitats",
  hayUnaMateriaPrimaSinPrecio: "Hi ha una matèria primera sense preu",
  guardandoGasto: "Guardant despesa...",
  actualizado: "actualitzat",
  creado: "creat",
  laLongitudDelNombreNoPuedeSerMayorDe:
    "La longitud del nom no pot ser superior a ",
  relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar:
    "Ompliu totes les dades marcades amb * abans d'enviar",
  seleccionaProveedor: "Seleccioneu proveïdor...",
  filtrarPorFecha: "Filtrar per data",
  convertirAlbaranes: "Convertir albarans",
  cancelarConversion: "Cancel·lar conversió",
  convertir: "Convertir",
  convertirAlbaranEnFactura: "Convertir albarà en factura",
  refFactura: "Ref factura",
  albaranesDeLaFactura: "Albarans de la factura",
  finalizada: "finalitzada",
  conversion: "Conversió",
  error: "Error",
  estaSeguroDeVerificarEsteGasto: "Esteu segur de verificar aquesta despesa?",
  siVerficarGasto: "Sí, verificar despesa",
  estasSeguroDeEliminarElGasto: "Esteu segur d'eliminar la despesa?",
  siEliminarGasto: "Sí, eliminar despesa",
  contabilizadoCambiadoCorrectamente: "Comptabilitzat canviat correctament",
  gastoEliminadoCorrectamente: "Despesa eliminada correctament",
  hacerInventario: "Fer inventari",
  seleccionarTodas: "Seleccionar totes",
  inventarioRealizadoCorrectamente: "Inventari realitzat correctament",
  traspaso: "Traspassament",
  negocioDeDestino: "Negoci de destinació",
  referenciaNecesaria: "Referència necessària",
  elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos:
    "El moviment de magatzem ha de tenir assignat un producte o productes",
  realizado: "realitzat",
  enviarInventario: "Enviar inventari",
  volverAlAlmacen: "Tornar al magatzem",
  inventarioCompletado: "Inventari completat",
  inventarioNoEncontrado: "Inventari no trobat",
  cargandoInventario: "Carregant inventari",
  inventarioExcluidosTitulo: "Hi ha matèries primeres que no es comptabilitzen en aquest inventari",
  inventarioExcluidosTexto: "El seu codi està repetit, així que no es pot saber a quina matèria primera correspon la quantitat. No apareixeran per comptar fins que es corregeixi el codi.",
  inventarioExcluidoCodigoCompartido: "El codi {codigo} el comparteixen {total} matèries primeres actives.",
  inventarioExcluidoLineaDuplicada: "El codi {codigo} apareix {total} vegades en aquest inventari.",
  importacion: "Importació",
  importar: "Importar",
  tienesQueSeleccionarUnArchivoDeImportacion:
    "Heu de seleccionar un arxiu d'importació",
  importandoVentasDelNegocio: "Important vendes del negoci...",
  nuevosProductos: "Nous Productes",
  seHanCreadoLosSiguientesProductos: "S'han creat els següents productes",
  importandoMovimientosDeAlmacen: "Important moviments de magatzem...",

  seleccionaCasa: "Seleccioneu casa...",
  desgloseDeVentasPorProductos: "Desglossament de vendes per productes",
  noTienesPermisoParaVisualizarEsteInforme:
    "No tens permís per visualitzar aquest informe",
  historicoVentasPorCliente: "Històric de vendes per client",
  buscarPorNombreDelCliente: "Buscar per nom del client",
  importeSinDto: "Import sense Dto.",
  seleccioneUnClienteValido: "Seleccioneu un client vàlid",
  seleccioneUnNegocioParaVerLosTickets:
    "Seleccioneu un negoci per veure els tickets",
  ventasDeCategoriasPorClientes: "Vendes de categories per clients",
  desgloseDeVentasDeLaCategoria: "Desglossament de vendes de la categoria",
  verImporteEnCategoriasHijas: "Veure import en categories filles",
  gestionDePedidos: "Gestió de comandes",
  cargandoGastos: "Carregant despeses...",
  cargandoDatos: "Carregant Dades",
  tiempoMedioCocina: "Temps mitjà cuina",
  nComandas: "Nº Comandes",
  eliminada: "eliminada",
  tiempoMedio: "Temps mitjà",
  noHayComandasEnviadasAlKdsEnEsteRangoDeFechas:
    "No hi ha comandes enviades al KDS en aquest rang de dates",
  tiempoMedioProducto: "Temps mitjà producte",
  nProductos: "Nº Productes",
  informePersonalizado: "Informe personalitzat",
  nombreDelDispositivo: "Nom del dispositiu",
  dispositivo: "Dispositiu",
  registrosHorarios: "Registres horaris",
  marshallEjecutadoCorrectamente: "Marshall executat correctament",
  mes: "Mes",
  seleccionaUnaSemana: "Seleccioneu una setmana",
  seleccioneUnaFechaValida: "Seleccioneu una data vàlida",
  noMayuscula: "NO",
  siMayuscula: "SÍ",
  editarObservacion: "Editar observació",
  anadirObservacion: "Afegir observació",
  editarHoraInicioYHoraFin: "Editar hora inici i hora fi",
  verLocalizacionEnMapa: "Veure localització al mapa",
  noSeHaEncontradoLocalizacion: "No s'ha trobat localització",
  inicioJornada: "Jornada iniciada",
  finJornada: "Jornada finalitzada",
  geolocalizacionJornada: "Geolocalització de la jornada",
  editarHorario: "Editar horari",
  editarHorarioDeTurno: "Editar horari de torn",
  observacion: "Observació",
  turnosOperarios: "Torns operaris",
  compartirEnlaceTurnos: "Compartir enllaç de torns",
  hazClicConsultar: "Feu clic al botó Consultar per realitzar la cerca.",
  calculo: "Càlcul",
  alMinuto: "Per minut",
  redondear: "Arrodonir",
  alSegundo: "Per segon",
  horaCompleta: "Hora completa",
  haciaArriba30m: "Cap amunt (30m)",
  haciaArriba45m: "Cap amunt (45m)",
  verInfoCalculos: "Veure informació de càlculs",
  infoCalculoTurnosTitulo: "Informació sobre el Càlcul de Torns",
  infoCalculoIntroP1: "El sistema permet calcular el temps i el sou de tres formes. Quan s'aplica un arrodoniment,",
  infoCalculoIntroDestacado: "el temps real treballat apareixerà sempre entre parèntesis i en color gris",
  infoCalculoAlMinutoTitulo: "1. Per minut",
  infoCalculoAlMinutoDesc: "Descarta els segons. Si un operari treballa 1h 30m 45s, es comptabilitza com",
  infoCalculoAlMinutoSueldo: "El sou es calcula exactament sobre aquells minuts.",
  infoCalculoRedondearTitulo: "2. Arrodonir",
  infoCalculoRedondearDesc: "Ajusta el temps segons la regla seleccionada:",
  infoCalculoHoraCompletaDesc: "No compta els minuts. Si treballa 1h 55m, es paga",
  infoCalculoHaciaArribaDesc: "Si els minuts superen el llindar, arrodoneix a l'hora següent.",
  infoCalculoRedondearNota: "* El sou es calcularà sobre aquest temps ja arrodonit.",
  infoCalculoAlSegundoTitulo: "3. Per segon",
  infoCalculoAlSegundoDesc1: "Màxima precisió. Comptabilitza el temps exacte (ex.",
  infoCalculoAlSegundoDesc2: ") i el sou inclou fins a l'últim cèntim generat per aquells segons.",
  enlaceGeneradoExito: "Enllaç generat correctament",
  enlaceCopiadoAlPortapapeles: "Enllaç copiat al porta-retalls",
  enlaceExternoTurnosTitle: "Enllaç extern per consulta de torns",
  enlaceExternoTurnosLabel:
    "A través d'aquest enllaç podràs consultar els torns dels operaris. Caducarà en 24 hores.",
  errorComunicacionBackend: "Error de comunicació amb el servidor.",
  errorNoSeHaPodidoGenerarElEnlace:
    "Ho sentim, no s'ha pogut generar l'enllaç. Torneu-ho a provar",
  enlaceExternoTurnosOperariosTitle: "Torns dels operaris de ",
  enlaceExternoTurnosCaducadoTitle: "L'enllaç ha caducat",
  enlaceExternoTurnosCaducadoLabel:
    "Per consultar els torns dels operaris, contacteu amb l'administrador del negoci perquè generi un nou enllaç.",
  ventasDeProductosMinusculas: "vendes de productes",
  pedidosGuionPasarelaDePago: "Comandes - Passarel·la de Pagament",
  numPedidos: "Num.Comandes",
  costoPorPedido: "Cost per comanda",
  totalComisiones: "Total Comissions",
  totalSinComisiones: "Total sense comissions",
  errorEnLaPeticion: "Error en la petició",
  rentabilidad: "Rendibilitat",
  buscarPorNombreDelRepartidor: "Buscar per nom del repartidor",
  verDesgloseDeTarifas: "Veure desglossament de tarifes",
  ventasPorMeses: "Vendes per mesos",
  ventasHoras: "Vendes hores",
  ventasPorHorasYMesas: "Vendes per hores i taules",
  tarifasDelProducto: "Tarifes del producte",
  cantidad: "Quantitat",
  fechaDesde: "Data des de",
  fechaHasta: "Data fins",
  seleccionaProcedencia: "Seleccioneu procedència...",
  verDesgloseFacturas: "Veure desglossament factures",
  verDesgloseMateriasPrimas: "Veure desglossament matèries primeres",
  seleccionaUnaEtiqueta: "Seleccioneu una etiqueta",
  buscarPorNombreDeLaMateriaPrima: "Buscar per nom de la matèria primera",
  ventasDeMateriasPrimas: "Vendes de matèries primeres",
  seleccionaTpv: "Seleccioneu TPV...",
  deVentas: "de vendes",
  totalComision: "Total comissió",
  totalSinComision: "Total sense comissió",
  desgloseFacturas: "Desglossament factures",
  facturasDelProveedor: "Factures del proveïdor",
  retiradas: "Retirades",
  buscarTicket: "Buscar ticket...",
  baseMayusculas: "BASE",
  numServ: "Num. Serv.",
  ticketMed: "Ticket Med.",
  necesitasElegirUnTpvParaPoderVerLosDetallesDeEste:
    "Necessites triar un TPV per poder veure els detalls d'aquest",
  ventasMinusculas: "vendes",
  totales: "Totals",
  noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha:
    "No tens cap rang de dates creat. Vols crear un rang de dates?",
  siCrearUnRangoHorario: "Sí, crear un rang horari",
  detalleDe: "Detall de ",
  cierresDeCaja: "tancaments de caixa",
  ventasNegocioPorZonaHoraria: "Vendes negoci per zona horària",
  porZonaHoraria: " per zona horària",
  detalleDeVentasSegun: "Detall de vendes segons",
  comensalesMinuscula: " comensals",
  desgloseDe: "Desglossament de ",
  ticketsCobrados: "tickets cobrats",
  segunTipoDeIVA: "segons tipus d'IVA",
  facturasEmitidas: "Factures emeses",
  aClientes: " a clients",
  desgloseDeVentasSegun: "Desglossament de vendes segons ",
  formasDePagoMinusculas: "formes de pagament",
  agenciasMinusculas: "agències",
  cuentasACredito: "comptes a crèdit",
  sumatorioDe: "Sumatori de ",
  impuestos: "impostos",
  porFechas: " per dates",
  cuentasAnuladasMinusculas: "comptes anul·lats",
  delNegocio: " del negoci",
  cuentasRectificadas: "Factures rectificatives",
  cuentasRectificadasMinusculas: "factures rectificatives",
  retiradasMinusculas: "retirades",
  ventaDeProductosPorNegocio: "Vendes de productes per negoci",
  rankingDe: "Rànquing de",
  costeDeProductos: "Cost de productes",
  margenDeCostes: "Marge de costos",
  segunVentasPorRangoDeFecha: "segons vendes per rang de dates",
  historicoDeProducto: "Històric de producte",
  rankingAgrupadoDe: "Rànquing agrupat de",
  enTodosLosNegocios: "en tots els negocis",
  ventasDeCategoriasPorNegocio: "Vendes de categories per negoci",
  agrupacionDe: "Agrupació de",
  ventasDeCategoriasMinusculas: "vendes de categories minúscules",
  deProductos: "de productes",
  invitacionesMinusculas: "invitacions",
  ventasPorMateriasPrimas: "Vendes per matèries primeres",
  ventasDeMateriasPrimasMinusculas: "vendes de matèries primeres",
  comprasDeMateriasPrimas: "compres de matèries primeres",
  porRangoDeFecha: "per rang de dates",
  comprasAProveedores: "compres a proveïdors",
  comprasAUnProveedor: "compres a un proveïdor",
  porRangoDeFechaEn: "per rang de dates en",
  todosLosNegocios: "tots els negocis",
  comprasAgrupadasPorEtiquetas: "compres agrupades per etiquetes",
  comprasAFabricantes: "compres a fabricants",
  comprasAUnFabricante: "compres a un fabricant",
  ranking: "Rànquing",
  detallesDe: "Detalls de",
  turnos: "torns",
  ventasPorClientesPlural: "Vendes per client",
  deVentasPorClientes: "de vendes per client",
  consultaDeVentasPorCliente: "Consulta de vendes per client",
  historico: "Històric",
  deVentasPorCliente: "de vendes per client",
  numierPedidos: "Numier Comandes",
  informeDePasarelaDePago: "Informe de Passarel·la de Pagament",
  desgloseDiarioDeLosPagosATraves:
    "Desglossament diari dels pagaments a través",
  pasarelaDePagoStripe: "Passarel·la de pagament Stripe",
  clicParaMasInformacion: "Clic per més informació",
  cantidadMinusculas: "quantitat",
  totalMinusculas: "total",
  tarjetaYCheques: "Targeta i xecs",
  seleccionaOperario: "Seleccioneu operari...",
  necesitasSeleccionarUnProveedorParaPoderHacerUnPedido:
    "Necessites seleccionar un proveïdor per poder fer una comanda",
  estePedidoNoEsValido: "Aquesta comanda no és vàlida",
  quieresRestablecerElPedido: "Vols restablir la comanda?",
  siRestablecerPedido: "Sí, restablir comanda",
  datosPersonales: "Dades Personals",
  datosDeAcceso: "Dades d'Accés",
  contrasenaAntigua: "Contrasenya Antiga",
  contrasenaNueva: "Contrasenya Nova",
  confirmarContrasena: "Confirmar Contrasenya",
  quieresDarDeAltaUnUsuario: "Vols donar d'alta un usuari?",
  quieresDarDeBajaUnUsuario: "Vols donar de baixa un usuari?",
  licencias: "Llicències",
  fechaCaducidad: "Data caducitat",
  ilimitado: "IL·LIMITAT",
  lasContrasenasNoCoinciden: "Les contrasenyes no coincideixen",
  seleccionaUsuario: "Seleccioneu usuari...",
  usuario: "Usuari",
  negocios: "Negocis",
  balance: "Balance",

  teHaParecidoUtilEsteArticulo: "T'ha semblat útil aquest article?",
  graciasPorTuOpinion: "Gràcies per la teva opinió",
  asignarTurno: "Assignar torn",
  vacaciones: "Vacances",
  descargarPDF: "Descarregar PDF",
  enviarHorario: "Enviar horari",
  incidenciasEnElMes: "incidències en el mes",
  diasDeVacacionesEnElMes: "dies de vacances en el mes",
  diasDeVacacionesEnElAno: "dies de vacances a l'any",
  nuevoTurno: "Nou torn",
  clonarTurno: "Clonar torn",
  nombreDelTurno: "Nom del torn",
  diasDeLaSemana: "Dies de la setmana",
  editarTurno: "Editar torn",
  borrarTurno: "Esborrar torn",
  evento: "Esdeveniment",
  nombreEvento: "Nom esdeveniment",
  hayUnaIncidenciaEnEsteTurno: "Hi ha una incidència en aquest torn",
  fechaInicioTurno: "Data inici torn",
  fechaFinTurno: "Data fi torn",
  numHorasTurno: "Nº hores torn",
  fechaInicioTrabajada: "Data inici treballada",
  fechaFinTrabajada: "Data fi treballada",
  numHorasTrabajadas: "Nº hores treballades",
  noIniciado: "No iniciat",
  noFinalizado: "No finalitzat",
  fechaInicioVacaciones: "Data inici vacances",
  fechaFinVacaciones: "Data fi vacances",
  turnoHorario: "Torn horari",
  nombreTurno: "Nom torn",
  campoRequerido: "Camp requerit",
  introduzcaLosDiasDeLaSemana: "Introduïu els dies de la setmana",
  crearTurnoHorarioDeOperario: "Crear torn horari d'operari",
  introduzcaLosOperarios: "Introduïu els operaris",
  laboral: "Laboral",
  vacacional: "Vacacional",
  seleccionaTurno: "Seleccioneu torn...",
  seleccionaLosNegociosALosQueQuiereClonarElTurno:
    "Seleccioneu els negocis als quals voleu clonar el torn",
  seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios:
    "Seleccioneu la data en què voleu copiar els horaris",
  seleccioneUnaSemana: "Seleccioneu una setmana",
  lunes: "Dilluns",
  martes: "Dimarts",
  miercoles: "Dimecres",
  jueves: "Dijous",
  viernes: "Divendres",
  sabado: "Dissabte",
  domingo: "Diumenge",
  laFechaSeleccionadaNoEsValida: "La data seleccionada no és vàlida",
  turnoClonadoCorrectamente: "Torn clonat correctament",
  correoEnviadoCorrectamente: "Correu enviat correctament",
  estasSeguroDeBorrarElTurnoSeleccionado:
    "Esteu segur de voler esborrar el torn seleccionat?",
  siBorrarTurno: "Sí, esborrar torn",
  necesitasCrearAlgunTurnoParaPoderCrearCuadrantes:
    "Necessites crear algun torn per poder crear quadrants",
  estasSeguroDeEditarElTurno: "Esteu segur de voler editar el torn?",
  siEditarTurno: "Sí, editar torn",
  hoy: "Avui",
  turno: "Torn",
  turnoBorradoCorrectamente: "Torn esborrat correctament",
  informacion: "Informació",
  elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido:
    "El dia no correspon amb la configuració del torn escollit",
  turnoCopiadoCorrectamente: "Torn copiat correctament",
  turnoDeOperarioAgregadoCorrectamente: "Torn d'operari afegit correctament",
  turnoDeOperarioEliminadoCorrectamente: "Torn d'operari eliminat correctament",
  turnoDeOperarioEditadoCorrectamente: "Torn d'operari editat correctament",
  tecnicoConsultasTecnicasIncidencias:
    "Tècnic (Consultes tècniques, Incidències...)",
  comercialActivacionDeProductosInformacionServicios:
    "Comercial (Activació de productes, Informació, Serveis...)",
  administracionFacturacionReclamaciones:
    "Administració (Facturació, Reclamacions...)",
  elAsuntoEsObligatorio: "L'assumpte és obligatori",
  elMensajeEsObligatorio: "El missatge és obligatori",
  soporteOnlineEnviadoCorrectamente: "SuportOnline enviat correctament",
  todosLosNegociosMayusculas: "Tots els negocis",
  recordarMisDatos: "Recordar les meves dades",
  paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros:
    "Per a qualsevol incidència o més informació, podeu posar-vos en contacte amb nosaltres",
  iniciarSesion: "Iniciar sessió",
  haOlvidadoSuContrasena: "Heu oblidat la contrasenya?",
  haHabidoUnErrorAlConectarPruebeDeNuevo:
    "Hi ha hagut un error en connectar. Torneu-ho a provar",
  elEmailNoPuedeEstarEnBlanco: "L'email no pot estar en blanc",
  elEmailNoEsValido: "L'email no és vàlid",
  laContrasenaNoPuedeEstarEnBlanco: "La contrasenya no pot estar en blanc",
  estaPaginaNoSeEncuentraEnElSistema: "Aquesta pàgina no es troba al sistema",
  volverAlInicio: "Tornar a inici",
  obtenerContrasena: "Obtenir contrasenya",
  disculpeLasMolestiasEstamosDeMantenimiento:
    "Disculpeu les molèsties, estem en manteniment",
  funcionEnMantenimiento: "Funció en manteniment",
  getDataCompanyMantenimiento: "Aquesta funció es troba temporalment en manteniment. Disculpeu les molèsties.",
  vuelvaAIntentarloMasTarde: "Torneu-ho a intentar més tard",
  acepto: "Accepto",
  categoriasDeClientes: "Categories de clients",
  categoriaDeCliente: "Categoria de client",
  nombreCategoria: "Nom categoria",
  noSeleccionada: "No seleccionada",
  cobradoMayusculas: "COBRAT",
  envioProgramadoPara: "Enviament programat per a",
  eliminarPedido: "Esborrar comanda",
  aceptarPedido: "Acceptar comanda",
  pedidoConfirmado: "Comanda confirmada",
  archivarPedido: "Arxivar comanda",
  detallesPedido: "Detalls comanda",
  nota: "Nota",
  precioUd: "Preu Ud",
  gratis: "GRATIS",
  guardarYAceptarPedido: "Guardar i acceptar comanda",
  seleccionaGrupo: "Seleccioneu grup...",
  todosMayusculas: "TOTS",
  nombreOperario: "Nom operari",
  apellidos: "Cognoms",
  claveAcceso: "Clau accés",
  codigoDeTurnos: "Codi de torns",
  claveAccesoPDA: "Clau accés PDA",
  seleccionaIVA: "Seleccioneu IVA",
  calcularCostoAPartirDeMateriasPrimas:
    "Calcular cost a partir de matèries primeres",
  seleccionaImpresoraDeComandasTPV: "Seleccioneu impressora de comandes TPV",
  seleccionaImpresoraDeComandasPDA: "Seleccioneu impressora de comandes PDA",
  buscarMateriaPrima: "Buscar matèria primera",
  buscarProducto: "Buscar producte",
  nuevaMateriaPrima: "Nova matèria primera",
  ordenarSubproductos: "Ordenar subproductes",
  seleccionaEtiqueta: "Seleccioneu etiqueta...",
  clonarProducto: "Clonar producte",
  clonarProductoCarta: "Clonar producte",
  buscarSinPuntos: "Buscar",
  sinProveedores: "Sense proveïdors",
  agregadas: "afegides",
  modificadas: "modificades",
  materiaPrimaEliminadaCorrectamente: "Matèria primera eliminada correctament",
  asociacion: "associació",
  materiaPrimaOrdenadaCorrectamente: "Matèria primera ordenada correctament",
  productosCopiadosCorrectamente: "Productes copiats correctament",
  menuCopiadoCorrectamente: "Menú copiat correctament",
  responder: "Respondre",
  administracion: "Administració",
  soporteTecnico: "Suport tècnic",
  horaInicioMayusculas: "Hora Inici",
  horaFinal: "Hora Final",
  personaDeContacto: "Persona de contacte",
  motivoVisita: "Motiu visita",
  servicioBajoMantenimiento: "Servei en manteniment",
  desplazamiento: "Desplaçament",
  ticketEnviadoCorrectamente: "Ticket enviat correctament",
  precioCompraConDescuento: "Preu compra amb descompte",
  introduzcaLasPartesDelStockMinimo: "Introduïu les parts de l'estoc mínim",
  actualizarStockMinimoYOptimo: "Actualitzar estoc mínim i òptim",
  subproductoDeVerdad: "Subproducte",
  entregado: "Entregat",
  retirada: "Retirada",
  subtotal: "Subtotal",
  pagosACuenta: "Pagaments a compte",
  horaDeApertura: "Hora d'obertura",
  horaInicio: "Hora inici",

  condicionesDeNumierOnline: "Condicions de Numier Online",
  descripcionDelServicio: "Descripció del servei",
  terminosIntroduccionParte1:
    "El servei al núvol de Numier ofert per NEXODO DIGITAL S.L. (a partir d'ara NEXODO), facilita als seus clients l'accés en línia a la informació actualitzada dels seus negocis.",
  terminosIntroduccionParte2:
    "Per això, les aplicacions de punt de venda de Numier enviaran a través d'internet detalls de les vendes realitzades i altres tipus d'informació que pugui ser interessant per als seus clients.",
  terminosIntroduccionParte3:
    "L'accés a aquest servei es realitzarà a través de la pàgina web https://www.numier.com/clientes, on podrà consultar la informació enviada pels seus punts de venda.",
  terminosIntroduccionParte4:
    "NEXODO es reserva el dret de millorar, modificar o anul·lar el servei en qualsevol moment.",
  politicaDePrivacidad: "Política de privacitat",
  privacidadParte1:
    "1. NEXODO ha realitzat la següent declaració de privacitat amb l'objectiu de manifestar el seu ferm propòsit de protegir la seva privacitat. NEXODO li demana que llegeixi atentament aquesta política de privacitat abans d'utilitzar aquest servei ja que això implica que NEXODO recopili i processi les seves dades personals d'acord amb aquesta política. NEXODO es reserva el dret a modificar en qualsevol moment la política de privacitat. En aquest cas, NEXODO es compromet a posar-se en contacte amb vostè per informar-lo de les modificacions que l'afectin.",
  privacidadParte2:
    "2. NEXODO respecta les seves opcions de privacitat. En el cas que ens proporcioni alguna informació es tractarà d'acord amb aquesta política.",
  privacidadParte3:
    "3. NEXODO li recomana discreció a l'hora de proporcionar informació a operadors o propietaris del lloc. És important que tingui en compte que proporcionar informació personal en llocs d'accés públic, com sales de xat, implica que qualsevol persona amb accés a internet pugui disposar de la seva informació. Li recomanem que no introdueixi cap informació que no vulgui que altres puguin veure en aquestes zones públiques.",
  privacidadParte4:
    "4. Si decideix registrar-se a NUMIER ONLINE és possible que hagi d'aportar dades personals. És important que registri correctament la informació en la data de registre. Si la seva informació personal canvia després d'haver efectuat el registre haurà de canviar-la o actualitzar-la immediatament. De no fer-ho, és possible que no rebi algun servei o informació de NEXODO.",
  privacidadParte5:
    "5. NEXODO pot utilitzar la seva informació personal amb la finalitat de realitzar millores en aquest lloc.",
  privacidadParte6:
    "6. NEXODO recopila aquestes dades amb la finalitat d'obtenir informació per millorar els seus serveis i els seus productes. I és possible que utilitzem la informació que ens ha proporcionat per enviar-li ofertes per correu electrònic o postal que puguin ser del seu interès.",
  privacidadParte7:
    "7. Per anul·lar la seva subscripció a aquests correus haurà de posar-se en contacte amb NEXODO per informar de la seva decisió. Altrament, NEXODO mantindrà la informació de l'usuari fins al moment en què la subscripció sigui anul·lada o fins al venciment de qualsevol període necessari descrit en la normativa vigent.",
  privacidadParte8:
    "8. NEXODO no revelarà les seves dades a cap tercer sense el seu consentiment, tret que considerem de bona fe que la llei ho requereix.",
  privacidadParte9:
    "9. Té la possibilitat d'anul·lar la totalitat de les dades de la seva subscripció que figurin a la nostra base de dades. Per això haurà de posar-se en contacte amb l'empresa i realitzar la seva sol·licitud.",
  privacidadParte10:
    "10. NEXODO ha pres mesures per garantir que la informació només estarà disponible per a l'usuari que va introduir la informació inicialment.",
  privacidadParte11:
    "11. Només es pot accedir a la informació un cop s'hagi introduït la contrasenya.",
  privacidadParte12:
    "12. Aquest lloc pot contenir enllaços a altres llocs que no estan associats amb NEXODO. Aquests llocs tenen les seves pròpies polítiques de privacitat de les quals NEXODO no se'n fa responsable. L'accés a aquests llocs vinculats es realitza sota la seva exclusiva responsabilitat.",
  privacidadParte13:
    "13. NEXODO garanteix la seguretat de la informació referent als seus usuaris excepte en els casos que es descriuen a continuació:",
  privacidadParte13dos: "- Si NEXODO disposa del seu consentiment.",
  privacidadParte13tres:
    "- Si se sol·licita a NEXODO proporcionar aquesta informació per indicació legal, requeriment judicial o altre procediment jurídic.",
  privacidadParte13cuatro:
    "- Si la revelació d'aquests dades és necessària per protegir els drets i la propietat de NEXODO.",
  privacidadParte13cinco:
    "- Si la revelació d'informació de les seves dades és necessària per millorar els serveis i productes dels nostres clients, inclòs vostè.",
  privacidadParte14:
    "14. NEXODO garanteix el manteniment adequat de la seva informació en un servidor segur i encriptat al qual només puguin accedir tercers autoritzats.",

  cartaDigital: "Carta digital",
  horarios: "Horaris",
  zonas: "Zones",
  modificarHorariosDeLaCarta: "Modificar horaris de la carta",
  modificarZonasDeLaCarta: "Modificar zones de la carta",
  diaDeLaSemana: "Dia de la setmana",
  esteNegocioNoTieneCarta: "Aquest negoci no té carta",
  tipoDeEnvio: "Tipus d'enviament",
  nuevoHorario: "Nou horari",
  elCampoDiaDeLaSemanaEsRequerido: "El camp dia de la setmana és requerit",
  borrarHorario: "Esborrar horari",
  laHoraInicioNoPuedeSerMayorQueLaHoraFin:
    "L'hora d'inici no pot ser major que l'hora de fi",
  noHayHorariosEnEsteNegocio: "No hi ha horaris en aquest negoci",
  deseaEliminarEsteHorario: "Voleu eliminar aquest horari?",
  siBorrarHorario: "Sí, esborrar horari",
  seleccioneDiaDeLaSemana: "Seleccioneu dia de la setmana",
  seleccioneTipoDeEnvio: "Seleccioneu tipus d'enviament",

  importacionSage: "Importació Sage",
  importacionContable: "Importació comptable",
  enlaceContable: "Enllaç comptable",
  ejercicio: "Exercici",
  codigoEmpresa: "Codi empresa",
  asiento: "Assentament",
  cargoAbono: "Càrrec/Abonament",
  codigoCuenta: "Codi compte",
  fechaAsiento: "Data assentament",
  comentario: "Comentari",
  importeAsiento: "Import assentament",
  numeroPeriodo: "Número període",
  delegacion: "Delegació",
  canal: "Canal",
  ejercicioFactura: "Exercici factura",
  serie: "Sèrie",
  factura: "Factura",
  suFacturaNo: "La seva factura núm.",
  fechaFactura: "Data factura",
  importeFactura: "Import factura",
  tipoFactura: "Tipus factura",
  codigoCuentaFactura: "Codi compte factura",
  codigoRetencion: "Codi retenció",
  baseRetencion: "Base retenció",
  porRetencion: "Per retenció",
  importeRetención: "Import retenció",
  baselva1: "Base IVA 1",
  porlva1: "Percentatge IVA 1",
  cuotaIva1: "Quota IVA 1",
  porRecargoEquivalencia1: "Percentatge recàrrec equivalència 1",
  recargoEquivalencia1: "Recàrrec equivalència 1",
  codigoTransaccion1: "Codi transacció 1",
  descargarComoTxt: "Descarregar com a .txt",

  noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha:
    "No hi ha assentaments comptables en aquest TPV amb aquest rang de dates",
  cargandoAsientosContables: "Carregant assentaments comptables",
  fechaDeAperturaDeCaja: "Data d'obertura de caixa",
  fechaDeCierreDeCaja: "Data de tancament de caixa",
  descargarVentas: "Descarregar vendes",
  descargarGastos: "Descarregar despeses",
  noHasCerradoEstaCaja: "No has tancat aquesta caixa",
  numeroDeCierres: "Nombre de tancaments",
  introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE:
    "Introduïu l'últim número d'assentament comptable que té a SAGE",
  porFavorRelleneElAsientoContable:
    "Si us plau, ompliu l'assentament comptable",
  descargar: "Descarregar",
  elAsientoContableDebeSerUnNumero:
    "L'assentament comptable ha de ser un número",
  elAsientoContableNoPuedeSerMayorA10Digitos:
    "L'assentament comptable no pot ser superior a 10 dígits",
  TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos:
    "Tingueu en compte que utilitzarem els números següents a aquest per completar les dades",
  noExistenVentasEsteDia: "No existeixen vendes aquest dia",
  noExistenGastosEsteDia: "No existeixen despeses aquest dia",
  enSage: "a SAGE",
  proyecto: "Projecte",
  codigoEmpresaHelp:
    "Recordeu que la dada empresa es comparteix entre tots els negocis de la mateixa empresa",
  cuentasDelTpvSeleccionado: "Comptes del TPV seleccionat",
  nuevaCuenta: "Nou compte",
  nombreDeCuenta: "Nom del compte",
  codigoCuentaMinuscula: "Codi compte",
  tipoDeCuenta: "Tipus de compte",
  noHayCuentasCreadasConElTpvSeleccionado:
    "No hi ha comptes creats amb el TPV seleccionat",
  crearNuevaCuenta: "Crear nou compte",
  codigoDeLaCuenta: "Codi del compte",
  codigoDeLaSubcuenta: "Codi de la subcompte",
  configuracionCuentasIva: "Configuració comptes IVA",
  configuracionCuentasEspeciales: "Configuració comptes especials",
  cuenta: "Compte",
  subcuenta: "Subcompte",
  editarCuenta: "Editar compte",
  sage200: "SAGE 200",
  exportarCAPTE: "Exportar CAPTE",
  losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos:
    "Els camps nom, codi de compte i codi de subcompte han d'estar omplerts",
  estaSeguroDeQueDeseaEliminarEstaCuenta:
    "Esteu segur que voleu eliminar aquest compte?",
  siBorrarCuenta: "Sí, eliminar compte",
  cuentaEditadaCorrectamente: "Compte editat correctament",
  cuentaCreadaCorrectamente: "Compte creat correctament",
  configuracionSAGE: "Configuració Sage",
  sinCuentaAsociada: "Sense compte associat",
  loSientoSuNegocioNoTieneContratadoSAGE:
    "Ho sentim, el vostre negoci no té contractat SAGE",
  loSientoSuNegocioNoTieneContratadoEsteModulo:
    "Ho sentim, el vostre negoci no té contractat aquest mòdul",
  paraMasInformacionContacteConComerciales:
    "Per a més informació contacteu amb comercials",
  laLongitudMaximaDeLasSubCuentas:
    "La longitud màxima de la subcompte ha de ser de 12 caràcters",

  preparados: "Preparats",
  enReparto: "En repartiment",
  noHayPedidosPreparados: "No hi ha comandes preparades",
  noHayPedidosEnReparto: "No hi ha comandes en repartiment",
  pedidoListo: "Comanda llesta",
  pedidoEnReparto: "Comanda en repartiment",

  codigo: "Codi",
  crearNuevoCodigoCuenta: "Crear nou codi de compte",
  editarNuevoCodigoCuenta: "Editar nou codi de compte",
  seleccioneUnaFormaDePagoParaElGasto:
    "Seleccioneu una forma de pagament per a la despesa",
  hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna:
    "Heu seleccionat albarans amb diferents formes de pagament, si us plau seleccioneu-ne una",
  seleccioneUnaFormaDePago: "Seleccioneu una forma de pagament",
  zonasActualizadasCorrectamente: "Zones actualitzades correctament",
  zonaCreadaCorrectamente: "Zona creada correctament",
  zonaEditadaCorrectamente: "Zona editada correctament",
  guardarCambios: "Guardar canvis",
  laZonaNoPuedeTenerElNombreEnBlanco: "La zona no pot tenir el nom en blanc",
  zonasDeReparto: "Zones de repartiment",
  editarZona: "Editar zona",
  color: "Color",
  costeDeReparto: "Cost de repartiment",
  pedidoMinimo: "Comanda mínima",
  crearNuevaZona: "Crear nova zona",
  estasSeguroDeQueQuieresEliminarLaZona:
    "Esteu segur que voleu eliminar la zona?",
  estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos:
    "Aquesta zona deixarà de ser disponible immediatament i no es podran fer comandes des d'ella",
  siEliminarZona: "Sí, eliminar zona",
  zonaEliminadaCorrectamente: "Zona eliminada correctament",
  ventasExportadas: "Vendes exportades",
  gastosExportados: "Despeses exportades",
  todosLosCierresDeEsteDiaHanSidoExportados:
    "Tots els tancaments d'aquest dia han estat exportats",
  faltanVentasPorExportarEsteDia: "Falten vendes per exportar aquest dia",
  todosLosGastosDeEsteDiaHanSidoExportados:
    "Totes les despeses d'aquest dia han estat exportades",
  faltanGastosPorExportarEsteDia: "Falten despeses per exportar aquest dia",
  exportar: "Exportar",

  // 10-02-2021
  otros: "Altres",
  restriccionHorarios: "Restricció horaris",
  restriccionHorariosDesc:
    "Restringir algunes franges horàries (tancat, ple, sense repartiment...)",
  borrar: "Esborrar",
  restriccion: "Restricció",
  nMaximoPedidos: "Nº màxim de comandes",
  cerrarFranja: "Tancar franja",
  limitePedidos: "Límit Nº comandes",
  loSentimosSuNegocioNoTieneContratadoEsteModulo:
    "Ho sentim, el vostre negoci no té contractat aquest mòdul",
  numeroPedidosPermitidos: "Nombre de comandes permeses",
  estaSeguroDeQueDeseaEliminarEstaRestriccion:
    "Esteu segur que voleu eliminar aquesta restricció?",
  siBorrarRestriccion: "Sí, eliminar restricció",
  loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion:
    "Ho sentim, per accedir a aquest mòdul cal activar la configuració",
  costeSinIVA: "Cost sense IVA",

  // 11.3.2021
  importeIVA: "Import IVA",

  // 17.3.2021
  pasarAPreparacion: "Passar a preparació",
  pasarAPreparados: "Passar a preparats",
  pasarAEnReparto: "Passar a en repartiment",
  finalizarPedido: "Finalitzar comanda",

  // Tener en cuidado con los espacios, ya que son los espacios Braille
  domicilioActivado: "‏‏‎DOMICILI⠀ACTIVAT",
  domicilioDesactivado: "DOMICILI⠀DESACTIVAT",
  recogerActivado: "RECOLLIR⠀ACTIVAT",
  recogerDesactivado: "RECOLLIR⠀DESACTIVAT",

  conDetalles: "amb detalls",
  zonasRepartoActivadas: "ACTIVADES⠀",
  zonasRepartoDesactivadas: "DESACTIVADES⠀",
  siEliminarCategoria: "Sí, eliminar categoria",
  confirmaEliminarCategoria:
    "Esteu segur que voleu eliminar aquesta categoria?",
  pedidoPreparado: "Comanda preparada",
  configuracionParaLaImportacionExportacionDeDatosDeSage:
    "Configuració per a la importació/exportació de dades de Sage",
  enEstaPantallaSeConfiguranLosCodigosDeLasCuentas:
    "En aquesta pantalla es configuren els codis dels comptes",
  formadosPor3Digitos: "formats per 3 dígits",
  estosSonNecesariosParaConfigurarLasCuentasContables:
    "Aquests són necessaris per configurar els comptes comptables",
  alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente:
    "En editar un codi relacionat amb un compte comptable ja existent",
  todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta:
    "tot canvi que es produeixi sobre aquest afectarà també al propi compte",
  aContinuacionSeListaranLasCuentasDeTipo:
    "A continuació es llistaran els comptes de tipus",
  gastoMinuscula: "despesa",
  paraQue: "per a que",
  asocieMinuscula: "associï",
  ventaMinuscula: "venda",
  unaParaSuPosterior: "una per al seu posterior",
  relacionEnSage: "relació en SAGE",
  relacionEnContabilidad: "relació en comptabilitat",
  seleccioneUnaCuenta: "Seleccioneu un compte",
  aDomicilio: "A domicili",
  aRecoger: "A recollir",
  tipoDeZona: "Tipus de zona",
  seleccioneUnTipo: "Seleccioneu un tipus",
  kilometrosDelArea: "Kms de l'àrea",
  codigoEmpleado: "Codi empleat",
  exportarReservas: "Exportar reserves",
  importacionSinqro: "Importació Sinqro",
  configuracionParaLaImportacionDeDatosDeSinqro:
    "Configuració per a la importació de dades de Sinqro",
  pasarelaDePago: "Passarel·la de pagament",
  importeSinDescuento: "Import sense descompte",
  desactivarZona: "Desactivar zona",
  activa: "ACTIVA",
  inactiva: "INACTIVA",
  exportarPdfConMateriasPrimasAsociadas:
    "Exportar PDF amb matèries primeres associades",
  exportarExcelConMateriasPrimasAsociadas:
    "Exportar Excel amb matèries primeres associades",

  // Pedidos archivados 18/05/21
  informePedidosDetalle: "Detall de comandes",
  informePedidos: "Informe de comandes",
  tipoPago: "Forma de pagament",
  tipoPedido: "Tipus de comanda",
  domicilio: "Enviament a domicili",
  recoger: "Recollida al local",
  pagoLocal: "Pagament al local",
  otro: "Altres",

  // 25/05/2021
  configuracionTurnos: "Configuració de torns",

  // 2021/05/20
  estasSeguroDeImportarTusProductosASinqro:
    "Voleu importar els vostres productes a Sinqro?",
  esteProcesoPuedeTardarVariosMinutos:
    "Aquest procés pot trigar diversos minuts.",
  siImportarConSinqro: "Sí, importar a Sinqro",
  estasSeguroDeDarDeBajaElProducto: "Voleu donar de baixa el producte?",
  podraDarloDeAltaEnUnFuturo: "Podrà donar-lo d'alta en el futur",
  siDarDeBaja: "Sí, donar de baixa",
  estasSeguroDeDarDeAltaElProducto: "Voleu donar d'alta el producte?",
  podraDarloDeBajaEnUnFuturo: "Podrà donar-lo de baixa en el futur.",
  siDarDeAlta: "Sí, donar d'alta",
  laImportacionTardara: "Important... aquest procés pot trigar diversos minuts",
  importacionFinalizada: "Importació completada amb èxit",
  completo: "Completat",
  vale: "D'acord",
  importarSinqro: "Importar Sinqro",
  importandoProductos:
    "S'està duent a terme la importació en aquests moments...",
  generandoCarta: "Un moment, si us plau. Estem generant la vostra carta.",
  procesoFin: "El procés s'ha completat amb èxit",
  procesoCompletado: "Procés completat",
  yaFaltaPoco: "Ja falta poc...",
  estamosEnEllo:
    "Estem treballant en la importació. Si us plau, no recarregueu el navegador.",
  finProgres: "El progrés ha finalitzat amb èxit.",
  textoInfo: "Aquesta columna mostra el preu de compra sense IVA",
  textoInfoImporteDTO:
    "Aquesta columna mostra el preu total de compra amb descompte (calculat a partir del preu sense IVA)",
  correosEnviados: "Correus enviats",
  correosEnviadosCorrectamente: "Els correus s'han enviat correctament.",
  errorAlEnviar: "Error en enviar",
  noSePudieronEnviarTodosLosCorreos: "No s'han pogut enviar tots els correus:",
  errorInesperadoEnvioCorreos:
    "Ha ocorregut un error inesperat. Si us plau, torneu-ho a intentar més tard",

  // 07/06/2021
  valorRecuento: "Valor Recompte",

  // 08/06/2021
  obligatorioEmail: "Obligatori omplir email",
  datosCliente: "Dades client",

  // 11/06/2021
  recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:
    "Recordeu que fer cobraments avançats pot generar petits descuadres",
  yQue: "i que",
  losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:
    "els descomptes de les vendes estan al 0% d'IVA",

  // 16/06/2021
  totalValoresNegativos: "Total Valors Negatius",
  solamenteSeTieneEnCuentaValoresPositivos:
    "Només es tenen en compte valors positius",
  totalValoresDiferencia: "Total Valors Diferència",
  totalValoresDiferenciaDto: "Total Valors Diferència Dto.",
  valorDiferencia: "Valor diferència",
  valorDifereciaDto: "Valor diferència dto.",
  precioDto: "Preu Dto.",

  // 24/06/2021
  exportarMateriasPrimasAsociadasAEsteProducto:
    "Exportar matèries primeres associades a aquest producte",
  sinIVA: "Sense IVA",
  errorAlIntentarObtenerLosTpvs: "Error en intentar obtenir els TPVs",

  // 01/07/2021
  deseaguardarelproductoencarta:
    "A continuació, es procedirà a replicar els noms i els preus de les tarifes que siguin majors a 0€, així com el camp baixa. Aquests canvis afectaran a tots els productes de NumierPEDIDOS relacionats amb aquest producte.",
  leidoyacepto: "Ho entenc!",
  replicarencarta: "Esteu segur?",
  aceptarreplicarencarta: "Acceptar i replicar a carta",
  guardaryreplicar: "Guardar i replicar a Carta",

  // Modal seleccionar categoría al crear en carta
  enlazarACategoria: "Vincular a una categoria",
  deseaEnlazarProductoCategoria: "Voleu vincular el nou producte a una categoria existent a la carta?",
  categoria: "Categoria",
  seleccionarCategoria: "Seleccionar categoria",
  omitirYCrear: "Ometre i crear",
  aceptarYAgregar: "Acceptar i afegir",

  // 01/07/2021
  porRangosHorarios: " per rangs horaris",

  // 22/07/2021
  recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal:
    "Recordeu que les línies de descompte no es sumen al total",

  // 16/07/21
  destacado: "Destacat",
  sugerido: "Sugerit",

  // 23/07/2021
  totalSinDescuento: "Total sense descompte",

  // MENÚS
  menus: "Menús",
  descripcionMenus: "Grup de productes que es venen de forma conjunta",
  numeroDePlatos: "Nombre de plats que el client podrà triar per cada plat:",
  platosTip1: "En aquesta pantalla es poden crear els diferents plats que",
  platosTip2:
    "componen el menú per a la seva posterior assignació amb els productes.",
  productosPlatosTip:
    "En aquesta pantalla es poden relacionar plats i productes per a la seva posterior visualització a la carta.",
  plato: "Plat",
  platos: "Plats",
  primerPlato: "Primer plat",
  segundoPlato: "Segon plat",
  tercerPlato: "Tercer plat",
  cuartoPlato: "Quart plat",
  quintoPlato: "Cinquè plat",
  sextoPlato: "Sisè plat",
  seleccionaUnPlato: "Selecciona un plat",
  noPuedeDejarEnBlancoElNombreDeUnPlato:
    "No pot deixar en blanc el nom d’un plat",
  estaSeguroDeQueQuiereBorrarEstePlato:
    "Esteu segur que voleu eliminar aquest plat?",
  seBorraranTodasLasAsociacionesDeProductosConElMismo:
    "S'eliminaran totes les associacions de productes amb el mateix",
  siEstoySeguro: "Sí, estic segur",
  estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado:
    "Esteu segur que voleu desvincular aquest producte del plat seleccionat?",
  dejaraDeFormarParteDelMenuDeFormaInstantanea:
    "Deixarà de formar part del menú de manera instantània",
  noMostrarSuelto: "No mostrar sol (només disponible en menús)",
  clonarMenu: "Clonar menú",
  // 29/07/2021
  totalPedidosDevueltos: "Nº de devolucions",
  totalImportesDevueltos: "Total import retornat",

  // 06/08/2021
  NoMostrarRecargasSaldo: "No mostrar recàrregues de saldo",
  // 10/08/2021
  noMostrarDescuento: "No mostrar descomptes",
  // 17/08/2021
  operarioApertura: "Operari d'obertura",
  aperturasPorOperarios: "Comptes oberts per operari",
  aperturasPorOperariosMinuscula: "comptes oberts per operari",
  aperturasOperarios: "Comptes oberts",
  productosPorAperturaDe: "Productes per obertura de",
  productosPorApertura: "Productes per obertura",
  facturasEmitidasMinuscula: "factures emeses",

  // 18/08/21
  restriccionesProductos: "Restriccions per producte",
  restriccionesProductosDesc:
    "Configurar restriccions horàries per a la venda de productes",
  // 19/08/21
  noHayRestriccionesParaProductos:
    "No hi ha restriccions horàries per a productes en aquest negoci.",
  alcohol: "Alcohol",
  // 20/08/21
  inforestriccionesproducto:
    "Un cop creada la restricció de venda horària, podrà assignar-la a la configuració dels productes.",
  noMostrarDescuento: "No mostrar descomptes",

  // 17/08/2021
  rangosDeMesas: "Rangs de taules",
  agrupacionesDeMesasParaConsultarVentas:
    "Agrupacions de taules per consultar vendes",
  verUnInformeDeRangosDeMesas: "Veure informe de rangs de taules",
  nuevoRangoMesa: "Nou rang de taula",
  mesaInicial: "Taula inicial",
  mesaFinal: "Taula final",
  noHayRangosDeMesasEnEsteTpv: "No hi ha rangs de taules en aquest TPV",
  nombreRangoDeMesas: "Nom del rang de taules",
  borrarRangoMesas: "Eliminar rang de taules",
  deseaEliminarEsteRangoDeMesas: "Voleu eliminar aquest rang de taules?",
  siBorrarEsteRangoDeMesas: "Sí, eliminar aquest rang de taules",
  ventasPorRangoDeMesas: "Vendes per rang de taules",
  porRangoDeMesas: " per rang de taules",
  numeroDeOperaciones: "Nombre d’operacions",
  precioMedioPorOperacion: "Preu mitjà per operació",
  propuestoParaCierre: "Proposat per a tancament",
  esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo:
    "Aquest tiquet ha estat proposat per al seu tancament, hi esteu d'acord?",
  siCerrarTicket: "Sí, tancar tiquet",
  propuestaDeCierreDeTicket: "Proposta de tancament del tiquet",
  noEstoyDeAcuerdo: "No estic d'acord",
  ultimaRespuestaDelEquipoTecnico: "Última resposta de l’equip tècnic",
  escribaAquiSuRespuesta: "Escriviu aquí la vostra resposta",
  enviarRespuesta: "Enviar resposta",
  tienesTicketsPendientesDeCerrar: "Tens tiquets pendents de tancar",

  // 27/08/2021
  cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV:
    "Quan un producte és de tipus Menú, es crea un Menú que es sincronitza amb el TPV",
  platosDelMenu: "Plats del menú",
  productosDelMenu: "Productes del menú",
  paraConfigurarUnProductoComoTipoMenu:
    "Per configurar un producte com a tipus Menú, primer ha de guardar el producte",
  ocultarSaldo: "Ocultar productes relacionats amb saldo",

  // 26/08/21
  resActiva: "Activada",
  resInactiva: "Desactivada",

  // 26/08/2021
  exportarExcelDeTodosLosTickets: "Exportar Excel de tots els tiquets",
  soloPuedesSacarInformesDeUnMesComoMaximo:
    "Només pots generar informes d’un mes com a màxim",
  loSentimos: "Ho sentim",
  noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas:
    "No tens cap rang de taules creat. Vols crear-ne un?",
  siCrearUnRangoMesas: "Sí, crear rang de taules",

  // 07/08/2021
  usuarioSinAcceso: "El teu usuari no té accés a aquest mòdul",

  // 08/09/21
  pedidosHoras: "Comandes per hores",
  graficaPedidosHoras:
    "Gràfica que mostra el nombre de comandes agrupades per franja horària avui",

  // 20/09/21
  personalizacionCarta: "Personalització de la Carta Online",
  personalizacion: "Personalització",
  conLasOpcionesQueTeOfrecemos: "amb les opcions que t’oferim",
  opcionesConfiguracion: "Opcions de configuració",
  vistaPrevia: "Vista prèvia",
  imagenCargando: "Imatge de càrrega",

  // 21/09/21
  diagnosis: "Diagnosis",
  diagnosticoProductos: "Diagnòstic de productes",
  comprobacionProducts: "Comprovació de productes",
  diagnosticarProductos: "Diagnosticar productes",
  productosSinRelacionEnElTpv: "Tot correcte!",
  pulseElBoton: "Prem el botó desitjat",
  paraRealizarDiagnosis: "per realitzar el diagnòstic",
  productoRelacionadoConTpv: "Relacionat al TPV amb",
  noTieneRelacion: "No té relació",
  hayProductosSinRelacion: "Hi ha productes que no estan relacionats al TPV",

  // 20/09/21
  destacadosTitulo: "Títol destacat",
  nuevoTitulo: "Nou títol",
  tituloActual: "Títol actual",

  // 22/09/21
  textos: "Textos",

  // 21/09/21
  facturas: "Factures",
  facturasMinusculas: "factures",
  facturacionGeneral: "Facturació general",
  deTodasLasSeries: " de totes les sèries",

  // 29/09/21
  permisoBusinessGestion:
    "Ho sentim. No tens permís per utilitzar aquesta eina en el negoci actual",
  permisoUsuarioGestion: "Ho sentim. Aquest negoci no té aquest mòdul activat.",
  traduccion: "Traducció",
  traduccionDe: "Traducció de",
  idioma: "Idioma",
  losDescuentosDeLasVentasEstanAlCeroDeIva:
    "Els descomptes de les vendes estan al 0% d’IVA",
  recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo:
    "Recorda que en realitzar cobraments avançats, els comensals s’assignaran a la forma de pagament efectiu",
  mapasYZonas: "Mapes i zones",
  idiomas: "Idiomes",
  permisoControlIdiomas:
    "Ho sentim, aquest negoci no té activat el control d’idiomes.",
  idiomasCartaTip1:
    "Per activar o desactivar un idioma pots fer clic als interruptors.",
  idiomasCartaTip2:
    "Per ordenar els idiomes a la carta, pots utilitzar el camp ordre.",
  idiomasCartaTip3: "Els idiomes amb un ordre menor apareixeran primer.",
  menu: "Menú",

  // 30/11/21
  totalVentasDevueltos: " total vendes i retornats",

  // 24/11/21
  tpvOrigen: "TPV d’origen",
  validez: "Validesa (dies)",
  dateConsumo: "data de consum",
  dateCreacion: "data d’emissió",
  nombreTpvDestino: "TPV de canvi",
  nombreTpvOrigen: "TPV d’origen",
  hash: "CÒDIGO (hash)",
  proveedor: "Proveïdor",

  // 14/12/2021
  apuntes: "Apunts",
  apunte: "Apunt",
  cuentaContableGastos: "Compte comptable de despeses",
  cuentaContableApuntes: "Compte comptable d’apunts",
  retrocederEstado: "Retrocedir estat",

  // 23/12/2021
  excluirDeSage: "Excluir de Sage",
  costeDeProductosPorAgencias: "Cost de productes per agències",
  agrupadoPorAgencias: " agrupat per agències",

  // 27/10/21
  selectCategory: "Selecciona les categories per a la importació",
  errorCategorySelect: "ATENCIÓ",
  txtErrorCategorySelect:
    "S’ha cancel·lat la importació perquè les categories seleccionades només contenen menús.",

  // 24/01/22
  consultarPorAperturaDeCuenta: "Consultar per obertura de compte",
  consultarPorCierreDeCuenta: "Consultar per tancament de compte",
  informeAperturaCuentas: "Informe obertura comptes",
  informeCierreCuentas: "Informe tancament comptes",
  activado: "Activat",
  desactivado: "Desactivat",
  rango: "Rang",
  pedidosPlataformaDePagoSinCompletar:
    "Comandes plataforma de pagament sense completar",
  estaAccionAnadiraUnPedidoEstaSeguro:
    "Aquesta acció afegirà una comanda, estàs segur que ha estat pagada?",
  estaAccionNoSePuedeDeshacerEstaSeguro:
    "Aquesta acció no es pot desfer, estàs segur?",
  haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas:
    "Hi ha hagut una comanda amb aquest telèfon en les últimes 12 hores",
  interrogacionQuiere: "Vols ",
  elPedidoTemporalInterrogacion: " la comanda temporal?",
  aceptarMinuscula: "acceptar",
  eliminarMinuscula: "eliminar",
  excluirPrecioMedioMenu:
    "Excloure del preu mitjà els productes venuts en menús",

  // 28/01/22
  categoriasPadre: "Categories pare",
  quieresConvertirLaCategoria: "Vols convertir la categoria",
  quieresQueLaCategoria: "Vols que la categoria",
  enUnaCategoriaPadre: "en una categoria pare?",
  dejeDeSerUnaCategoriaPadre: "deixi de ser una categoria pare?",
  porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion:
    "Si us plau, afegeix una categoria pare abans d’activar la configuració",
  deseaActivarLasCategoriasPadreParaLaCartaDigital:
    "Vols activar les categories pare per a la carta digital?",
  deseaDesactivarLasCategoriasPadreParaLaCartaDigital:
    "Vols desactivar les categories pare per a la carta digital?",
  recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital:
    "Recorda que les categories que no estiguin relacionades amb una categoria pare no apareixeran a Numier Pedidos",
  activadas: "ACTIVADES",
  desactivadas: "DESACTIVADES",
  categoriasPadreTextoExplicativo:
    "Les categories pare serveixen per agrupar les categories de Numier Pedidos en agrupacions majors. Exemple: Pots tenir una categoria pare 'Primers' que contingui Carn, Peix i Vegetarià",
  lasImagenesSoloSeraVisibleEnLasCategoriasPadre:
    "Les imatges només seran visibles a les categories pare",

  // 09/02/2022
  consultarInventarioPorSectores: "Consultar inventari per sectors",
  inicioReal: "Inici real",
  precarga: "Precàrrega",
  mermas: "Pèrdues",
  finalBarra: "Final barra",
  porSectores: "per sectors",
  buscarPorRefONombreDelProducto:
    "Buscar per codi de barres o nom del producte",
  textoAyudaProductoCompleto:
    "Quan aquesta opció està desmarcada es treballarà amb matèries primeres",
  accion: "Acció",

  metodoLiquidacionSinqro: "Mètode liquidació Sinqro",
  metodoLiquidacionSinqroInfo:
    "La modificació d’aquest camp s’ha de sol·licitar al suport tècnic.",
  horaRepartidorAsignado: "Hora repartidor assignat",
  envioProgramado: "Enviament programat",
  tiempoEstimado: "Temps estimat",
  gastosEnvio: "Despeses enviament",
  buscarPedidoPorCliente: "Buscar comanda per client...",
  obligatorioApellidos: "Obligatori els dos camps de cognoms",

  // 13/06/2022
  introduzcaElPorcentajeDeLaPrimeraCuentaContable:
    "Introdueix el percentatge del primer compte comptable",
  porcentajeContable: "Percentatge comptable",

  // 7/7/2022
  incidenciaOperario: "Incidències per operari",
  deIncidenciaOperario: "d’incidències per operari",
  verIncidenciaOperario: "Veure incidències",
  Incidencia: "Incidència",

  // 11/07/2022
  nTickets: "Nº Tiquet",
  propina: "Propina",
  serviceCharge: "Service Charge",

  // 15/07/2022
  totalCompleto: "Total complet",

  // 31/08/2022
  sinConsumir: "Sense consumir",

  // 06/09/2022
  integraciones: "Integracions",
  GStock: "G-Stock",

  // 13/09/2022
  estasSeguroDeExportarLasVentas:
    "Estàs segur de exportar les vendes a G-Stock?",
  ventasExportadasExsitosamente: "Vendes exportades amb èxit",
  rangoFechasExcedidoMaximo: "L'interval de dates no pot excedir 3 mesos",
  rangoSolicitadoMayorAlPermitido: "L'interval sol·licitat és superior al permès (màxim 3 mesos)",
  respuestaInvalida: "Resposta inválida del servidor",

  // 04/10/2022
  referenciaYaExiste: "La referència coincideix amb la d’una altra despesa",
  continuar: "¿Continuar?",
  guardarGasto: "Guardar despesa",
  maximoOpcionales: "Màxim opcionals",

  // 04/11/2022
  totalImpuestoIva: "Total impost IVA",

  // 09/11/2022
  enviarFacturaECorreo: "Enviar factura electrònica per correu",

  // 10/11/2022
  baseImponible: "Base imposable",
  cuotaIVA: "Quota IVA",
  baseSinDto: "Base sense dto.",
  importeTotalSinDto: "Import total sense dto.",

  // 17/11/2022
  identificador: "Identificador comptable",

  // 13/12/2022
  cambiarAgencia: "Canviar agència",
  facturaEditadaCorrectamente: "La factura s’ha editat correctament",
  editarNumeroComensales: "Editar nombre de comensals",
  buscarPorNombreDeAgencia: "Buscar per nom d’agència",

  // 10/01/2023
  exportadoSage: "Exportat SAGE",
  updateExportadoSageCorrectamente: "Exportat SAGE actualitzat correctament",
  titleModificarExportadoSage: "Modificar exportat a SAGE",
  askUpdateExportadoSageTrue:
    "Estàs segur que vols marcar la despesa com exportada?",
  askUpdateExportadoSageFalse:
    "Estàs segur que vols marcar la despesa com NO exportada?",

  // 01/02/2023
  ProgramacionCarta: "Planificador de la carta",
  guardados: "Guardats",
  publicados: "Publicats",
  dePublicacion: "de Publicació",
  sinPublicar: "Sense publicar",
  publicado: "publicat",
  publicar: "Publicar",
  Ocultar: "Ocultar",
  Publicado: "Publicat",
  aliasMayuscula: "Àlies",

  // 03/02/2023
  porcentajeRespectoTotal: "% respecte del total",

  // 13/02/2023
  ultimoPrecioCompra: "Últim preu de compra",

  // 21/02/2023
  basePropina: "Base Propina",
  impuestoPropina: "Impost Propina",
  baseServiceCharge: "Base Service Charge",
  impuestoServiceCharge: "Impost Service Charge",

  // 02/03/2023
  socios: "Soci",
  noSocios: "No soci",

  // 20/04/2023
  productoCartaSinRelacionar: "Sense relacionar",

  // 21/04/2023
  precioTarifa: "Preu / Tarifa 1",

  resetearDias: "Resetjar dies",
  resetearButton: "Resetjar",
  fechaIni: "Data d’inici",
  fechaFin: "Data de fi",
  reseteoExitoso: "Reset realitzat correctament",
  reseteoError: "Hi ha hagut un error en realitzar el reset",

  productosNoRelacionados: "Productes sense PLU",
  productosNoRelacionadosDescripcion: "Eina per trobar productes sense PLU",

  // 23/05/2023
  verDetallesDeCuentaAnulada: "Veure detalls de compte anul·lada",
  desgloseDeCuenta: "Desglossament de compte",

  // 29/03/2023
  exportarExcelValderrama: "Exportar Excel complet",

  // 20/04/2023
  productoCartaSinRelacionar: "Sense relacionar",

  // 21/04/2023
  precioTarifa: "Preu / Tarifa 1",

  // 29/05/2023
  pendientePago: "Pendent de pagament",
  fechaVencimiento: "Data de venciment",
  pendientePagoCambiadoCorrectamente:
    "Pendent de pagament canviat correctament",
  numeroTickets: "Número de tiquets",

  // 06/06/2023
  mensajePorcentajeCompraAumento:
    "El preu ha augmentat respecte del percentatge de compra establert",
  avisoPorcentajeCompra: "Avís de percentatge de compra",

  // 19/06/2023
  conIvaDesglosado: "amb IVA desglossat",

  // 21/06/2023
  ventasPorProductos: "Vendes per productes",
  sinRecoger: "Sense recollir",
  sinDomicilio: "Sense domicili",
  recogerEnPedidos: "Recollir",
  domicilioEnPedidos: "Domicili",
  informeDeVentasDeProductosDePedidos:
    "Informe de vendes de productes de comandes",

  // 22/06/2023
  numeroPedidosDomicilio: "Nº comandes domicili",
  numeroPedidosRecoger: "Nº comandes recollir",

  // 25/07/2023
  exportarSage200Fechas: "Exportar Sage200 per dates",
  fechas: "Dates",
  soloExportarGastos: "Només exportar despeses",

  // 05/09/2023
  noMostrarInformeSectores: "No mostrar informe sectors",
  totalCargar: "Total a carregar",
  deshabilitar: "Deshabilitar",
  noMostrar: "No mostrar",

  // 19/09/2023
  verificarTodo: "Verificar tot",
  estaSeguroDeVerificarTodosLosGastos:
    "Estàs segur de verificar totes les despeses?",
  gastosVerificadosCorrectamente: "Despeses verificades correctament",

  // 26/09/2023
  siVerificarGastos: "Sí, verificar despeses",
  seleccionarTodosDelMismoProveedor: "Seleccionar tots del mateix proveïdor",

  // 28/09/2023
  mostrarSinIva: "Mostrar sense IVA",
  modificarPrecio: "Modificar preu",

  // 05/10/2023
  nDeComensales: "Nº de comensals",

  // 13/10/2023
  archivoEnFormatoExcel: "Arxiu en format Excel",
  importarExcelClientes: "Importar Excel clients",
  importarExcelSaldoClientes: "Importar Excel saldo clients",
  importarClientes: "Importar clients",

  // 31/10/2023
  ticketMedioRecoger: "Tiquet mitjà recollir:",
  ticketMedioDomicilio: "Tiquet mitjà domicili:",

  // 23/11/2023
  ultimoPrecioCompraSinIva: "Últim preu de compra sense IVA",

  // 08/01/2024
  ventaDeProductosPorRangoDeMesas: "Vendes de productes per rang de taules",
  filtradoPorRangoDeMesas: " filtrat per rang de taules",
  vecesQueSeHaVendidoDentroDeMenus: "Vegades que s’ha venut dins de menús",
  delMenu: "del menú",
  cEnMenus: "C. en Menús",
  cFueraDeMenus: "C. Fora de Menús",
  rangoDeMesas: "Rang de taules",

  // 10/01/2024
  // ToolTip
  tolTipLogo:
    "Afegeix el logo del teu restaurant perquè aparegui a la pantalla d’inici i a la teva targeta QR. La mida recomanada és de 90 x 90 px.",
  tolTipFondo:
    "Afegeix una foto d’alta qualitat perquè aparegui com a portada al teu menú QR. La mida recomanada és de 1280 x 1024 px",
  tolTipImagenProducto:
    "Afegeix una imatge d’alta qualitat per mostrar el teu producte de manera visual i atractiva. Per productes del menú, crea’n un de nou amb resolució ideal de 500 x 500 píxels o 12 cm x 12 cm.",
  tolTipNombreMostrado:
    "Escriu aquí el nom que vols que es mostri del teu negoci.",
  tolTipEmail:
    "Facilita un correu electrònic de contacte per als teus clients.",
  tolTipTelefono: "Facilita un telèfon de contacte.",
  tolTipDescripcion:
    "Descriu breument el teu restaurant: el concepte i l’experiència que ofereixes.",
  tolTipDireccion:
    "Facilita l’adreça del restaurant que pertany a aquesta carta.",
  tolTipPresentacion:
    "Escriu una crida a l’acció adequada perquè els teus clients vulguin obrir la teva targeta a la pantalla d’inici.",
  tolTipHorario:
    "Mostra el teu horari o comparteix informació extra (vacances, fora de servei...).",
  tolTipMostrarCategoriaDeBaja:
    "Si marques la casella, es mostraran les categories donades de baixa, però no apareixeran a la teva carta.",
  tolTipMostrarProductoDeBaja:
    "Si marques la casella, es mostraran els productes donats de baixa, però no apareixeran a la teva carta.",
  tolTipTraducirCategoria:
    "Traduir al idioma que vulguis el títol de les categories",
  tolTipConvertirCategoriaPadre: "Convertir en categoria pare",
  tolTipOrdenCategorias:
    "Si vols que aparegui aquesta categoria com la primera, el número hauria de ser '1', i així successivament segons l’ordre.",
  tolTipBajaCategoria:
    "Al activar aquesta opció, la categoria seleccionada deixarà de aparèixer al teu menú digital quan els clients hi accedeixin. La desactivació d’una categoria implica que tots els productes inclosos sota aquesta categoria també deixaran de ser visibles.",
  tolTipVerQr: "Accedeix i descarrega el codi QR de la teva carta",
  tolTipDisponibleProducto:
    "Marca la disponibilitat del producte: Indica si un producte està disponible o no a la teva carta.",
  tolTipIdiomaProducto:
    " Tria l’idioma en què també vols que es presenti el producte",
  tolTipOrdenProducto:
    "Tria l’ordre en què vols que aparegui el producte dins la categoria seleccionada.",
  tolTipProductoDestacado:
    " Si selecciones aquesta opció, el producte apareixerà en una secció destacada al principi de la carta. Ressalta productes especials o promocions.",
  tolTipBaja:
    "Aquest producte no es mostrarà a la teva carta (si està activat).",
  tolTipDisponible:
    "Activa el botó si el producte està disponible per a la venda. Desactiva si el producte està 'Fora d’Stock' (quan no hi ha existències).",
  tolTipImagenCarga:
    "Imatge que es mostrarà durant els breus segons en què es carrega la teva carta.",
  tolTipTituloDestacado:
    "Aquí pots definir el text que anomenarà la secció de productes destacats. Ex: 'Suggerències del Xef', 'Els nostres Top Vendes' o 'No t’ho pots perdre'.",
  tolTipIdiomaMateriaPrima:
    "Tria l’idioma en què també vols que es presenti la matèria primera",
  guiaUsuario: "Guia d’usuari",

  // 14/02/24
  pedidosPorRepartidores: "Comandes per repartidors",
  nombreRepartidor: "Nom del repartidor",
  cantidadDePedidos: "Quantitat de comandes",

  // 13/02/2024
  herramientaControlStockControlComprasInventarios:
    "Eina de control d'estoc, control de compres i inventaris",
  fidelizacion: "Fidelització",
  cheerfy: "Cheerfy",
  plataformaGestionPromocionesClientes:
    "Plataforma de gestió de promocions de clients",
  nuevaPromocion: "Nova promoció",
  noHayPromocionesEnEsteTpv: "No hi ha promocions en aquest TPV",
  tolTipDisponiblePromocion:
    "Marqueu la disponibilitat de la promoció: indica si la promoció està disponible o no.",
  promocion: "promoció",
  fechaCreacion: "Data creació",
  activo: "Actiu",
  inactivo: "Inactiu",
  borrarPromocion: "Esborrar promoció",
  promociones: "Promocions",
  codigoPromocion: "Codi promoció",
  elCampoCodigoEsRequerido: "El camp codi és obligatori",
  deseaEliminarEstaPromocion: "Vol esborrar aquesta promoció?",
  siBorrarEstaPromocion: "Sí, esborrar aquesta promoció",

  // 12/03/24
  basesFree: "Bases extra gratis",
  extrasFree: "Bases / Extres gratis",
  tooltipBaseExtra:
    "Si la base està activada, no suma extra gratis. Si l'extra està activat, no comptarà com a gratis en afegir-se.",

  // 09/04/24
  permisoControlModulos: "Ho sentim. Aquest negoci no té aquest mòdul activat.",
  calcularCosteTodosLosProductos: "Calcular cost de tots els productes",
  trabajarSinIva: "Treballar sense IVA",
  filtrarPorAgencias: "Filtrar per agència",
  seleccioneLaTarifaParaMostrarSuNombre:
    "Seleccioneu la tarifa per mostrar el seu cost",
  conIVA: "Amb IVA",
  calcular: "Calcular",
  productosIncluidosConEsteMenu: "Productes inclosos amb aquest menú",
  abonarFacturaQr: "Abonar Factura QR",
  deseasAbonarEstaFacturaQR: "Voleu abonar aquesta factura QR?",
  abonarFactura: "Abonar factura",

  exportar: "Exportar",
  codigoBarras: "Codi de barres",
  codBarras: "C.Barre",

  // 18/08/24
  listadoTicketRepartidor: "Tickets per repartidor",

  // WALLET
  passbooks: "Passbooks",
  sharePassbooks: "Compartir wallets",
  copyToClipboard: "Copiar al porta-retalls",
  shareViaEmail: "Enviar per e-mail",
  shareViaWhatsapp: "Enviar per Whatsapp",
  copied: "Copiat al porta-retalls",
  selectBusinessForWallet: "Trieu el negoci al qual voleu enviar les Wallets",
  sendMethod: "Mètode d’enviament",
  share: "Enviar",
  sendAndSaveButton: "Sí, enviar i guardar",
  sendAndNoSaveButton: "No, enviar i no guardar",
  titleSaveInfoModalText:
    "La informació del client ha canviat. Voleu guardar aquesta informació?",
  verifyNumberText: "Verifiqueu el telèfon",
  verifyEmailText: "Verifiqueu l’e-mail",
  selectOption: "Seleccioneu una opció",
  clipboardCopied: "Copiat al porta-retalls",
  clipboardFailedToCopy:
    "L’API del porta-retalls no està disponible en aquest navegador.",
  enviarWallet: "Enviar Wallet",
  confirmacionEnvioWallet: "Confirmació d’Enviament de Wallet",
  confirmacionTextoEnviarWallet:
    "Esteu segur que voleu enviar la wallet a tots els clients?",
  mensajeConfirmacion:
    "Aquesta acció no es pot desfer i només s’enviarà als clients que tinguin l’email afegit i un codi de barres.",
  enviar: "Enviar",
  noHayCorreosElectronicos: "No hi ha correus electrònics.",
  ningunClienteConCorreoElectronico:
    "No s’ha trobat cap client amb correu electrònic configurat.",
  clientHasNoBarcode: "El client no té un codi de barres establert.",
  exportarCarta: "Exportar Carta",
  exportarSimplifiedExcel: "Exportar com Excel (Sense capçaleres)",

  // GESTIÓ D’IMPOSTOS
  taxes: "Impostos",
  tax: "Impost",
  gestionImpuestos: "Gestió d’Impostos",
  administracionTiposTasas: "Administració",
  administracionTiposTasasImpositivas: " de tipus i taxes impositives",
  agregarImpuesto: "Afegir Impost",
  taxRate: "Impost Aplicat",
  taxDescription: "Descripció",
  taxType: "Tipus d’Impost",
  taxBoldType: "impostos",
  impuestoAplicadoEsCero: "L’impost aplicat no pot ser menor de ",
  impuestoYaCreado: "Aquest impost ja existeix i no es pot crear novament",

  // IMPORTAR CLIENTS
  previewClientData: "Previsualització de Clients",
  editarCliente: "Editar client",
  importarData: "Importar dades",
  importandoDatos: "Important dades",
  preview: "Previsualitzar",
  importacionRealizada: "Importació realitzada",
  datosImportados: "Les dades s’han importat correctament",
  confirmarImportacion: "Confirmar importació",
  seguroContinuarImportacion:
    "Esteu segur que voleu continuar? Aquesta acció és irreversible",

  // 18/11/24 - Update-Logo
  inserteImagen: "Inseriu una imatge",
  seleccioneArchivoImagen: "Seleccioneu un fitxer d’imatge",
  archivoDemasiadoGrande:
    "El fitxer és massa gran. La mida màxima permesa és de 5MB.",
  dimensionesExcedenLimite:
    "Les dimensions de la imatge superen el límit permès (2000x2000px).",
  mensajeconfirmacion:
    "Esteu a punt de reemplaçar la imatge existent. Voleu guardar?",
  botonGuardar: "Guardar",
  botonCancelar: "Cancel·lar",
  Guardado: "Guardat",
  guardarOvisualizarLogo: "Visualitzar o guardar logo",
  configurarLogoNegocio: "Configurar el logo del negoci",
  seleccionLogo: "Feu clic per seleccionar un logo",
  volver: "Tornar",
  noExisteLogoNegocio: "No existeix cap logo per al negoci.",
  informacion: "Informació: ",
  tamaño: "Mida: ",
  dimensiones: "Dimensions: ",
  restriccionesLogo: "Restriccions del logo:",
  tamañoMaximo: "Mida màx: ",
  dimensionesMaximas: "Dimensions màx: ",

  // 13/12/24 - ProductosNoRelacionados
  mensajeAviso:
    "Esteu segur que voleu generar automàticament els PLUs? Aquest procés generarà un codi per a cada producte i tarifa no configurats i es guardarà automàticament.",
  mensajeAvisoSubProducto:
    "Esteu segur que voleu generar automàticament els PLUs? Aquest procés generarà un codi per a cada matèria primera no configurada i es guardarà automàticament.",
  generarPlu: "Generar automàticament PLUs",
  botonAceptar: "Acceptar",
  PLUsGenerados: "¡PLUs generats correctament!",
  errorGenerandoPLUs: "Error en generar els PLUs",

  // 21/01/2025
  nosmudamos: "¡Ens hem traslladat!",
  noscambiamosaselfi:
    "El teu negoci ha fet un gran pas: ara la seva carta forma part de la família Selfibar. A partir d’ara, totes les configuracions i gestions relatives a la carta es podran realitzar directament a Selfibar.",
  esteNegocioEsSelfi: "Aquest negoci és Selfibar",
  paraContinuar:
    "Per continuar, fes clic a Selfibar i accedeix al teu compte amb usuari i contrasenya",
  irASelfibar: "Anar a Selfibar",
  barcodeUnico: "Codi de barres únic",
  barcodeNecesarioSeActualizara:
    "El codi de barres és necessari per a aquesta acció i s’actualitzarà per aquest client en enviar o copiar al porta-retalls.",
  emailenviado: "Email enviat",

  // ListadomateriaPrima-Proveedor
  // 14/01/25
  verListado: "Llistat matèries primeres",
  listadoMateriaPrimaProveedor: "Llistat matèria primera per proveïdor",
  noTiene: "No té ",
  esteProveedor: " aquest proveïdor",
  precioAcordado: "Preu acordat amb proveïdor",
  porcentajeAcordado: "Percentatge acordat ",
  filtrarPorEtiqueta: "Filtrar per etiqueta: ",
  precioAcordadoGuardadoCorrectamente: "Preu fixat. Guardat correctament!",
  fijarprecio: "Fixar preu ",
  preciofijado: "(Fixar el preu de la matèria primera)",
  mensajePrecioFijado: "El preu de la matèria primera és de  ",
  explicacionFijarPrecio:
    "En activar-lo, el preu de la matèria primera i el percentatge de descompte es quedaran fixats. En fer una nova despesa ni el preu ni el descompte es veuran modificats.",
  porcentajeAcordado: "Percentatge d’avís",
  porcentajeAcoradoGuardado: "Percentatge acordat. Guardat correctament!",
  losSubproductosSeHanIncrementado:
    "S’ha detectat un increment en el preu de les següents matèries primeres respecte al percentatge acordat amb el proveïdor",
  errorverificar: "Error en verificar",
  mensajeErrorVerificarTodo:
    "S’ha detectat en les següents despeses un increment en el preu de la matèria primera respecte al percentatge acordat amb el proveïdor",
  explicacionPorcentajeAcordado:
    "Aquest és el percentatge acordat amb el proveïdor per al control del preu de les matèries primeres a l’hora de realitzar una despesa.",
  generarBusinessHash: "Generar URL per a operaris",
  enlaceFicharTurnosOperario: "Accés per fitxar i consultar torns",
  enlaceFicharTurnosOperarioDescripcion:
    "Els treballadors del negoci podran iniciar sessió amb les mateixes credencials que al TPV per registrar l’inici i fi del seu torn, així com consultar els últims 14 torns realitzats amb els seus temps.",

  // KIOSKOS
  kioskos: "Kiosks",
  stockBreak: "Ruptura d’estoc",
  kiosksMenu: "Kiosks carta",
  barcode: "BARCODE",

  sort: "Ordenar",
  productSorted: "Producte ordenat correctament",
  subproductSorted: "Matèria primera ordenada correctament",
  categorySorted: "Categoria ordenada correctament",

  saldoAnterior: "SALDO ANT.",
  saldoActual: "SALDO ACTUAL",

  // 31/01/2025
  guardarOreplicar:
    "Aquest producte està en una carta. Voleu guardar els canvis del producte o guardar-los i replicar-los a la carta?",
  guardarYreplicar: "Guardar i replicar a carta",
  CrearProductoEnCarta: "Guardar i Crear producte a carta",
  tienesProductosSinActualizar:
    "Teniu productes i/o matèries primeres a la carta sense relacionar o de baixa al TPV",
  porFavorDirijaseADiagnosticoParaActualizar:
    "Si us plau, dirigiu-vos a Carta digital > Configuració Carta > Diagnosis > Diagnòstic per revisar els productes i matèries primeres pendents d’actualització",
  irAdiagnosis: "Anar a Diagnosis",
  realizarDespues: "Fer després",
  actualizarProductos: "Queden per revisar ",
  activoEnCarta: "Actiu a carta",
  activoEnTPV: "Actiu a TPV",
  relacionarProducto: "Relacionar producte carta amb TPV",
  editarProductoCarta: "Editar producte carta",
  editarProductoTpv: "Editar producte TPV",
  editarMateriaPrimaCarta: "Editar matèria primera carta",
  editarMateriaPrimaTpv: "Editar matèria primera TPV",
  sinErroresProductos:
    "No s’han trobat possibles errors amb els productes a la carta ",
  sinErroresMateriasPrimas:
    "No s’han trobat possibles errors amb les matèries primeres a la carta ",

  // Sinqro refactor
  seleccionePrecioAgenciaSinqro: "Preu de l’agència que voleu sincronitzar",
  iniciandoImportacion: "Iniciant importació",
  limpiandoSinqro: "Eliminant registres de Sinqro",
  obteniendoCategorias: "Obtenint categories",
  obteniendoProductos: "Obtenint productes",
  obteniendoSubproductos: "Obtenint subproductes",
  sincronizandoConSinqro: "Sincronitzant amb Sinqro",
  finalizandoSincro: "Finalitzant sincronització",
  errorSincronizacion: "Error en sincronitzar amb Sinqro",
  estamosTrabajandoEnEllo: "Estem treballant en això, espereu si us plau...",
  creandoCategoriasSinqro: "Creant categories a Sinqro",
  errorSincronizacionPruebeOtraVez:
    "Error en sincronitzar amb Sinqro. Si us plau, torneu-ho a intentar.",
  losentimos: "Ho sentim!",
  estamosPreparandoTuCarta: "Estem preparant la vostra carta",
  borrandoCartasObsoletas: "Eliminant cartes obsoletes",
  creandoCarta: "Creant carta a Sinqro",
  ultimoPasoCasiTerminado: "Últim pas, ja estem acabant",

  exportarPdfSinDesglose: "Exportar com PDF (Sense Desglossar)",
  exportarPdfConDesglose: "Exportar com PDF (Desglossat)",
  exportarExcelSinDesglose: "Exportar com Excel (Sense Desglossar)",
  exportarExcelConDesglose: "Exportar com Excel (Desglossat)",

  // 14/07/2025
  replicarPLUs: "Replicar PLUs",
  pluReplicadosExitosamente: "PLUs replicats amb èxit",
  replicarPLUPRod: "Replicar PLUs de productes en TPVs",
  replicarPLUSubPRod: "Replicar PLUs de matèries primeres en TPVs",
  replicarPLUsaBusinesses: "Replicar PLUs de productes en negocis",
  replicarPLUaBusinesses: "Replicar PLU de matèries primeres en negocis",
  noSeActualizoNingunProducto: "No s’ha actualitzat cap producte",
  productosActualizadosCorrectamente: "Producte actualitzat correctament",

  importarExcelTarjetas: "Importar Excel Targetes",
  importarTarjetas: "Importar Targetes",
  editarTarjeta: "Editar Targeta",
  previewTarjetasData: "Previsualització de Targetes",

  estaSeguroPLU: "Esteu segur de voler replicar el PLU?",
  conEstaAcciónPLU:
    "Amb aquesta acció, el PLU es replicarà en tots els negocis seleccionats.",

  porDiaNatural: "per dia natural",
  actualizados: "Actualitzats",
  conErrores: "Amb Errors",
  estasSeguro: "Esteu segur?",
  conEstaAccionPLUTpvs:
    "Amb aquesta acció, el PLU es replicarà en tots els TPVs relacionats amb aquest negoci",
  advertenciaPLUTexto1Prod:
    "Aquest procés de replicació de PLUs entre negocis utilitza el nom del producte per al seu funcionament.",
  advertenciaPLUTexto2Prod:
    "Si hi ha noms duplicats en productes, aquest procés no es podrà realitzar per a ells.",
  advertenciaSubPLUTexto1:
    "Aquest procés de replicació de PLUs de matèries primeres utilitza el nom de la matèria primera per al seu funcionament.",
  advertenciaSubPLUTexto2:
    "Si hi ha noms duplicats en matèries primeres, aquest procés no es podrà realitzar per a ells.",

  advertenciaPLUsDuplicadosProductos:
    "⚠️ Els PLUs dels productes amb noms duplicats no s’han pogut replicar perquè el nom s’utilitza com a referència en aquest procés.",
  advertenciaPLUsDuplicadosSubproductos:
    "⚠️ Els PLUs dels subproductes amb noms duplicats no s’han pogut replicar perquè el nom s’utilitza com a referència en aquest procés.",

  productosActualizadosResumen: "Productes Actualitzats",
  productosNoEncontradosResumen: "Productes No Trobat",
  productosSinCambiosResumen: "Productes Sense Canvis",

  subproductosActualizadosResumen: "Subproductes Actualitzats",
  subproductosNoEncontradosResumen: "Subproductes No Trobat",
  subproductosSinCambiosResumen: "Subproductes Sense Canvis",

  seRepite: "es repeteix",

  ordenarProductosAlfabeticamenteDesc:
    "Ordenar productes alfabèticament de forma ascendent.",
  ordenarMateriasPrimasAlfabeticamenteDesc:
    "Ordenar matèries primeres alfabèticament de forma ascendent.",
  configurarFechaCaducidadFacturas: "Data de venciment de FACTURES QR",
  configurarFechaCaducidadFacturasDesc:
    "Configura el temps que tindran els clients per abonar les FACTURES QR abans que venci.",
  configurarLogoNegocioDesc:
    "Configura el logo del negoci que es mostrarà a les factures.",
  cambiarPreciosAProductosDesc: "Canviar preus a productes de forma massiva.",
  calcularCostoProductos: "Cost dels productes",
  calcularCostoProductosDesc: "Calcular el cost dels productes per TPV.",
  gestionAvanzadaHerramientas: "Gestió avançada d’eines",
  gestionAvanzadaHerramientasDesc:
    "Configuració avançada d’impressores, categories i monitor de cuina per al teu negoci.",
  hora: "Hora",
  cancelaciones: "Cancel·lacions",
  totalNeto: "Total Net",
  identificadorPostit: "Identificador Post-it",

  // VentasNegocios internationalization
  totalMesasPostit: "Total Taules de Post-it",
  noHayVentasDisponibles: "No hi ha vendes disponibles per al pla seleccionat",
  intentaSeleccionarOtroPlano:
    "Intenta seleccionar un altre pla o verifica les dades del període seleccionat",
  loSentimos: "Ho sentim",
  esteNegocioNoCuentaConModulo: "Aquest negoci no té aquest mòdul activat",
  mesasDePostit: "Taules de Post-it",
  totalConsolidado: "Total Consolidat",
  totalMesa: "Total Taula",
  pagosaldo: "Pagament saldo",
  desgloseVentasPorMesasHoras: "Desglossament de Vendes per Taules i Hores",

  configurar: "Configurar",
  configurarLogoFacturas: "Logo de factures",
  configurarFechaDeVencimientoDeFacturas:
    "Configurar data de venciment de factures",
  introduzcaElNumeroDeDiasEnElQueVenceranLasFacturas:
    "Introduïu el número de dies en què venciran les factures.",
  datoInformativo:
    "Aquesta data no tindrà efecte a nivell de sistema, és simplement informativa per al client.",
  calcularCostoDeTodosLosProductos: "Calcular cost de tots els productes",

  // Business Central
  summary: "Resum de baixes de productes",
  productDowngrades: "S’han trobat baixes en productes",
  subproductDowngrades: "S’han trobat baixes en matèries primeres",
  totalDowngrades: "Total de baixes",
  totalAffectedRecipes: "Total de receptes afectades",
  downgradedProducts: "Productes donats de baixa",
  downgradedSubproducts: "Matèries primeres donades de baixa",
  noRecipesAffected: "No hi ha receptes afectades",

  actualizar: "Actualitzar",
  crear: "Crear",
  terminar: "Finalitzar",

  departamentosSeleccionados: "Departaments seleccionats",

  seleccionarProducto: "Seleccionar\nproducte",
  seleccionarDepartamentos: "Seleccionar\ndepartaments",
  completarCampos: "Completar\ncamps",
  asignarMateriasPrimas: "Assignar matèries primeres",
  seleccionaMateriasPrimasBusinessCentralAlertInfo:
    "Aquesta és la llista de matèries primeres venables de Business Central pendents de crear o actualitzar a Numier. Selecciona la matèria primera de la llista per continuar. <strong>Tens {PRODUCT_LIST_LENGTH} matèries primeres pendents.</strong>",
  seleccionaProductosBusinessCentralAlertInfo:
    "Aquesta és la llista de productes de Business Central pendents de crear o actualitzar a Numier. Selecciona el producte de la llista per continuar. <strong>Tens {PRODUCT_LIST_LENGTH} productes pendents.</strong>",
  seleccionaDepartamentosBusinessCentralAlertInfo:
    "<strong>On ha d’estar disponible el producte {PRODUCT_NAME}?</strong> Selecciona els departaments on vols que estigui disponible el producte {PRODUCT_NAME}.",
  completarCamposProductosBusinessCentralAlertInfo:
    "A continuació <strong>completa els camps i tarifes</strong> de {PRODUCT_NAME}.",
  asignarMateriasPrimasProductosBusinessCentralAlertInfo:
    "S’han detectat les següents matèries primeres per a <strong>{PRODUCT_NAME}</strong>. Aquestes s’afegiran automàticament al producte en finalitzar el procés.",
  estasMateriasPrimasSeAnadiranAlProducto:
    "Aquestes matèries primeres s’afegiran automàticament al producte en finalitzar el procés.",
  completarTarifasBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME} pot tenir diferents categories, IVA i preus depenent del departament</strong>. Per exemple, un preu de 2,50€ per la Tarifa 1 al Departament 1 i 3,00€ al Departament 2. Si està marcat el checkbox de replicar valors i introdueixes un valor, es completarà tota la columna amb aquest valor.",
  CategoriayTarifasPorDepartamento: "Categoria, IVA i Tarifes per departament",
  replicarValoresTarifasEnTodaLaColumnaCheckbox:
    "Replicar valors de Tarifa a tota la columna",
  sincronizado: "sincronitzat",
  swalSalirFromProductosBusinessCentralTitle: "Abans de continuar...",
  swalSalirFromProductosBusinessCentralText:
    "Si surts ara, perdràs el teu progrés actual.",
  swalSalirFromProductosBusinessCentralButtonConfirm: "Sí, sortir",
  swalCamposObligatoriosFromProductosBusinessCentralText:
    "Has de completar tots els camps marcats amb *",
  swalNombreProductoObligatorioFromProductosBusinessCentralText:
    "Nom del producte",
  swalColorObligatorioFromProductosBusinessCentralText: "Color del botó",
  swalCategoriaObligatorioFromProductosBusinessCentralText:
    "Categoria en cada departament",
  swalTipoIvaObligatorioFromProductosBusinessCentralText:
    "IVA en cada departament",
  noPuedenCoincidirLosValoresDeLosCodigosDeBarrasEntreDiferentesFormatos:
    "Els valors dels codis de barres no poden coincidir entre diferents formats.",
  swalProductoSincronizadoTitle: "Product sincronitzat!",
  swalProductoSincronizadoTextNPendientes:
    "Vols continuar sincronitzant productes o prefereixes acabar ara?",
  swalProductoSincronizadoText0Pendientes:
    "Tots els productes han estat sincronitzats.",
  swalProductoSincronizadoButtonSeguir: "Continuar sincronitzant",
  swalProductoSincronizadoButtonTerminar: "Acabar",
  swalProductoActualizadoTitle: "Product actualitzat!",
  swalProductoActualizadoText0Pendientes:
    "Tots els productes han estat actualitzats.",
  swalSuplementoTarifa1ObligatoriaFromProductosBusinessCentralText:
    'Falta preu de SUPLEMENT (Tarifa 1) al departament/TPV "{tpv}".',

  modalUnidadesMedidaTitle: "ℹ️ IMPORTANT",
  modalUnidadesMedidaTextIntro:
    "{PRODUCT_NAME} té {UD_COUNT} unitats de mesura a Business Central ({UD_LIST}). Hi ha 2 opcions:",
  modalUnidadesMedidaOpcionMultiples:
    "🔹 Crear {UD_COUNT} productes → Ideal si són matèries primeres diferents (ex: Aigua BOT500ML i Aigua BOT1L són matèries primeres diferents).",
  modalUnidadesMedidaOpcionUnico:
    "🔹 Crear 1 producte i utilitzar fins a 4 tarifes → Millor si és la mateixa matèria primera amb diferents quantitats (ex: utilitzar tarifes 'Tapa' i 'Ració' d'Ensaladilla).",
  modalUnidadesMedidaRecomendacion:
    "Recomanació: Si és la mateixa base (ex: Ensaladilla en diferents quantitats), utilitza 1 producte. Si són matèries primeres diferents, crea {UD_COUNT} productes.",
  modalUnidadesMedidaButtonMultiples: "Crear {UD_COUNT} productes",
  modalUnidadesMedidaButtonUnico: "Crear 1 producte",

  modalConfirmarDatosTitle: "ℹ️ CONFIRMA LES DADES DEL PRODUCTE",
  modalConfirmarDatosIntro:
    "{PRODUCT_NAME} ja s'havia sincronitzat i guardat a Numier, però ha estat modificat a Business Central.",
  modalConfirmarDatosExplicacion:
    "A continuació, carregarem al formulari les dades que tenim a Numier d'aquest producte perquè confirmis i facis clic a continuar si són correctes.",
  continuar: "Continuar",

  cargandoListaProductos: "Carregant llista de productes...",
  seHaDetectadoCambioUdmEsNecesarioActualizarPorFormato: "S'ha detectat un canvi en les unitats de mesura. Cal actualitzar els preus per format per a aquesta nova unitat de mesura.",
  productoYaCreadoMateriasPrimasIguales: "El producte ja existe en Numier, per tant les matèries primeres seran les mateixes.",
  seHanDetectadoMasUdmQueSoportaNumierSeCrearanProductosIndividuales: "S'han detectat més unitats de mesura al Business Central de les que suporta Numier. Es crearan productes individuals per a cada unitat de mesura.",
  error: "Error",
  serverError: "Hi ha hagut un problema en comunicar-se amb el servidor",
  errorRecetasBC:
    "No s'han pogut obtenir les receptes des de Business Central.",
  erroresAddTipoMateriaPrima: "Has de triar el tipus de cada matèria primera.",
  erroresAddTodasMateriasPrimas: "Has d’afegir totes les matèries primeres",
  redirigidoIntegracionesBC:
    "T'hem redirigit al punt de partida per confirmar que l'empresa seleccionada és la correcta.",
  redirigidoFaltanDatos:
    "Has estat redirigit perquè faltaven dades necessàries.",
  unknownProduct: "Producte desconegut",

  // BussinessCentral MateriasPrimas
  nombreMateriaPrima: "Nom de la Matèria Primera",
  descripcion: "Descripció",
  codigoDeBarra: "Codi de Barres",
  seleccionaCategoria: "Selecciona una Categoria",
  seleccionaTipo: "Selecciona un Tipus",
  precioCompraSinIva: "Preu de Compra (sense IVA)",
  baja: "Baixa",
  escandallo: "Escandall",
  quieresSeguirSincronizando: "Vols continuar sincronitzant?",
  seguirSincronizando: "Continuar sincronitzant",
  seleccionar: "Seleccionar",
  materiaPrimaGuardada: "Matèria primera guardada correctament",
  seleccionarMateriaPrima: "Seleccionar\nmatèria primera",
  completarCamposMateriaPrima: "Completar\ncamp i assignar\nmatèries primeres",
  queQuieresHacerAhora: "Vols continuar sincronitzant matèries primeres?",
  seguirEditando: "Continuar editant",
  materiaPrimaSincronizadaCorrectamente:
    "Matèria primera sincronitzada correctament",
  estaMateriaPrimaTieneMateriasPrimasRelacionadasAlertInfo:
    "La matèria primera <strong>{MATERIA_PRIMA_NAME}</strong> té altres matèries primeres associades. Afegeix-les per completar la sincronització.",
  finalizar: "Finalitzar",
  seleccionaLosDepartamentos: "Selecciona els departaments",
  noHayEtiquetasTPV: "No hi ha etiquetes per a aquest TPV",
  aniadir: "Afegir",
  aniadirTodas: "Afegir totes",
  listo: "llest",
  errorDesconocido: "Error desconegut",
  nombreMateriaPrimaObligatorio: "El nom de la matèria primera és obligatori.",
  submateriasPrimasObligatorio: "Has d’afegir totes les submatèries primeres.",

  actualizacionMateriaPrima: "Actualització de Matèria Primera",
  mensajeCambioMateriaPrimaInfo:
    "S'han detectat canvis en aquesta matèria primera des de Business Central.",
  antesContinuarMateriaPrimaInfo:
    "Abans de continuar, revisa els departaments en què aquesta matèria primera ha d'estar disponible, per si hi ha hagut canvis.",
  accionNecesariaMateriaPrimaInfo:
    "És necessari realitzar aquesta acció per mantenir la informació actualitzada correctament.",
  entendido: "Entès",
  noVolverAMostrarEsteAviso: "No tornar a mostrar aquest avís",
  cerrarYNoVolverAMostrar: "Tancar i no tornar a mostrar",
  preferenciasGuardadas: "Preferències desades correctament",
  errorAlGuardarPreferencias: "Error en desar les preferències",
  seleccioneCategoria: "Seleccioneu categoria...",

  bajasDeProductos: "Baixes de productes",

  // Formulario combinado de productos
  precioRequerido: "Preu requerit",
  introduzcaPrecio: "Introdueix el preu del suplement",
  errorValidandoCodigosBarras: "Error validant codis de barres",
  asignaPreciosMateriasPrimas: "Assigna preus a les matèries primeres",
  rateNameRequired: "És obligatori indicar el nom de la tarifa núm.: ",
  categoryRequiredForDept: "És obligatori seleccionar una categoria per al departament: ",
  validationError: "Error de validació dels camps",
  pleaseFillRequiredFields: "Si us plau, completeu tots els camps obligatoris.",
  configuracionPorDepartamento: "Configuració per departament",
  productoNormal: "Producte Normal",
  productoCON: "Producte AMB",
  productoSUPL: "Producte SUPL",
  esProductoCON: "És producte AMB",
  esProductoSUPL: "És producte SUPL",
  categoriaNormal: "Normal",
  categoriaCON: "AMB",
  categoriaSUPL: "SUPL",
  suplemento: "SUPLEMENT",
  mensajeProductoCON:
    "Esteu creant un producte AMB. Se generaran 2 productes: un normal i un AMB.",
  mensajeProductoSUPL:
    "Esteu creant un producte SUPL. Se generaran 2 productes: un normal i un SUPL.",
  mensajeProductosCONySUPL:
    "Esteu creant productes AMB i SUPL. Se generaran 3 productes: un normal, un AMB i un SUPL.",
  completeCamposObligatorios: "Si us plau, ompliu tots els camps obligatoris.",
  completeNombreProductoCON:
    "Si us plau, introduïu el nom per al producte AMB.",
  completeNombreProductoSUPL:
    "Si us plau, introduïu el nom per al producte SUPL.",
  productosGuardadosCorrectamente: "Els productes s'han desat correctament.",
  errorAlGuardarProductos: "S'ha produït un error en desar els productes.",

  dataNegocioVisualizar: "Departaments",
  formaPagoFiltrado: "Filtrar per forma de pagament",
  fechaExportacionDisponible: "Data d'exportació detectada",
  todasLasFormasPago: "Totes les formes de pagament",
  seleccioneSubtipoFormaPago:
    "Si us plau, seleccioneu una forma de pagament específica (com Visa, Mastercard o el tipus de xec).",
  noCambiosFormaPago: "No s'han realitzat canvis en la forma de pagament",
  finalizarProcesoActualizar:
    "Finalitzar procés d'actualització de matèria primera",
  actualizarFinalizarText:
    "Per completar el procés i actualitzar correctament la matèria primera, fes clic al botó 'Actualitzar i finalitzar' a continuació.",
  cambiosDepartamentosMateriaPrimaInfo:
    "Si s'han realitzat canvis en els departaments on aquesta matèria primera ha d'estar activa, aquests canvis s'aplicaran automàticament durant l'actualització.",
  actualizarFinalizar: "Actualitzar i finalitzar",
  verDetallesFormaPago: "Veure detalls de la forma de pagament",
  detallesFormaPago: "Detalls de la forma de pagament",
  formaDePago: "Forma de pagament",
  medioDePago: "Mitjà de pagament",
  medioPagoFiltrado: "Filtrar per mitjà de pagament",
  advertenciaExportacionVentas: "Advertència sobre l'exportació de vendes",
  seExportaranTodosLosDepartamentos:
    "S'exportaran les vendes de TOTS els departaments",
  advertenciaExportacionTodosLosDepartamentos:
    "En continuar, s'exportaran les vendes de tots els departaments, incloent les seves respectives formes de pagament, no només del departament actual.",
  noHayVueltaAtras: "Un cop realitzada l'exportació, no es podrà desfer.",
  reviseYEditeFormasPagoAntes:
    "Revisa i edita les formes de pagament abans de continuar.",
  eleccionModoExportacion: "El mode d’exportació només determina si les vendes s’envien per lots o totes juntes. En qualsevol cas, s’enviaran les vendes de tots els punts de venda.",
  estaSeguroDeExportar: "Estàs segur que vols continuar amb l'exportació?",
  todosLosMediosPago: "Tots els mitjans de pagament",
  tpv: "TPV",
  department: "Departament",
  productoEspecialDetectado: "S'ha detectat un producte especial",
  productoEspecialDetectadoMensaje: "S'ha detectat un producte especial.",
  seCrearanTresProductos: "Es crearan {cantidad} productes a Numier: un de normal, un AMB i un SUPLEMENT.",
  seCrearanDosProductosCon: "Es crearan {cantidad} productes a Numier: un de normal i un AMB.",
  seCrearanDosProductosSuplemento: "Es crearan {cantidad} productes a Numier: un de normal i un SUPLEMENT.",
  relleneFormularios: "Si us plau, ompliu els formularis corresponents a continuació.",
  categoriaEnlazada: "Categoria enllaçada",
  dadoDeBaja: "Donat de baixa",
  refrescar: "Refrescar",
  errorAlRefrescar: "No s'han pogut actualitzar les dades. Torna-ho a provar.",
  sinPermisoExportacionBC: "No tens permís per accedir a l'exportació de vendes a Business Central. Parla amb el teu administrador.",
  productoDeBajaTitulo: "Producte donat de baixa",
  productoDeBajaTexto: "Aquest producte està donat de baixa i no es pot afegir com a plat del menú. Activa'l a Business Central i torna a sincronitzar: Numier el reactivarà en la següent sincronització.",
  categoriaFijadaPorTipo: "La fixa el tipus {TIPO}",
  categoriaFijadaPorTipoAviso: "La categoria no es pot triar: un {TIPO} es crea sempre a la categoria que té al negoci d'origen. Si no existeix al destí, es crea.",
  sinNegociosParaReplicar: "No hi ha cap altre negoci disponible per replicar aquest producte.",
  negocioSinCategorias: "Sense categories creades",
  resultadoReplicacion: "Resultat de la replicació",
  replicados: "Replicats",
  replicaFamiliaAviso: "Aquest producte forma família. Es replicaran:",
  replicaTipoDetectado: "Tipus de producte detectat:",
  productosPorNegocio: "productes per negoci",
  faltaCategoriaEnNegocios: "Selecciona una categoria en aquests negocis:",
  seleccionaAlMenosUnNegocio: "Selecciona almenys un negoci.",
  seleccionaPreviamenteCategoria: "Selecciona prèviament una categoria",

  // Producto solo con/suplemento
  crearProductoSinNormal: "Crear producte normal com a inactiu",
  crearProductoSinNormalExplicacion: "Si actives aquesta opció, el producte normal es crearà però amb estat 'baixa' (inactiu). Això és útil quan el producte només té sentit vendre'l com a AMB o SUPLEMENT, ja que no es vendrà com a producte individual per si sol. Només serà visible al TPV si l'actives manualment.",
  crearProductoSinNormalDetalle: "El producte normal sempre es crearà, però amb aquesta opció marcada apareixerà desactivat. Els productes AMB i SUPLEMENT estaran actius per al seu ús immediat.",
  crearProductoSinNormalImportante: "IMPORTANT: Hauràs de seleccionar una categoria obligatòriament abans de marcar aquesta casella, ja que es requereix per mantenir la integritat de les dades encara que el producte estigui inactiu.",
  productoNormalOculto: "Producte normal ocult",
  productoNormalOcultoExplicacion: "Aquest formulari està ocult perquè el producte normal es crearà com a inactiu",
  activarProducto: "Activar producte",

  // Business Central - Exportació de vendes
  exportacionVentasBC: "Exportar vendes",
  noHayDiasParaExportar: "No hi ha dies per exportar",
  dailyExportCardTitle: "Exportació diària de vendes",
  dailyExportCardSubtitle: "Revisa les vendes i exporta-les a Business Central",
  todoExportadoCorrectamente:
    "Totes les vendes s'han exportat correctament o no hi ha vendes per a aquest departament.",
  hayVentasPendientesExportar: "Hi ha vendes pendents d'exportar.",
  debesExportarPrimeroDiasAnteriores:
    "Has d'exportar primer els dies anteriors per mantenir la correlativitat.",
  fechaExportacion: "Data d'exportació",
  formapago: "Forma de pagament",
  noPuedeCambiarFechaSinExportarPrimero:
    "No es pot exportar una nova data sense abans exportar el dia més antic pendent.",
  trabajador: "Treballador",
  exportData: "Exportar vendes",
  exportacionExitosa: "L'exportació s'ha realitzat amb èxit",
  errorExportarDatos: "Error en exportar les dades",
  falloExportarDatos: "Fallo al exportar les dades",
  exportacionRealizada: "Exportació realitzada",
  exportacionRealizadaParcial: "Exportació realitzada parcialment",
  exportacionExitosaConErrores: "Exportació realitzada amb èxit amb alguns errors",
  editarFormaPago: "Editar forma de pagament",
  noExistenDatosNoPudieronCargar: "No hi ha dades o no es van poder carregar",
  mensajeEfectivoSeleccionado:
    "S'ha seleccionat efectiu com a forma de pagament. No cal indicar més detalls.",
  guardarFormaPago: "Desar forma de pagament",
  tipoFormaPago: "Tipus de forma de pagament",
  seleccioneUnTipo: "Seleccioneu un tipus",
  formaPagoTarjeta: "Forma de pagament amb targeta",
  formaPagoCheque: "Forma de pagament amb xec",
  updatePagoCorrecto: "Forma de pagament actualitzada correctament",
  noSePudoActualizarFormaPago: "No s'ha pogut actualitzar la forma de pagament",
  errorAlGuardarFormaPago: "Error en desar la forma de pagament",
  noHayVentasConEstaFormaPago: "No hi ha vendes amb aquesta forma de pagament",
  formaPagoNoEncontrada:
    "Forma de pagament no detectada per a aquest departament",
  totalCash: "Total efectiu",
  totalCard: "Total targeta",
  totalCheque: "Total xec",
  totalPagosaldo: "Total pagament saldo",
  totalAvanzado: "Total avançat",
  avanzadoEfectivo: "Avançat efectiu",
  avanzadoTarjeta: "Avançat targeta",
  avanzadoCheque: "Avançat xec",
  avanzadoPagosaldo: "Avançat pagament saldo",
  avanzadoOtros: "Avançat altres",
  cashPaymentMethod: "Forma de pagament efectiu",
  cardPaymentMethod: "Forma de pagament targeta",
  chequePaymentMethod: "Forma de pagament xec",
  importeTotal: "Import total",
  sinDatos: "SENSE DADES",

  // Integración Business Central > Business Central
  businessCentral: "Business Central",
  sincronizacionBusinessCentralSubtitle:
    "Sincronització de productes, departaments i més en temps real",
  sincronizaMateriasPrimasBusinessCentralSubtitle:
    "Tens <strong>{MATERIAS_PRIMAS_LENGTH}</strong> matèries primeres pendents de actualitzar",
  noHayParaActualizar: "No hi ha res pendent d’actualitzar o sincronitzar",
  obteniendoDatos: "Obtenint dades...",
  relacionesProcesadas: "Relacions processades",
  exportacionDeshabilitada: "Exportació deshabilitada",
  sincronizaProductosBusinessCentralSubtitle:
    "Tens <strong>{NUMERO_PRODUCTOS_PENDIENTES}</strong> productes pendents de sincronitzar",
  sincronizaFormasDePagoBusinessCentralSubtitle:
    "Tens <strong>{NUMERO_FORMAS_PAGO_PENDIENTES}</strong> formes de pagament pendents de sincronitzar",
  productoFormCompleto: {
    info: "Editant producte: {productName}",
  },
  completaProductosBussinessCentralSubtitle:
    "Completa primer la sincronització de les matèries primeres per començar amb els productes ",

  seleccionaMateriaPrimaBusinessCentralAlertInfo:
    "Aquesta és la llista de matèries primeres de Business Central pendents de crear o actualitzar a Numier. Selecciona la matèria primera de la llista per continuar. <strong>Tens {PRODUCT_LIST_LENGTH} matèries primeres pendents.</strong>",
  seleccionaDepartamentosMateriasPrimasBusinessCentralAlertInfo:
    "<strong>On ha d'estar disponible la matèria primera {PRODUCT_NAME}?</strong> Selecciona els departaments on vols que estigui disponible {PRODUCT_NAME}.",
  completarCamposMateriasPrimasBusinessCentralAlertInfo:
    "Per finalitzar, completa els camps de {PRODUCT_NAME}.",
  materiaPrimaDisabledByPendingsChildrenTooltip:
    "Aquesta matèria primera és una recepta cuyas matèries primeres encara estan pendents de sincronitzar.",

  swalMateriaPrimaSincronizadaTitle: "Matèria primera sincronitzada!",
  swalMateriaPrimaSincronizadaTextNPendientes:
    "Vols continuar sincronitzant matèries primeres o prefereixes acabar ara?",
  swalMateriaPrimaSincronizadaText0Pendientes:
    "Totes les matèries primeres han estat sincronitzades.",
  swalMateriaPrimaSincronizadaButtonSeguir: "Continuar sincronitzant",
  swalMateriaPrimaActualizadaTitle: "Matèria primera actualitzada!",
  swalMateriaPrimaActualizadaText0Pendientes:
    "Totes les matèries primeres han estat actualitzades.",

  // Integración Business Central > Empty entidades pendientes
  esteNegocioNoTieneProductosParaSincronizar:
    "Tots els productes sincronitzats",

  // Integración Business Central > Formas de pago
  formasDePagoBC: "Formes de pagament",
  swalTipoObligatorioFormasDePago:
    "Has de seleccionar un tipus per a cada forma de pagament abans de finalitzar.",
  formasDePagoBusinessCentralAlertInfo:
    "Relaciona les formes de pagament de Business Central amb les formes de pagament (tipus) Efectiu, Targeta o Xec de Numier. <strong>Només es pot seleccionar un únic tipus com a Efectiu, la resta com Targeta i Xec.</strong>",
  noHayFormasDePagoPorConfigurar:
    "No hi ha formes de pagament pendents de configurar.",
  formasDePagoConfiguradasCorrectamente:
    "Totes les formes de pagament han estat establertes correctament.",
  formaPagoGuardada: "¡Formes de pagament desades!",
  todasFormasPagoConfiguradas:
    "Totes les formes de pagament han estat configurades",
  formasPagoDarDeBajaMensaje:
    "Les següents formes de pagament s'han de donar de baixa a Numier perquè ja no estan disponibles al sistema Business Central",
  pulsaDarDeBaja: "Prem a donar de baixa per confirmar",
  darDeBaja: "Donar de baixa",
  dandoDeBajaFormasPago: "Donant de baixa formes de pagament...",
  formasPagoDadasDeBaja: "Formes de pagament donades de baixa correctament.",
  errorDarDeBajaFormasPago: "Error al donar de baixa les formes de pagament.",
  errorServidorDarDeBaja:
    "Error en comunicar-se amb el servidor al donar de baixa.",

  // Verifactu Dashboard
  verifactu: "VERI*FACTU",
  verifactu2: "Verifactu",
  declaracionesResponsables: "Declaracions responsables",
  conectaNumierConHacienda: "Connecta Numier amb Hisenda en només uns quants clics.",
  solicitar: "Sol·licitar",
  esperandoRespuestaNumier: "Esperant resposta de Numier",
  seleccionarCertificado: "Seleccionar certificat.",
  enviarCertificado: "Enviar certificat.",
  subeTuCertificadoParaConectarConHacienda: "Puja el teu certificat per connectar el teu negoci amb Hisenda.",
  seleccionarArchivo: "Seleccionar fitxer.",
  ustedYaHaGuardadoElCertificadoDigital: "Ja has desat correctament el certificat digital en aquest negoci.",

  paraComenzarVerifactuSeleccionaNegocio: "Per començar amb VERI*FACTU, si us plau <strong>selecciona un negoci</strong> al menú desplegable inferior.",
  bienvenidoA: "Benvingut a",
  verifactuDescripcion: "<strong>Verifactu</strong> és el sistema de l’Agència Estatal d’Administració Tributària (AEAT) que permet la verificació automàtica de factures, garantint-ne l’autenticitat i la integritat davant Hisenda.",
  informacionSobreVerifactu: "Informació sobre VERI*FACTU",

  importanteEmpresasSII: "Important: Empreses adscrites al SII",
  siTuEmpresaEstaAdscritaSII: "Si la teva empresa està adscrita al Sistema de Subministrament Immediat d’Informació (SII), estàs exempta d’utilitzar VERI*FACTU.",
  masInformacionAqui: "Més informació aquí",

  automatizacionInteligente: "Automatització Intel·ligent",
  automatizacionInteligenteDesc: "Verificació automàtica de factures sense intervenció manual. El sistema processa i valida cada document a l’instant.",
  automatizacionInteligenteDetalle: "Estalvia fins a 8 hores setmanals de feina manual",
  automatizacionInteligenteStat: "100% Automàtic",

  cumplimientoNormativo: "Compliment Normatiu",
  cumplimientoNormativoDesc: "Compliment total amb la normativa fiscal. Actualització automàtica segons els canvis legislatius.",
  cumplimientoNormativoDetalle: "Compatible amb totes les regulacions vigents de l’AEAT",
  cumplimientoNormativoStat: "Normatiu AEAT",

  controlDeCalidad: "Control de Qualitat",
  controlDeCalidadDesc: "Elimina errors humans i prevé fraus mitjançant la validació avançada de dades.",
  controlDeCalidadDetalle: "Detecció automàtica d’inconsistències i anomalies",
  controlDeCalidadStat: "-95% Errors",

  seguridadAvanzada: "Seguretat Avançada",
  seguridadAvanzadaDesc: "Màxima protecció en totes les teves transaccions amb xifratge de nivell bancari.",
  seguridadAvanzadaDetalle: "Certificats SSL i autenticació de doble factor",
  seguridadAvanzadaStat: "Xifratge SSL",

  configuracionDeVerifactu: "Configuració de Verifactu",
  paraComenzarNecesitasCertificado: "Per començar a treballar amb VERI*FACTU, has de pujar el teu <strong>certificat digital.</strong>",
  certificadoPermiteAutenticacion: "Aquest certificat permet l’autenticació segura amb l’AEAT.",
  formatosSoportados: "Formats admesos: <code>.pfx</code>, <code>.p12</code>.",
  aunNoTienesCertificado: "Encara no tens certificat digital?",
  puedesObtenerCertificadoEn: "Pots obtenir el teu certificat digital a:",
  fabricaNacionalMonedaTimbre: "Fàbrica Nacional de Moneda i Timbre (FNMT)",
  yaTienesCertificadoListo: "Ja tens el teu certificat digital a punt?",
  hazClickAbrirSelector: "Fes clic aquí per obrir el selector de fitxers.",
  tengoUnCertificado: "Tinc un certificat",
  hazClickSeleccionarCertificado: "Fes clic i selecciona el teu certificat",
  formatosMaximo: "Formats: .pfx, .p12 (màx. 60KB)",
  subirCertificado: "Pujar certificat",
  debeSeleccionarFechaInicioVerifactu: "Has de seleccionar una data d’inici per a VERI*FACTU abans de continuar.",
  porFavorSeleccionaFechaInicioNuevamente: "Se ha trobat un error. Si us plau, selecciona la data d’inici novament.",
  porFavorSeleccionaCertificadoNuevamente: "Si us plau, selecciona el certificat novament.",

  certificadoConfiguradoCorrectamente: "Certificat Configurat Correctament!",
  certificadoValidadoConfigurado: "El teu certificat digital ha estat validat i configurat.",
  certificadoValidoHasta: "Certificat vàlid fins a",
  noSeHaPodidoVerificarFecha: "No s’ha pogut verificar la data de validesa del certificat",
  facturasComplianNormativa: "Les teves factures compliran amb la normativa VERI*FACTU.",
  sistemaListoVerificacion: "Sistema llest per a la verificació automàtica.",
  comoFuncionaVerifactu: "Com funciona VERI*FACTU?",

  generacionAutomatica: "Generació Automàtica",
  generacionAutomaticaDesc: "Les factures es generaran automàticament amb el format i els requisits de VERI*FACTU",

  codigoQRenTickets: "Codi QR als tiquets",
  codigoQRenTicketsDesc: "Cada tiquet de cobrament inclourà un codi QR per verificar la factura a la seu de l’AEAT",

  comprobacionInstantanea: "Comprovació Instantània",
  comprobacionInstantaneaDesc: "L’estat de cada factura pot verificar-se escanejant el QR des de qualsevol dispositiu",

  seguridadGarantizada: "Seguretat Garantida",
  seguridadGarantizadaDesc: "Totes les transaccions queden registrades i protegides amb signatura electrònica avançada",

  contrasenaCertificado: "Contrasenya del Certificat",
  introduceContrasenaDesc: "Si us plau, introdueix la contrasenya del teu certificat digital per poder processar-lo correctament.",
  contrasena: "Contrasenya:",
  introduceContrasenaPlaceholder: "Introdueix la contrasenya del certificat",
  contrasenaRequerida: "La contrasenya és obligatòria",
  procesando: "Processant…",
  continuar: "Continuar",
  cancelar: "Cancel·lar",

  exito: "Èxit",
  seleccionaArchivoAntes: "Si us plau, selecciona un fitxer abans d’enviar.",
  errorNegocioNoValido: "Error: No s’ha seleccionat cap negoci vàlid.",

  // Textos para negocio exento
  negocioExentoVerifactu: "Negoci Exempt de VERI*FACTU",
  negocioRegistradoComoExento: "Aquest negoci està registrat com a exempt de VERI*FACTU.",
  noRequiereVerifactu: "No requereix certificat ni configuració addicional.",
  facturacionNormalContinua: "La teva facturació continuarà funcionant amb normalitat.",
  queSignificaExento: "Què vol dir això?",
  queSignificaExentoDesc: "El teu negoci no necessita complir els requisits de VERI*FACTU. Això pot ser perquè està adscrit al SII o compleix altres criteris d’exempció establerts per la normativa fiscal.",
  siHayAlgunError: "Hi ha hagut algun error?",
  siHayAlgunErrorDesc: "Si creus que aquesta classificació és incorrecta o has tingut algun problema, contacta amb el nostre equip de suport per ajudar-te.",
  noSePudoObtenerIdUsuario: "No s’ha pogut obtenir l’ID d’usuari.",
  verificandoCertificado: "Verificant certificat...",
  certificadoEnviadoCorrectamente: "Certificat enviat correctament",
  respuestaInesperadaServidor: "Resposta inesperada del servidor",

  verifactuError449: "Contrasenya incorrecta o fitxer invàlid.",
  verifactuError552: "S’ha produït un error inesperat. Si us plau, torna-ho a intentar.",
  errorAlEnviarCertificado: "Error en enviar el certificat",
  noSeRecibioRespuestaServidor: "No s’ha rebut resposta del servidor",
  errorDeConfiguracion: "Error de configuració:",
  noSeSeleccionoArchivo: "No s’ha seleccionat cap fitxer.",
  formatoArchivoNoValido: "Format de fitxer no vàlid. Utilitza .pfx o .p12",
  archivoDemasiadoGrande: "El fitxer és massa gran. Mida màxima permesa: 60KB",

  // Selector de fecha de inicio Verifactu
  cuandoDebeComenzarTuNegocio: "Quan ha de començar el teu negoci amb VERI*FACTU?",
  antesDeConfigurarDebesIndicar: "Abans de configurar VERI*FACTU, has d’indicar la data obligatòria d’inici segons el teu tipus de negoci.",
  consultarInformacionOficial: "Consultar informació oficial",
  paraContribuyentesSociedades: "Per a contribuents de l’Impost de Societats",
  restoNegociosAutonomos: "Resta de negocis i autònoms. Per facilitar l’adaptació al nou sistema.",
  miNegocioAdscritoSII: "El meu negoci està adscrit al Sistema d’Informació Immediata",
  estoyExentoSII: "Estic exempt (SII)",
  seleccionar: "Seleccionar",
  fechaInicioSeleccionada: "Data d’inici seleccionada",
  exentoSII: "Exempt (SII)",
  cambiar: "Canviar",
  negocioExentoVerifactu: "Negoci exempt de VERI*FACTU",
  tuNegocioNoRequiereVerifactu: "El teu negoci no requereix configuració de VERI*FACTU en estar adscrit al Sistema d’Informació Immediata (SII).",
  alEstarEnSIINoNecesitas: "En estar al SII, no necessites implementar VERI*FACTU",
  confirmacionExencionSII: "Confirmació d’exempció SII",
  antesDeConfirmar: "Abans de confirmar, assegura’t que:",
  miNegocioEstaAdscritoSistemaInmediato: "El meu negoci està adscrit al Sistema d’Informació Immediata (SII)",
  tengoDocumentacionQueLoAcredita: "Tinc documentació que ho acredita",
  entiendoQueNoDebereUsarVerifactu: "Entenc que no he d’utilitzar VERI*FACTU si estic al SII",
  siNoEstasSegurotConsultaAsesor: "Si no n’estàs segur, consulta amb el teu assessor fiscal",
  confirmarExencion: "Confirmar exempció",
  negocioMarcadoComoExento: "Negoci marcat com a exempt de VERI*FACTU",
  errorAlMarcarExencion: "S’ha produït un error en marcar l’exempció. Si us plau, intenta-ho més tard.",

  certificadoExpiradoAlerta: "<strong>Atenció:</strong> El certificat digital d’aquest negoci ha <strong>expirat</strong>. Has de renovar-lo urgentment per mantenir el compliment amb VERI*FACTU.",
  certificadoProximoExpirarAlerta: "<strong>Avís:</strong> El certificat digital d’aquest negoci està <strong>a punt de vèncer</strong>. Et recomanem renovar-lo aviat per evitar interrupcions.",
  certificadoExpirado: "Certificat Expirat",
  certificadoProximoExpirar: "Certificat a Punt de Vèncer",
  certificadoExpiroEl: "El certificat va expirar el",
  certificadoExpiraEl: "El certificat expira el",
  certificadoYaNoValido: "El certificat digital ja no és vàlid. Cal renovar-lo urgentment.",
  certificadoProntoVencera: "El certificat digital vencerà pròximament. Es recomana renovar-lo com més aviat millor.",
  sinCertificadoNoEsPosibleVerificar: "Sense un certificat vàlid, no és possible fer la verificació automàtica de factures.",
  EsperarAExpiracionPuedeProvocarErrores: "No renovar a temps pot provocar errors en la verificació automàtica.",
  pongaseEnContactoConSoporteParaProceder: "Si es produeix algun error, contacta amb el suport per saber com procedir.",
  renovarCertificado: "Renovar Certificat",

  // unidades de medida dadas de baja
  unidadesMedidaDadasDeBaja: "S’han trobat baixes en productes",
  bajasDeProductos: "Baixes de productes",

  // 21/05/2025 - Listado productos por operario
  listadoDeProductosPorOperario: "Venda de producte per operari",
  listadoProductosOperario: "Venda per operari",

  // 29/10/2025 - Bajas
  bajaEntidades: "Baixes d'entitats",
  checkBajaEntidades: "Consultar i aplicar baixes d'entitats eliminades al Business Central",

  bajaProductos: "Baixes de productes",
  bajaSubproductos: "Baixes de matèries primeres",
  bajaFormasPago: "Baixes de formes de pagament",
  bajaUdMedida: "Baixes d'unitats de mesura",
  bajaLineaProd: "Baixes de línies de producte",

  checkBajaProductos: "Consultar baixes de productes",
  checkBajaSubproductos: "Consultar baixes de matèries primeres",
  checkBajaFormasPago: "Consultar baixes de formes de pagament",
  checkBajaUdMedida: "Consultar baixes d'unitats de mesura",
  checkBajaLineaProd: "Consultar baixes de línies de producte",

  loadingBajaProductos: "Consultant baixes de productes...",
  loadingBajaSubproductos: "Consultant baixes de matèries primeres...",
  loadingBajaFormasPago: "Consultant baixes de formes de pagament...",
  loadingBajaUdMedida: "Consultant baixes d'unitats de mesura...",
  loadingBajaLineaProd: "Consultant baixes de línies de producte...",

  emptyBajaUdMedida: "No s'han trobat unitats de mesura donades de baixa.",
  errorUnidadMedidaNoConfigurada: "No es pot crear el producte perquè no té unitat de mesura configurada des de Business Central.",
  errorUnidadMedidaMateriasPrimas: "Les següents matèries primeres no tenen unitat de mesura configurada des de Business Central",

  configurarVerifactuUrgente: "Numier TPV ja està certificat amb VERI*FACTU",
  debesConfigurarVerifactuAntes15Nov: "Ja ho tenim tot llest per connectar el teu negoci amb <span><i>VERI*FACTU</i></span>.<br />Per fer-ho només necessitem que pugis el teu <strong>certificat digital a cadascun dels teus negocis</strong>, d'aquesta manera, quan arribi la data tindrem la teva versió actualitzada a la nova <strong>normativa obligatòria de l'AEAT</strong>.<br />Si necessites més informació, visita les nostres <i><a href='#/novedades' style='color: #1E22AA; text-decoration: underline; font-weight: 600;'>Novetats</a></i>.",
  subirCertificadoVerifactu: "Puja el certificat <i class='fas fa-file-upload ml-1'></i>",
  verNovedades: "Veure Novetats",
  verifactuAplazadoTitulo: "VERI*FACTU ajornat fins al 2027",
  verifactuAplazadoMensaje: "A causa de l'<strong><a style='text-decoration: underline; font-weight: 600;' href='https://sede.agenciatributaria.gob.es/Sede/iva/sistemas-informaticos-facturacion-verifactu/nota-informativa-ampliacion-plazo-adaptacion-facturacion.html' target='_blank' rel='noopener noreferrer'>ajornament de la normativa VERI*FACTU</a></strong> fins a l'any 2027, tots els certificats digitals allotjats als servidors de <b><i>Numier</i></b> han estat <strong>eliminats</strong> per motius logístics.<br/><br/>Les noves dates d'implementació seran:<br/><strong>• 1 de gener de 2027</strong> per a contribuents i societats.<br/><strong>• 1 de juliol de 2027</strong> per a la resta de negocis i autònoms.<br/><br/>A mesura que s'acosten les noves dates, comunicarem qualsevol <b>novetat</b> o <b>canvi important</b>.",

  verifactuProximoTitulo: "Prepara't per a VERI*FACTU 2027",
  verifactuProximoMensaje: "La data d'implementació de <span><i>VERI*FACTU</i></span> s'acosta. En <strong>gener</strong> i <strong>juliol de 2027</strong> entrarà en vigor la nova normativa obligatòria de facturació electrònica.<br/><br/>Per a garantir el correcte funcionament del teu negoci, és fonamental que <strong>pugis els certificats digitals</strong> a cadascuna de les teves seus al més aviat possible.<br/><br/>Si necessites ajuda, no dubtis en <strong>contactar suport</strong>.",

  errorVariasUdsMedidasProductoConSuplemento:
    "No es pot crear el producte perquè el producte base té diverses unitats de mesura configurades des de Business Central.",

  //17/11/25 Diagnostico PLU
  diagnosticoPLU: "Diagnòstic de PLU",
  todosPluIguales: "Tots els PLU iguals",
  pluDiferentes: "PLU diferent",
  noExiste: "No existeix",
  productoNoDisponible: "Producte no trobat",
  subproductoNoDisponible: "Matèria primera no trobada",
  productoNoEncontrado: "Producte no trobat en aquest negoci",
  coincide: "Mateix PLU",
  noCoincide: "PLU diferent",
  //12/12/25
  tipoRol: "Tipus de rol",

  updatedPaymentMethod: "S'han actualitzat les següents formes de pagament:",
  paymentMethodNameChanged: "El nom de la forma de pagament ha canviat de <strong>{oldName}</strong> a <strong>{newName}</strong>.",
  updatedPaymentMethod: "S'han actualitzat els següents mètodes de pagament:",
  noEsProductoValidoParaMutarProductoConSuple: "Aquest producte no compleix els requisits per poder ser admès com a producte AMB o producte SUPLEMENT.",

  paymentMethodDowngrades: "Se han encontrado bajas en formas de pago",
  downgradedPaymentMethods: "Formas de pago dadas de baja",
  unknownPaymentMethod: "Forma de pago desconocida",
  configuracionRol: "(Aquesta configuració només s'aplica a Numier TORNOS)",
  sinIdDeProducto: "Sense detalls",

  addSupplementPriceTitle: "Definir el preu del suplement",
  addSupplementPriceText: "S'ha detectat que el producte <strong>{PRODUCT_NAME}</strong> ara admet ser suplement, quan anteriorment no ho feia. Per poder finalitzar l'actualització, és necessari especificar la variació de preu que s'aplicarà en seleccionar aquest producte com a suplement. Això s'utilitza per calcular el preu final del producte incloent el suplement.",
  addSupplementPriceInputLabel: "Variació de preu: ",
  productComputedInfo: "S’ha detectat que el producte seleccionat té més d’una unitat de mesura i, alhora, és de tipus AMB o SUPLEMENT, fet que no està permès. Per aquest motiu, s’ignoraran les unitats de mesura i es crearà un producte de tipus amb/suplement. Podeu continuar omplint el formulari o modificar-lo des de Business Central.",
  materiaPrimaComputedInfo:
    "La matèria primera venable seleccionada s'ha detectat amb més d'una unitat de mesura i, alhora, és de tipus CON o SUPLEMENT, cosa que no està permesa. Per tant, s'ignoraran les unitats de mesura i es crearà un producte de tipus con/suplement. Podeu continuar omplint el formulari o modificar-ho des de Business Central.",

  ocultarDTOInvitaciones: "Amagar descomptes i invitacions",

  modalUnidadesMedidaOpcionUnicoMasDeCuatro:
    "⚠️ Atenció → És obligatori crear un producte independent per a cada unitat de mesura, ja que el sistema admet un màxim de 4 tarifes per producte.",

  exportarPorLotesTPV: "Exportar per lots TPV",
  modoExportacion: "Mode d'exportació",
  exportacionNormal: "Exportació normal",
  exportarDatos: "Exportar dades",
  descripcionExportacionNormal: "Exporta totes les vendes juntes en una sola operació",
  descripcionExportacionTPV: "Exporta les vendes agrupades per punt de venda (TPV)",
  importeSinDto: "Import sense desc.",

  //28/07/26
  actualizandoCartaSinqro: "Actualizando carta de productos en Sinqro...",
  cartaActualizadaSinqro: "Carta de productos actualizada correctamente en Sinqro.",

  businessCentralCode: "Codi Business Central",
  errorCargandoDatos: "Error al cargar los datos",
  noSeHaPodidoConsultarIntenteloMasTarde: "No s'ha pogut consultar, torneu-ho a provar més tard.",
  listaPresentaMateriasPrimasNoSincronizadas: "La llista conté matèries primeres que no s'han sincronitzat amb el vostre TPV. Si us plau, torneu-ho a provar més tard.",

  noTieneProveedor: "Sense proveïdor, se seleccionarà durant el desament de la comanda.",
  seleccionarProveedorMateriasPrimas: "Seleccionar proveïdor per a les matèries primeres",
  lasSiguientesMateriasPrimasNoTienenProveedor: "Les matèries primeres següents no tenen cap proveïdor assignat. Seleccioneu un proveïdor per a cadascuna abans de desar la comanda:",
  seleccioneUnProveedor: "Seleccioneu un proveïdor",
  guardarYEnviar: "Desar i enviar",
  dividirPedidoEntreProveedores: "Dividir la comanda entre proveïdors",
  modalTextMp0: "Tens matèries primeres amb unitats i parts a 0. Vols excloure-les de la comanda?",
  pedidoSinMp: "La comanda s'ha quedat buida després d'excloure les matèries primeres.",
  excluir: "Excloure",

  
  noHayProductosAutoEditables: "No hi ha productes que es puguin sincronitzar automàticament en aquest moment",
  confirmarSincronizacionMasivaTitle: "Vols sincronitzar tots els productes automàtics?",
  confirmarSincronizacionMasivaText: "Se sincronitzaran automàticament {COUNT} productes sense necessitat de revisar-los un per un. Vols continuar?",
  siSincronizar: "Sí, sincronitzar",
  sincronizando: "Sincronitzant",
  sincronizacionMasivaCompletadaTitle: "Sincronització massiva completada",
  sincronizadosCorrectamente: "Sincronitzats correctament",
  errorDesconocido: "Error desconegut",
  sincronizarTodosAuto: "Sincronitzar tots ({COUNT})",
  sincronizarTodos: "Sincronitzar tots",
  sincronizarTodosAutoTooltip: "Sincronitza d'un cop tots els productes els canvis dels quals no requereixen emplenar el formulari.",
  // Exportació de vendes a Business Central: taula unificada, resums i avisos
  exportacionPorLotesFija: "L'exportació s'envia per lots de TPV.",
  resumenPorMedioPago: "Per mitjà de pagament",
  resumenPorTpv: "Per TPV",
  resumenPorTipoDocumento: "Per tipus de document",
  documento: "Document",
  verDetalle: "Veure detall",
  facturaQR: "Factura generada des d'una comanda per QR: no pertany a cap dia de caixa",
  rectificaA: "Rectifica el document",
  socio: "Soci",
  variasFormas: "Diverses formes",
  verDetallesVenta: "Veure detalls de la venda",
  editarMedioPago: "Editar mitjà de pagament",
  desglosePagos: "Desglossament de pagaments",
  valesRegalo: "Vals regal",
  valesDelDocumentoOriginal: "del document rectificat",
  avisos: "Avisos",
  totalDeVenta: "Total de venda:",
  ticket: "Tiquet",
  rectificativa: "Rectificativa",
  origenImporteVales: "import del val",
  origenImporteValesOriginal: "val del document rectificat",
  origenImporteCobrosAvanzados: "suma del cobrament avançat",
  seleccioneUnMedioPago: "Seleccioneu un mitjà de pagament",
  importesNoEditables: "Els imports no es poden modificar des d'aquí.",
  buscarClientePorNombreCodigoODni: "Cerca per nom, codi de soci o DNI",
  medioPagoRequiereClienteTexto: "Aquest mitjà de pagament es cobra contra un client, així que cal assignar-ne un.",
  medioActual: "Mitjà actual",
  detallesVenta: "Detalls de la venda",
  tipoDocumento: "Tipus de document",
  dni: "DNI / CIF",
  codigoSocio: "Codi de soci",
  pago: "Pagament",
  edicion: "Edició",
  ventaSinCliente: "La venda no té cap client assignat.",
  ventaNoEditable: "Aquesta venda no admet canvi de mitjà de pagament.",
  errorCargandoFormasPago: "No s'han pogut carregar les formes de pagament.",
  avisoFacturaSinNombre: "Factura sense nom de client",
  avisoFacturaSinDocumento: "Factura sense DNI / CIF",
  avisoSocioSinCodigo: "Soci sense codi: l'exportació el rebutjarà",
  avisoSocioSinCodigoSalesforce: "Soci sense codi: es demanarà a Salesforce en exportar",
  avisoMedioPagoSinCliente: "Mitjà de pagament sense client assignat",
  avisoCuentaCasaClienteGenerico: "Compte casa sense client: s'exportarà amb el client genèric de comptes casa",
  avisoValeSinRegistro: "Val regal sense registre a la taula de vals",
  avisoVentaSinImporte: "Venda sense import: viatjaria sense cap pagament",
  avisoRectificativaSinOriginal: "No es troba el document que rectifica",
  avisoProductoSinMapeoBC: "Producte sense codi d'integració",
  avisoProductoSinUnidadMedida: "Producte sense unitat de mesura",
  motivoVentaAvanzada: "Venda amb pagament avançat: el repartiment d'imports no s'edita des d'aquí.",
  motivoVentaConVale: "Venda amb val regal: el val ja està consumit i registrat.",
  motivoRectificativa: "Rectificativa: s'ha de cobrar igual que el document que corregeix.",
  motivoDestinoVale: "No es pot passar una venda a vals regal: el val es consumeix al TPV.",
  debeCambiarFormaPagoParaGuardar: "Cal canviar el mitjà de pagament o el client per poder desar.",
  // Exportacion BC: resumen de avisos, filtros y paginacion de la tabla
  evCargandoVentas: "Carregant les vendes pendents d'exportar...",
  evDocumentosPendientes: "Documents pendents",
  evDelDiaDeCaja: "del dia de caixa",
  evConAvisos: "Amb avisos",
  evNoSeExportaran: "No s'exportaran",
  evSinAvisos: "Sense avisos",
  evFiltrarPorAviso: "Prem un avís per veure només aquestes vendes a la taula.",
  evVerDetalles: "Veure detalls",
  evOcultarDetalles: "Amagar detalls",
  evErrorCargaVentas: "No s'han pogut carregar les vendes",
  evErrorCargaVentasTexto: "No sabem si hi ha vendes pendents: la consulta ha fallat. Torna-ho a provar d'aquí a uns segons.",
  evYOtros: "i {n} més",
  evBuscarVenta: "Cercar per document o client",
  evFiltroTodas: "Totes",
  evFiltroListas: "Llestes per exportar",
  evFiltroConAvisos: "Amb avisos",
  evFiltroBloqueantes: "No s'exportaran",
  evTodosLosTpv: "Tots els TPV",
  evQuitarFiltros: "Treure filtres",
  evFiltroAviso: "Avís",
  evSinCoincidencias: "Cap document coincideix amb els filtres.",
  evMostrandoRango: "{desde}–{hasta} de {total}",
  evPorPagina: "per pàgina",
  evIrAlDocumento: "Anar al document",
  evOriginalYaExportado: "exportada",
  evOriginalYaExportadoTexto: "El document original (del {fecha}) ja s'ha exportat",
  evRectificadaPor: "Rectificada per",
  evNivelBloqueante: "No s'exportarà",
  evNivelRevisar: "Revisar",
  evNivelBloqueanteTexto: "Aquesta venda no s'enviarà: quedarà pendent fins que es corregeixi.",
  evNivelRevisarTexto: "La venda s'exporta, però convé revisar-la.",
  evConNotasInformativas: "Amb notes informatives",
  evCuentasSinCobrar: "Comptes sense cobrar",
  evCuentasSinCobrarTitulo: "Comptes sense cobrar en aquest dia de caixa",
  evCuentasSinCobrarTexto: "Sumen {importe}. No s'exporten mentre continuïn sense cobrar.",
  evNivelInfo: "Informació",
  evNivelInfoTexto: "És només informatiu: la venda s'exporta amb normalitat.",
  evExportando: "Exportant…",
  evExportandoTexto: "Exportant vendes. Pot trigar uns minuts: no tanquis aquesta pàgina.",
  evExportarUnTpv: "Exportar un TPV",
  evExportarUnTpvDesc: "Exporta només les vendes del TPV que triïs",
  evEligeTpv: "Tria un TPV",
  evPrimeraPagina: "Primera pàgina",
  evUltimaPagina: "Última pàgina",
  evSoloSeExportaraTpv: "Només s'exportarà el TPV {tpv}.",
  evQueSeEnviara: "Què s'enviarà",
  evSeEnviaran: "S'enviaran",
  evQuedaranPendientes: "Quedaran pendents fins que es corregeixin",
  evCifrasDelTpv: "Xifres del TPV {tpv}.",
  evCifrasDelDepartamento: "Xifres d'aquest departament; els altres departaments de la companyia també s'exporten.",
  evFiltrosNoAfectanExportacion: "Els filtres de la taula no afecten l'exportació: s'envia tot el que està pendent.",
  evExportados: "Exportats",
  evRechazadosPorBC: "Rebutjats per BC",
  evOmitidosPorValidacion: "Omesos per BC",
  evResultadoPendientesTexto: "El que no s'ha exportat continua pendent i apareix a la taula amb els seus avisos.",
  evResultadosExportacion: "Resultats de l'exportació",
  evDescargarInformeExcel: "Descarregar Excel",
  evInformeEstaTanda: "Última exportació",
  evActualizarInformes: "Actualitzar",
  evSinInformes: "Encara no hi ha informes. Si l'exportació continua en curs, l'informe apareixerà aquí quan acabi.",
  evSinRespuestaTanda: "No s'ha rebut resposta del servidor. L'exportació pot continuar en curs: els estats de les vendes i l'informe Excel apareixeran quan acabi. Actualitza la llista d'aquí a uns minuts.",
  evDepartamentos: "Departaments",
  evEligeDepartamentos: "Tria departaments",
  evTodosLosDepartamentos: "Tots els departaments",
  evTpvsAExportar: "TPVs a exportar",
  evTpvsAyuda: "Entre parèntesis, documents sense exportar.",
  evAperturasAExportar: "Obertures de caixa a exportar",
  evAperturaMasAntigua: "L'obertura més antiga pendent",
  evAperturaMasAntiguaCadaTpv: "L'obertura més antiga pendent de cada TPV",
  evIncluirFacturasQR: "Incloure factures QR",
  evPendientesCorto: "pend.",
  evRechazadosCorto: "rebutjats BC",
  evOmitidosCorto: "omesos",
  evExcluidosCorto: "exclosos",
  evSeExportaraSeleccion: "S'exportaran les dades següents",
  evResumenSeleccion: "Departaments: {departamentos}. TPV: {tpvs}. Obertures: {aperturas}. {qr}.",
  evConFacturasQR: "Amb les factures QR pendents",
  evSinFacturasQR: "Sense factures QR",
  evExportacionTpvATpv: "S'envia TPV a TPV i per trams; el que es rebutja o s'omet queda pendent amb el seu motiu a l'Excel de la tanda.",
  evCifrasDeLaSeleccion: "Xifres de la selecció actual.",
  evEstadoRechazadoBC: "Prèviament rebutjada",
  evEstadoOmitido: "Omesa",
  evEstadoExcluido: "Exclosa",
  evExcluirDeExportacion: "Excloure de l'exportació",
  evIncluirEnExportacion: "Tornar a incloure a l'exportació",
  evVentaExcluida: "Venda exclosa de l'exportació",
  evVentaIncluida: "Venda inclosa de nou a l'exportació",
  evVentasIncluidasN: "{n} vendes incloses de nou a l'exportació",
  evVentasExcluidasN: "{n} vendes excloses de l'exportació",
  evIncluirSoloEste: "Incloure aquesta",
  evIncluirTambienAsociados: "Incloure associades",
  evExcluirSoloEste: "Excloure aquesta",
  evExcluirTambienAsociados: "Excloure associades",
  evAsociadosIncluirPregunta: "Vols tornar a incloure també els associats o només aquest document?",
  evAsociadosExcluirPregunta: "Vols excloure també els associats o només aquest document?",
  evAsociadosIncluirTexto: "El document {doc} té {n} documents associats exclosos de l'exportació:",
  evAsociadosExcluirTexto: "El document {doc} té {n} documents associats sense exportar que no es poden exportar sense ell:",
  evAsociadosTitulo: "Documents associats",
  evFechaDoc: "Data doc.",
  avisoOriginalNoExportado: "El document al qual fa referència no està exportat; s'enviarà quan entri l'original",
  avisoExcluidaManual: "Excloses de l'exportació",

  evCargarVentas: "Carregar vendes",
  evSeleccionCambiada: "Selecció canviada, prem per actualitzar la llista.",
  evCambiosSinCargar: "Has canviat la selecció i la llista no està actualitzada. Prem Carregar vendes abans d'exportar.",
  evModoAvanzadasTitulo: "Com comptar les vendes amb diversos pagaments (avançades)",
  evAvanzadasTodas: "Totes les vendes",
  evAvanzadasSolo: "Només avançades",
  evAvanzadasSin: "Sense avançades",
  evMasEnExcel: "… i {n} més. El detall complet és a l'Excel d'exportació.",
  evMensajeEjemploParcial: "Enviament parcial: algunes vendes omeses per validació i altres rebutjades (dades d'exemple)",
  evPrevisualizarRespuesta: "Previsualitzar resposta",
  evExcluidaTexto: "Exclosa per l'usuari: no s'exportarà fins que es torni a incloure.",
  evActualizandoVentas: "Actualitzant les vendes amb la selecció nova...",
  evActualizarVentas: "Actualitzar vendes",
  evTramoNotaDefecto: "En totes dues opcions l'exportació es fa en lots de 100 documents, llevat que es configuri una altra mida més avall.",
  evDocumentosCada: "documents (mínim 50)",
  evTramoDeN: "En lots de",
  evTramoTodoDeUnaVez: "Tot alhora",
  evPersonalizarTramos: "Configurar la mida del lot per enviament",
  evTramoNotaTodo: "Tota l'exportació anirà en un únic lot.",
  evTramoNota: "En totes dues opcions l'exportació es fa en lots de {n} documents.",
  evQrNoIncluidas: "No incloses",
  evQrIncluidas: "Incloses a l'exportació",
  evFacturasQR: "Factures QR",
  evCargandoInformes: "Carregant informes...",
  evConteoNoDisponible: "Recompte no disponible",
  evVentasExportadasN: "{n} vendes exportades",
  evEnvioTodoJuntoDesc: "Les vendes de tots els TPV triats s'envien juntes, en l'ordre en què es van fer.",
  evEnvioTodoJunto: "Tots els TPV junts",
  evEnvioPorTpvDesc: "Recorre els TPV triats un a un: cada TPV s'envia i es resol per separat.",
  evEnvioPorTpv: "Per TPV",
  evModoEnvio: "Enviament",
  evInformesExportacion: "Últims informes d'exportació",
  evLineasVenta: "Línies de la venda",
  evCargandoLineas: "Carregant les línies…",
  evErrorCargandoLineas: "No s'han pogut carregar les línies.",
  evVolverAIntentar: "Tornar-ho a provar",
  evSinLineas: "La venda no té línies.",
  evCodigoBC: "Codi BC",
  evUds: "Uts.",
  evUnidadBC: "Unitat",
  evMenu: "Menú",
  evIncluidoEnMenu: "Inclòs",
  evTotalLineas: "Total",
  evImporteDeLaVenta: "Import de la venda",
  evDescuento: "Dte.",
  // Informe de tancament de caixa (Z)
  cierreCajaZDescripcion: "Arqueig complet de cada Z: vendes, formes de pagament, impostos, productes i tiquets",
  todaLaEmpresa: "Tota l'empresa",
  estadoZ: "Estat de la Z",
  zCerradas: "Només tancades",
  zAbiertas: "Només obertes",
  zAbierta: "Oberta",
  zCerrada: "Tancada",
  consultarRangoFechas: "Consultar un rang de dates",
  ocultarFilasSinDatos: "Amagar files sense dades",
  zEnElInforme: "Z a l'informe",
  ocultarDetalle: "Amagar detall",
  quitarFranja: "Treure franja horària",
  documentos: "Documents",
  buscarDocumento: "Cercar document (núm., client, operari, taula)",
  limpiar: "Netejar",
  sector: "Sector",
  seleccionaSector: "Selecciona un sector",
  desplazarIzquierda: "Desplaçar a l'esquerra",
  desplazarDerecha: "Desplaçar a la dreta",
  verIncidencias: "Veure incidències",
  incidenciasTexto: "Preus, quantitats i línies modificades o eliminades al TPV durant la Z",
  todasLasIncidencias: "Totes les incidències",
  todasLasZ: "Totes les Z",
  caja: "Caixa",
  sinIncidencias: "No hi ha incidències amb aquest filtre",
  bloqueResumen: "Resum",
  bloqueAnalisisVentas: "Anàlisi de vendes",
  fechaCaja: "Data de caixa",
  propinas: "Propines",
  ventasSinPropinas: "Vendes sense propines",
  formaPagoTipoSaldo: "Pagament amb saldo",
  incidenciasPrecioModificado: "Preu modificat",
  incidenciasLineaEliminada: "Línia eliminada",
  incidenciasCantidadModificada: "Quantitat modificada",
  incidenciasDescuentoModificado: "Descompte modificat",
  incidenciasOtras: "Altres incidències",
  rangoNoDisponibleSectores: "Amb sectors només es pot consultar un dia: el sector agrupa molts TPV i un rang de dates faria l'informe inmanejable. Per acotar per TPV fes servir el filtre de la barra de vista, un cop carregat l'informe.",
  analisisNegocio: "Anàlisi de negoci",
  analisisNegocioDescripcion: "Comparatives de vendes, formes de pagament, incidències i rendibilitat entre mesos i anys",
  anPeriodo: "Període",
  anModoMes: "Mes",
  anModoRango: "Rang",
  anModoAnio: "Any",
  anMes: "Mes a analitzar",
  anCompararCon: "Comparar amb",
  anMesAnteriorYAnioAnterior: "Mes anterior i mateix mes de l'any anterior",
  anMesAnterior: "Mes anterior",
  anMismoMesAnioAnterior: "Mateix mes de l'any anterior",
  anSinComparar: "Sense comparar",
  anPeriodoA: "Període A",
  anPeriodoB: "Període B",
  anPeriodoC: "Període C",
  anAnio: "Any a analitzar",
  anAnioAnteriorMismaFecha: "Any anterior fins a la mateixa data",
  anRecalcular: "Recalcular",
  anRecalcularAyuda: "Recalcular ignorant les dades guardades. Fes-ho servir si s'han tornat a pujar dades d'un TPV. Màxim una vegada per hora i tres al dia.",
  anRecalcularEspera: "Ja s'ha recalculat fa poc. Podràs tornar a fer-ho en {tiempo}.",
  anRecalcularEsperaDia: "Ja s'han fet tres recàlculs en les últimes 24 hores. Podràs tornar a recalcular en {tiempo}.",
  anRecalcularConfirmacion: "S'esborraran les dades guardades dels TPV i mesos consultats i es tornaran a calcular. Pot trigar uns segons.",
  anCalculandoPeriodos: "Calculant els períodes seleccionats…",
  anSinDatos: "Sense vendes en el període",
  anSinDatosTexto: "No hi ha sessions de caixa ni documents en l'àmbit i el període seleccionats.",
  anPeriodosDistintaLongitud: "Períodes de durada diferent: compara les mitjanes",
  anPestanaVentas: "Vendes",
  anPestanaFormasPago: "Formes de pagament",
  anPestanaIncidencias: "Incidències",
  anPestanaRentabilidad: "Rendibilitat",
  anProximamente: "Disponible en la següent fase",
  anEvolucionMensual: "Evolució mensual",
  anUltimos13Meses: "últims 13 mesos",
  anMediaDiaria: "Mitjana diària",
  anCalculandoMesesAntiguos: "Calculant mesos anteriors…",
  anVentasPorDia: "Vendes per dia",
  anAlinearPorDiaSemana: "Alinear per dia de la setmana",
  anVentasPorDiaSemana: "Vendes per dia de la setmana",
  anMediaPorDiaConVentas: "mitjana per dia amb vendes",
  anVentasPorHora: "Vendes per hora",
  anPorNegocioYTpv: "Per negoci i TPV",
  anVariacion: "Variació",
  sesiones: "Sessions",
  anCompletaPeriodo: "Completa el període per consultar",
  anPeriodoInvertido: "El final del període és anterior al seu inici",
  anMaximo12Meses: "Cada període pot abastar com a màxim 12 mesos",
  anCalculadosAhora: "{n} de {total} TPV·mes calculats ara; la resta de les dades guardades",
  anDatosDeCache: "Dades guardades (calculades el {fecha})",
  anHasta: "fins",
  anNotaDistintaLongitud: "Els períodes no tenen la mateixa durada: fixa't en les mitjanes",
  anNotaAlineadoSemana: "Alineat per dia de la setmana: el dia 1 és el primer dilluns de cada període",
  anNotaBisiesto: "{periodo} inclou el 29 de febrer de {anio}, que no té parella en l'altre període",
  anDia: "Dia",
  anFormasPagoMesesCompletos: "El repartiment per forma de pagament es calcula sobre mesos complets: el tall per dia del període no s'aplica aquí.",
  anRepartoPorTipo: "Repartiment per tipus de pagament",
  anTiposPorPeriodo: "Tipus de pagament per període",
  anEvolucionFormasPago: "Evolució de les formes de pagament",
  anEnPorcentaje: "En percentatge",
  anPorTipoYMedio: "Per tipus i mitjà de pagament",
  formaPago: "Forma de pagament",
  anPorcentajeMediosNota: "El % de cada tipus és sobre el total del període; el de cada mitjà, sobre el seu tipus.",
  anRatioIncidencias: "{n} incidències per cada 100 documents",
  anRatioFrenteA: "ràtio davant de",
  anTipoPredominante: "Tipus predominant",
  anEvolucionIncidencias: "Evolució de les incidències",
  anBarrasTotalLineaRatio: "barres: total · línia: per 100 documents",
  anIncidenciasPorDia: "Incidències per dia",
  anPulsaDiaParaCierreZ: "prem un dia per obrir el seu Tancament de caixa Z",
  anIncidenciasPorTipo: "Incidències per tipus",
  anIncidenciasPorOperario: "Incidències per operari",
  anIncidenciasPorProducto: "Incidències per producte afectat",
  anAQueSeDeben: "a què es deuen",
  anPor100Docs: "Per 100 docs.",
  anVariacionRatio: "Variació de la ràtio",
  anCoberturaCoste: "{conCoste} de {total} ítems venuts tenen cost d'escandall ({pct} % de les vendes sense IVA); només aquests es classifiquen.",
  anCosteActualNota: "El cost és l'actual de l'escandall de cada producte, no el que tenia en el període.",
  anRentabilidadMesesCompletos: "La rendibilitat es calcula sobre mesos complets: el tall per dia no s'aplica aquí.",
  anPorProductoYTarifa: "Producte × tarifa",
  anPorProducto: "Producte",
  anTodasLasCategorias: "Totes les categories",
  anTodosLosCuadrantes: "Tots els quadrants",
  anSinCoste: "Sense cost",
  anItems: "ítems",
  anMargenContribucion: "Marge de contribució",
  anUmbrales: "Llindars del període",
  anIndicePopularidadMedio: "Índex de popularitat mitjà",
  anRentabilidadMedia: "Rendibilitat mitjana (MC per unitat)",
  anMediaCoste: "Mitjana de cost",
  anMatrizPopularidadMargen: "Matriu popularitat × marge",
  anMatrizExplicacion: "cada bombolla és un ítem; la mida, el seu marge total; les línies, els llindars",
  anMargenPorCuadrante: "Marge total per quadrant",
  anTopMargen: "Major marge total",
  anCambiosCuadrante: "Canvis de quadrant",
  anTablaIngenieriaMenu: "Enginyeria de menú",
  anNumeroVentas: "Núm. vendes",
  anCosteProducto: "Cost",
  anPrecioVentaSinIva: "PVP sense IVA",
  anIndicePopularidad: "Índex de popularitat",
  anCosteProductoPct: "% cost",
  anTotalCoste: "Total cost",
  anTotalVentas: "Total vendes",
  anMargenContribucionTotal: "MC total",
  anClasifRentabilidad: "Rendibilitat",
  anClasifPopularidad: "Popularitat",
  anClasifFinal: "Classificació",
  anTarifaNoIdentificada: "Tarifa no identificada: s'ha assignat a la tarifa 1",
  anNuevo: "nou",
  anAlta: "Alta",
  anBaja: "Baixa",
  anSinUnidades: "Sense unitats netes",
  anPrincipiosOmnes: "Preus: principis d'Omnes",
  anTodaLaCarta: "Tota la carta venuda",
  anDispersionPrecios: "Dispersió de preus",
  anDispersionTexto: "Preu més alt {max} / més baix {min}",
  anDispersionIdeal: "Ideal entre 2,5 i 3 en gammes de més de 12 plats",
  anDispersionNoAplica: "El criteri (2,5–3) s'aplica a gammes de més de 12 plats",
  anAmplitudGama: "Amplitud de gamma",
  anAmplitudTexto: "Bandes d'igual amplada; talls a {bajo} i {alto}. Ideal 25 / 50 / 25 %.",
  anRelacionCalidadPrecio: "Relació qualitat-preu",
  anPrecioMedioSolicitado: "Preu mitjà sol·licitat",
  anPrecioMedioOfertado: "Preu mitjà ofert",
  anSimularCambioPrecios: "Simular canvi de preus",
  anBandaBaja: "Banda baixa",
  anBandaMedia: "Banda mitjana",
  anBandaAlta: "Banda alta",
  anActual: "Actual",
  anIdeal: "Ideal",
  anRecomendableSubir: "Recomanable apujar preus (ràtio > 1,00)",
  anRecomendableBajar: "Recomanable abaixar preus (ràtio < 0,90)",
  anRecomendableMantener: "Preus adequats: mantenir (ràtio 0,90–1,00)",
  anCuadranteLider: "Líder",
  anCuadrantePopular: "Popular",
  anCuadranteRentable: "Rendible",
  anCuadranteRevisar: "A revisar",
  anCuadranteLiderAyuda: "Popularitat alta i marge alt: els plats que sostenen el negoci. Mantenir i destacar.",
  anCuadrantePopularAyuda: "Es ven molt però deixa poc marge: revisar cost o preu.",
  anCuadranteRentableAyuda: "Bon marge però es ven poc: donar-li visibilitat o reubicar-lo a la carta.",
  anCuadranteRevisarAyuda: "Ni es ven ni deixa marge: candidat a canviar o retirar.",
  anExportarPdfAyuda: "Exportar la pestanya actual a PDF (gràfiques i taules)",
  anExportarExcelAyuda: "Exportar la pestanya actual a Excel (un full per bloc)",
  verAnalisisNegocio: "Veure anàlisi",
  verAnalisisNegocioAyuda: "Obrir 'Anàlisi de negoci' amb aquesta empresa, aquests negocis i el mes de la data consultada",
  proximamente: "Properament",
  verAnalisisNegocioProximamente: "L'informe 'Anàlisi de negoci' estarà disponible properament",
  anPeriodosReordenados: "Els períodes es mostren del més recent al més antic: {reciente} és el període principal i la variació indica quant ha canviat respecte a {antiguo}.",
  anVariacionDireccion: "Variació de {antiguo} a {reciente}: quant ha canviat el període recent respecte a l'anterior.",
  anExportarEsperaCarga: "Espera que la pestanya acabi de carregar per exportar-la.",
  sinSesionesDeCaja: "No hi ha sessions de caixa",
  sinSesionesDeCajaTexto: "Cap TPV de l'àmbit va obrir caixa a la data seleccionada. La Z s'assigna al dia en què s'obre, encara que tanqui passada la mitjanit.",
  tpvsSinApertura: "TPV sense obertura",
  facturasQRExcluidasTexto: "Les factures QR no pertanyen a cap Z i no s'inclouen en aquest informe: tenen el seu propi informe.",
  franjaHoraria: "Franja horària",
  franjaHorariaSoloAnalisis: "La franja només filtra productes i tiquets. L'arqueig és de la sessió completa i no es veu afectat.",
  aplicar: "Aplicar",
  productosVendidos: "Productes venuts",
  productosVendidosTexto: "Quantitat de cada producte que surt per Z. No inclou anul·lacions, estoc ni minves.",
  todosLosDocumentos: "Tots els documents",
  formasPago: "Formes de pagament",
  invitacion: "Invitació",
  cuentaCasa: "Compte casa",
  valeRegalo: "Val regal",
  bloqueIdentificacion: "Identificació",
  bloqueVentas: "Vendes",
  bloqueFormasPago: "Formes de pagament",
  bloqueArqueo: "Arqueig",
  bloqueImpuestos: "Impostos",
  numeroZ: "Núm. de Z",
  operarioCierre: "Operari",
  duracionHoras: "Durada (hores)",
  primerDocumento: "Primer document",
  ultimoDocumento: "Últim document",
  numIncidencias: "Incidències",
  numAnulados: "Documents anul·lats",
  ventasBrutas: "Vendes",
  abonos: "Abonaments",
  ventasTotales: "Vendes totals",
  numDocumentos: "Núm. de documents",
  numTickets: "Tiquets",
  numFacturas: "Factures",
  numRectificativas: "Rectificatives",
  ticketMedio: "Tiquet mitjà",
  mediaPorComensal: "Mitjana per comensal",
  numInvitaciones: "Núm. d'invitacions",
  importeInvitaciones: "Import invitacions",
  formaPagoTipoEfectivo: "Efectiu",
  formaPagoTipoTarjeta: "Targeta",
  formaPagoTipoCheque: "Xec",
  formaPagoTipoOtros: "Altres",
  totalFormasPago: "Total formes de pagament",
  ventaSegunTpv: "Venda segons el TPV",
  diferenciaConDocumentos: "Diferència amb els documents",
  cambioInicial: "Canvi inicial",
  gastosCaja: "Despeses de caixa",
  totalCalculado: "Total calculat",
  totalDeclarado: "Total declarat",
  retirado: "Retirat",
  nuevaFianza: "Nova fiança",
  baseImponibleIva: "Base imposable IVA",
  cuotaIva: "Quota IVA",
  baseImponibleTotal: "Base imposable total",
  totalImpuestos: "Total impostos",
  avisoZAbierta: "Z sense tancar: no es pot arquejar",
  avisoZDuracionExcesiva: "Z oberta més temps del normal",
  avisoZConIncidencias: "Z amb incidències",
  avisoZSinVentas: "Z sense vendes",

  // --- Horario de disponibilidad Sinqro ---
  configurarHorarioSinqro: "Configurar horari de disponibilitat",
  horarioSinqroOnAyuda: "Tria un horari o crea'n un de nou; l'actiu és el que s'envia a Sinqro.",
  horarioSinqroOffAyuda: "Si no configures cap horari, a Sinqro la carta quedarà disponible les 24 h.",
  copiarATodosLosDias: "Copiar a la resta de dies",
  anadirTramo: "Afegir tram",
  horarioSinqroSinTramos: "Has activat l'horari però hi ha dies sense trams vàlids. Completa les hores o desactiva l'horari.",
  horarioSinqroRangoInvalido: "Hi ha trams amb l'hora de fi anterior o igual a la d'inici.",

  // --- Biblioteca de horarios Sinqro ---
  seleccionaHorario: "Selecciona un horari",
  crearNuevoHorario: "Crear un horari nou",
  nombreHorario: "Nom de l'horari",
  guardarHorario: "Desar horari",
  horarioGuardado: "Horari desat",
  horarioEliminado: "Horari eliminat",
  confirmarEliminarHorario: "Vols eliminar aquest horari? Aquesta acció no es pot desfer.",
  sinHorarios: "Aquest negoci encara no té horaris. Crea'n un de nou.",
  nombreHorarioObligatorio: "Posa un nom a l'horari.",
  horarioActivoAyuda: "L'horari seleccionat és el que s'envia a Sinqro.",

  // --- Etiquetes del negoci (pantalla nova) ---
  etiquetasDelNegocio: "Etiquetes del negoci",
  etiquetasClasifican: "Classifiquen matèries primeres i proveïdors.",
  etiquetasDosFamilias: "Dues famílies que no es barregen: una matèria primera només porta etiquetes de matèria primera.",
  deMateriaPrima: "De matèria primera",
  deProveedor: "De proveïdor",
  conProblema: "Amb problema",
  familiasDeEtiquetas: "Famílies d'etiquetes",
  sinTipo: "Sense tipus",
  verTodas: "Veure-les totes",
  sinNombre: "(sense nom)",
  sinEtiquetaExplica: "matèries primeres que no tenen cap etiqueta assignada",
  sinEtiquetasEnEstaFamilia: "Aquest negoci no té etiquetes d'aquesta família.",
  notaEtiquetas: "Les etiquetes viuen al TPV servidor del negoci, no una per terminal. Aquesta pantalla les ensenya totes, incloses les que la resta del panell no arriba a mostrar.",
  estadoRaiz: "etiqueta principal",
  estadoDentroDe: "dins de «{padre}»",
  estadoDeBaja: "donada de baixa",
  estadoNombreRepetido: "hi ha més d'una etiqueta amb aquest nom",
  estadoSinTipo: "no és ni de matèria primera ni de proveïdor",
  estadoBucle: "és la seva pròpia etiqueta pare",
  estadoHuerfana: "penja de l'etiqueta {code}, que no existeix o no és d'aquesta família",
  estadoNoSeVe: "no es veu a la resta del panell: la seva branca es talla abans d'arribar-hi",
  avisoEtiquetasOcultas: "<b>Una etiqueta de matèria primera no es veu a la resta del panell</b>, «{nombre}», amb {m} matèries primeres a dins. Surt al llistat, però no es pot triar en editar una fitxa. | <b>{n} etiquetes de matèria primera no es veuen a la resta del panell</b>, entre elles «{nombre}», amb {m} matèries primeres a dins. Surten al llistat, però no es poden triar en editar una fitxa.",
  avisoMpConEtiquetaProveedor: "<b>Una matèria primera porta una etiqueta de proveïdor.</b> Són dues famílies diferents: aquesta etiqueta no s'hauria de poder triar aquí. | <b>{n} matèries primeres porten una etiqueta de proveïdor.</b> Són dues famílies diferents: aquestes etiquetes no s'haurien de poder triar aquí.",
  avisoMpConEtiquetaSinTipo: "<b>Una matèria primera porta una etiqueta sense tipus.</b> No és ni de matèria primera ni de proveïdor, així que no s'agrupa enlloc. | <b>{n} matèries primeres porten una etiqueta sense tipus.</b> No són ni de matèria primera ni de proveïdor, així que no s'agrupen enlloc.",
  avisoMpConEtiquetaDeBaja: "<b>Una matèria primera porta una etiqueta donada de baixa.</b> L'etiqueta existeix, però la fitxa ja no l'ofereix, així que des del panell no hi ha manera de treure-la d'allà. | <b>{n} matèries primeres porten una etiqueta donada de baixa.</b> Les etiquetes existeixen, però la fitxa ja no les ofereix, així que des del panell no hi ha manera de treure-les d'allà.",
  avisoMpConEtiquetaInexistente: "<b>Una matèria primera apunta a una etiqueta que no existeix.</b> La referència està trencada: no apareix en cap informe per etiqueta. | <b>{n} matèries primeres apunten a una etiqueta que no existeix.</b> Les referències estan trencades: no apareixen en cap informe per etiqueta.",
  avisoEtiquetasSinTipo: "<b>Hi ha una etiqueta sense tipus.</b> No surt a cap llista, i les que en pengen tampoc. | <b>Hi ha {n} etiquetes sense tipus.</b> No surten a cap llista, i les que en pengen tampoc.",
  avisoMpSinEtiqueta: "<b>Una matèria primera no té etiqueta.</b> No apareix agrupada en cap informe per etiqueta. | <b>{n} matèries primeres no tenen etiqueta.</b> No apareixen agrupades en cap informe per etiqueta.",
  avisoEtiquetaRepetida: "<b>Hi ha {n} etiquetes anomenades «{nombre}»</b> a {familia}. En triar-ne una no hi ha manera de saber quina és quina.",

  // --- Alta d'etiqueta ---
  familia: "Família",
  queEsCadaFamilia: "Què és cada família",
  ayudaFamiliaMateriaPrima: "classifica les matèries primeres del magatzem. És l'única que es pot assignar a una matèria primera, i la que agrupa els informes de compres i inventari.",
  ayudaFamiliaProveedor: "classifica els proveïdors, per agrupar-los als informes de despesa. No es pot assignar a una matèria primera.",
  ningunaEsPrincipal: "Cap — serà una etiqueta principal",
  ayudaEtiquetaPadre: "Només s'ofereixen etiquetes actives de la mateixa família: una etiqueta que penja d'una altra família deixa de veure's a la resta del panell.",
  nombreEtiquetaObligatorio: "Posa un nom a l'etiqueta.",
  etiquetaCreada: "Etiqueta creada.",
  noSeHaPodidoGuardar: "No s'ha pogut desar. Torna-ho a provar.",

  // --- Edicio i baixa d'etiqueta ---
  editarEtiqueta: "Editar etiqueta",
  reactivar: "Reactivar",
  padreCode: "codi {code} (no existeix)",
  laFamiliaNoSeCambia: "La família no es canvia: les matèries primeres que ja la porten deixarien de complir la regla. Si en cal una altra, crea una etiqueta nova.",
  etiquetaGuardada: "Etiqueta desada.",
  etiquetaDadaDeBaja: "Etiqueta donada de baixa.",
  etiquetaReactivada: "Etiqueta reactivada.",
  darDeBajaEtiqueta: "Donar de baixa «{nombre}»",
  bajaConMateriasPrimas: "Té 1 matèria primera a dins, que es quedarà apuntant a una etiqueta de baixa. | Té {n} matèries primeres a dins, que es quedaran apuntant a una etiqueta de baixa.",
  bajaConHijas: "En penja 1 etiqueta, que es quedarà sense pare vàlid. | En pengen {n} etiquetes, que es quedaran sense pare vàlid.",
  bajaSinConsecuencias: "No té matèries primeres ni altres etiquetes a dins. La podràs reactivar quan vulguis.",
  aQueEtiquetaVan: "A quina etiqueta van?",
  bajaHijasSuben: "Penja 1 etiqueta d'ella, que passarà a {padre}. | Pengen {n} etiquetes d'ella, que passaran a {padre}.",
  ningunaSeranPrincipales: "ser etiquetes principals",
  bajaDejarSinEtiqueta: "Deixar-la sense etiqueta en lloc de reassignar-la | Deixar les {n} sense etiqueta en lloc de reassignar-les",
  bajaMpReasignadas: "1 matèria primera reassignada. | {n} matèries primeres reassignades.",
  bajaMpSinEtiqueta: "1 matèria primera s'ha quedat sense etiqueta. | {n} matèries primeres s'han quedat sense etiqueta.",
  bajaHijasMovidas: "1 etiqueta ha pujat de nivell. | {n} etiquetes han pujat de nivell.",

  // --- Materies primeres a revisar (modal de la pantalla d'etiquetes) ---
  verYAsignar: "Veure i assignar",
  asignarFamilia: "Assignar família",
  tituloSinTipo: "Etiquetes sense família",
  ayudaSinTipo: "No són ni de matèria primera ni de proveïdor, així que no surten en cap llista, i el que penja d'elles tampoc. Marca les que vulguis i tria la família que els correspon.",
  queFamiliaLesCorresponde: "Quina família els correspon?",
  pistaMateriasPrimas: "1 matèria primera a dins | {n} matèries primeres a dins",
  pistaHijas: "1 etiqueta a dins, de {familia} | {n} etiquetes a dins, de {familia}",
  pistaNadie: "ningú la fa servir",
  sinTipoNadaQueVer: "Totes les etiquetes tenen la seva família.",
  familiaAsignada: "Família assignada a 1 etiqueta. | Família assignada a {n} etiquetes.",
  tituloRevisar_sinEtiqueta: "Matèries primeres sense etiqueta",
  tituloRevisar_etiquetaProveedor: "Matèries primeres amb etiqueta de proveïdor",
  tituloRevisar_etiquetaSinTipo: "Matèries primeres amb etiqueta sense tipus",
  tituloRevisar_etiquetaDeBaja: "Matèries primeres amb etiqueta de baixa",
  tituloRevisar_etiquetaInexistente: "Matèries primeres amb etiqueta inexistent",
  ayudaRevisar_sinEtiqueta: "No estan agrupades en cap informe per etiqueta. Marca les que vulguis i tria a sota a quina etiqueta van.",
  ayudaRevisar_etiquetaProveedor: "Porten una etiqueta d'una altra família. Marca les que vulguis i tria a sota una etiqueta de matèria primera.",
  ayudaRevisar_etiquetaSinTipo: "La seva etiqueta no és ni de matèria primera ni de proveïdor, així que no agrupa en cap lloc. Marca les que vulguis i tria a sota una etiqueta de matèria primera.",
  ayudaRevisar_etiquetaDeBaja: "La seva etiqueta està donada de baixa, així que la fitxa de la matèria primera ja no l'ofereix. Marca les que vulguis i tria a sota una etiqueta que estigui d'alta.",
  ayudaRevisar_etiquetaInexistente: "Apunten a una etiqueta que ja no hi és. Marca les que vulguis i tria a sota a quina etiqueta van.",
  seleccionarNinguna: "Cap",
  revisarTruncado: "Es mostra la primera de {total}. Fes servir el cercador per arribar a la resta. | Es mostren les primeres {n} de {total}. Fes servir el cercador per arribar a la resta.",
  revisarSinPermiso: "Pots veure el llistat, però no tens permís per editar matèries primeres, així que no les pots reassignar.",
  revisarNadaQueVer: "No en queda cap en aquest estat.",
  asignarEtiqueta: "Assignar aquesta etiqueta",
  elegirEtiquetaDestino: "Tria una etiqueta de matèria primera",
  etiquetasDeMateriaPrima: "Etiquetes de matèria primera",
  quitarEtiqueta: "Treure l'etiqueta",
  sinResultados: "Cap etiqueta coincideix",
  dejarSinEtiqueta: "Deixar sense etiqueta",
  asignarACuantas: "Assignar | Assignar a {n}",
  confirmarDejarSinEtiqueta: "Es quedarà sense cap etiqueta i no apareixerà agrupada als informes per etiqueta. | Les {n} es quedaran sense cap etiqueta i no apareixeran agrupades als informes per etiqueta.",
  materiasPrimasAsignadas: "Etiqueta assignada a 1 matèria primera. | Etiqueta assignada a {n} matèries primeres.",
  etiquetaSinNombre: "(etiqueta sense nom)",
  destinoOculto: "No es veuen a la resta del panell",
  avisoDestinoOculto: "Aquesta etiqueta no es veu a la resta del panell: la seva branca es talla abans d'arribar-hi. Les matèries primeres quedaran agrupades, però continuaràs sense poder triar-la en editar una fitxa.",
  errorInesperado: "Ha passat alguna cosa inesperada. Torna-ho a provar.",
  // Pausas en el informe de turnos (app de gestión de turnos)
  tpPausas: "Pauses",
  tpPorDias: "Per dies",
  tpPorTurnos: "Per torns",
  tpHorario: "Horari",
  tpDesayuno: "Esmorzar",
  tpCigarro: "Cigarret",
  tpDescanso: "Descans",
  tpOtra: "Altra",
  tpEnCurso: "en curs",
  tpTurnoDe: "torn de",
  tpJornadaPartida: "Jornada partida",
  tpParon: "Aturada entre torns",
  tpDias: "dies",
  tpNota: "Prem un dia per veure'n el detall. Les pauses són informatives: no canvien les hores ni el sou.",
  // --- Categorias del negocio (Configuracion > Categorias) ---
  terminales: "Terminals",
  desiguales: "Desiguals",
  gruposDeCategorias: "Grups de categories",
  vistaListado: "Vista en llista",
  vistaColumnas: "Vista en columnes",
  verLos4Grupos: "Veure els 4 grups",
  catDe: "de",
  pantallaDelTerminal: "{n}a pantalla del TPV",
  reindexar: "Reindexar",
  grupoCompleto: "Grup complet",
  seGuardaEnTerminales: "Es desarà al terminal del negoci. | Es desarà als {n} terminals del negoci.",
  sinCategoriaExplica: "productes d'aquest grup que no són a cap categoria",
  huecoConBajasExplica: "només li queden productes de baixa; allibereu-la per poder reutilitzar-la",
  liberarRanura: "Alliberar",
  liberarRanuraTitulo: "Voleu alliberar aquesta posició?",
  liberarRanuraTexto: "Els seus productes de baixa es queden sense categoria i la posició queda lliure per a una categoria nova o per reindexar. Els productes d'alta no es toquen.",
  ranuraLiberada: "Posició alliberada",
  huecoLibreExplica: "aquí hi havia una categoria; el seu lloc continua reservat",
  verProductos: "Veure productes",
  usarEsteHueco: "Fer servir aquest buit",
  nombreCategoriaNueva: "Nom de la categoria nova",
  seCrearaAlFinalDelGrupo: "Es crearà buida, al final del grup {g}, al terminal del negoci. | Es crearà buida, al final del grup {g}, als {n} terminals.",
  grupoVacio: "Aquest grup és buit. Les categories que hi creïs sortiran a la {n}a pantalla del TPV.",
  fueraDeLosGrupos: "Fora dels quatre grups",
  fueraDeLosGruposExplica: "el terminal les fa servir, però la seva tecla no és de les 40 habituals",
  verDeUnoEnUno: "Veure els grups d'un en un",
  mostrarLos4Grupos: "Mostrar els 4 grups",
  notaGruposTerminal: "Els quatre grups són els que el cambrer veu al terminal. Una categoria es crea dins d'un grup i s'hi queda; afegir-la la col·loca al final del seu grup, i editar o eliminar no mou les altres.",
  productosAsignados: "1 producte assignat a «{categoria}». | {n} productes assignats a «{categoria}».",
  reordenar: "Reordenar",
  avisoOrdenDistinto: "<b>En 1 terminal les categories són en altres tecles que al servidor.</b> Reordena-les abans de res: mentrestant, els altres avisos poden no ser certs. | <b>En {n} terminals les categories són en altres tecles que al servidor.</b> Reordena-les abans de res: mentrestant, els altres avisos poden no ser certs.",
  avisoOtroNombre: "<b>Un terminal anomena «{otro}» la categoria «{nombre}», del grup {g}.</b> Els cambrers que facin servir aquest terminal veuen un altre nom per a la categoria.",
  unificar: "Unificar",
  avisoNombreRepetido: "<b>Hi ha dues categories anomenades «{nombre}»</b>, al grup {g1} i al {g2}, amb {p1} i {p2} productes.",
  avisoDesiguales: "<b>Una categoria no ha arribat a tots els terminals.</b> És creada al negoci però en falta el nom en algun, així que allà els seus productes no surten agrupats. | <b>{n} categories no han arribat a tots els terminals.</b> Són creades al negoci però en falta el nom en algun, així que allà els seus productes no surten agrupats.",
  avisoDesigualesSinNinguna: "El terminal {terminales} no en té cap. | Els terminals {terminales} no en tenen cap.",
  aplicarATodos: "Aplicar a tots",
  avisoTerminalesSinCategorias: "<b>Un terminal no té cap categoria.</b> Un producte creat allà no apareixerà a cap. | <b>{n} terminals no tenen cap categoria.</b> Un producte creat allà no apareixerà a cap.",
  avisoProductosSinCategoria: "<b>Un producte no és a cap categoria.</b> Es ven, però els cambrers només hi arriben cercant. | <b>{n} productes no són a cap categoria.</b> Es venen, però els cambrers només hi arriben cercant.",
  avisoTerminalPendiente: "<b>El terminal {terminales} és nou i encara no ha pujat la seva carta.</b> La copiarà del servidor en arrencar i la pujarà; fins aleshores no se li escriu res des d'aquí ni compta en aquests avisos. | <b>Els terminals {terminales} són nous i encara no han pujat la seva carta.</b> La copiaran del servidor en arrencar i la pujaran; fins aleshores no se'ls escriu res des d'aquí ni compten en aquests avisos.",
  unTerminalLaLlama: "un terminal l'anomena «{otro}»",
  pendienteEnTerminales: "pendent a 1 terminal | pendent a {n} terminals",
  enOtraTeclaEnTerminal: "en un terminal està en una altra tecla; es corregeix reordenant",
  avisoSoloEnClientes: "<b>«{nombre}», del grup {g}, només existeix al terminal {terminales}.</b> El servidor no la té, i és qui mana: creeu-la-hi si és bona, o traieu-la del terminal. | <b>«{nombre}», del grup {g}, només existeix als terminals {terminales}.</b> El servidor no la té, i és qui mana: creeu-la-hi si és bona, o traieu-la d'aquests terminals.",
  crearEnServidor: "Crear al servidor",
  quitarDelTerminal: "Treure del terminal | Treure dels terminals",
  soloEnTerminalSinServidor: "només a {terminales}; el servidor no la té",
  crearEnServidorTitulo: "Voleu crear «{nombre}» al servidor?",
  crearEnServidorExplica: "El servidor no la té. Es crea al servidor i als terminals on falti.",
  bajaSoloEnClientes: "Només la té {terminales}. El servidor no canvia.",
  enTodosLosTerminales: "a l'únic terminal | als {n} terminals",
  nombreVacio: "El nom no pot quedar buit. Si la vols treure, fes servir Eliminar.",
  categoriaGuardada: "Categoria desada al terminal. | Categoria desada als {n} terminals.",
  categoriaCreada: "Categoria creada al terminal. | Categoria creada als {n} terminals.",
  productosMovidos: "1 producte mogut a l'altra categoria. | {n} productes moguts a l'altra categoria.",
  productosSinCategoriaAhora: "1 producte s'ha quedat sense categoria. | {n} productes s'han quedat sense categoria.",
  categoriaEliminada: "Categoria eliminada al terminal. | Categoria eliminada als {n} terminals.",
  yaEstabanOrdenadas: "Les categories d'aquest grup ja estaven seguides.",
  categoriasReindexadas: "1 categoria moguda. El grup ja no té buits. | {n} categories mogudes. El grup ja no té buits.",
  categoriasReordenadas: "1 categoria posada a la seva tecla. | {n} categories posades a la seva tecla.",
  reordenarSaltados: "No s'ha pogut reordenar a: {terminales}.",
  categoriasIgualadas: "1 categoria igualada a tots els terminals. | {n} categories igualades a tots els terminals.",
  categoriasSaltadas: "1 categoria té noms diferents entre terminals: tria tu quin val. | {n} categories tenen noms diferents entre terminals: tria tu quin val.",
  huecoConBajas: "Ranura ocupada",
  huecoLibre: "Buit lliure",
  eliminarCategoria: "Eliminar «{nombre}»",
  eliminarConProductos: "Té 1 producte a dins. Tria on va abans d'eliminar-la. | Té {n} productes a dins. Tria on van abans d'eliminar-la.",
  eliminarSinProductos: "No té productes a dins. S'eliminarà al terminal. | No té productes a dins. S'eliminarà als {n} terminals.",
  eliminarHuecoSeQueda: "El buit es queda al seu lloc: no es recol·loca cap altra categoria.",
  eligeDestino: "Tria on van els seus productes.",
  moverProductosA: "Moure els seus productes a...",
  sinResultadosCategoria: "Cap categoria no coincideix",
  grupoNumero: "Grup {g}",
  dejarlosSinCategoria: "Deixar-los sense categoria",
  confirmarSinCategoriaTexto: "Aquest producte deixarà de sortir agrupat al terminal. Es continuarà venent, però els cambrers només hi arribaran cercant-lo. | Aquests {n} productes deixaran de sortir agrupats al terminal. Es continuaran venent, però els cambrers només hi arribaran cercant-los.",
  productosSinCategoriaTitulo: "Productes sense categoria",
  productosSinCategoriaAyuda: "No surten agrupats al terminal, així que els cambrers només hi arriben cercant-los. Marca els que vulguis i tria a sota a quina categoria van.",
  productoSinNombre: "(sense nom)",
  enNTerminales: "a 1 de {t} terminals | a {n} de {t} terminals",
  sinProductosSinCategoria: "No queda cap producte sense categoria.",
  asignarEstaCategoria: "Assignar aquesta categoria",
  elegirCategoriaDestino: "Tria una categoria",
  reindexarTitulo: "Voleu reindexar el grup {g}?",
  reindexarQuitaHuecos: "Es treu 1 buit: les categories queden seguides al principi del grup. | Es treuen {n} buits: les categories queden seguides al principi del grup.",
  reindexarCambiaTecla: "1 categoria canvia de tecla: al terminal apareixerà en un altre lloc. | {n} categories canvien de tecla: al terminal apareixeran en un altre lloc.",
  reindexarProductosSeQuedan: "Els productes no canvien de categoria: van amb la seva.",
  reindexarComoQueda: "Com queda:",
  reindexarSinCambios: "Aquest grup ja està seguit: no hi ha res a reindexar.",
  unificarTitulo: "Voleu unificar «{nombre}»?",
  aplicarTodosTitulo: "Voleu aplicar les categories a tots els terminals?",
  unificarTodosLaLlaman: "Tots els terminals passaran a anomenar-la «{nombre}».",
  unificarPorServidor: "Es queda el nom que té el terminal servidor.",
  unificarPorMayoria: "Es queda el nom que fan servir més terminals.",
  unificarCambiaEn: "Canvia en 1 terminal: els seus cambrers veuran el nom nou i l'anterior es perd. | Canvia en {n} terminals: els seus cambrers veuran el nom nou i l'anterior es perd.",
  igualarProductosSeQuedan: "Els productes no es toquen: continuen a la seva categoria.",
  aplicarTodosEscribe: "S'escriurà el nom d'1 categoria als terminals on falta. | S'escriurà el nom de {n} categories als terminals on falta.",
  aplicarTodosSaltadas: "1 categoria amb noms diferents entre terminals es queda com està: unifica-la des del seu avís. | {n} categories amb noms diferents entre terminals es queden com estan: unifica-les des del seu avís.",
  igualarQueCambia: "Què canvia:",
  unificarOtroNombreBueno: "Si el nom bo és un altre, cancel·la i canvia-li el nom amb el llapis: el nom que posis es desarà a tots els terminals.",
  aplicarTodosFaltaEn: "falta a {terminales}",
  aplicarTodosNada: "No hi ha res a aplicar: les categories pendents tenen noms diferents entre terminals i cal unificar-les abans.",
  igualarSeCrea: "no la té",
  igualarSinNombre: "sense nom",
  reordenarTitulo: "Voleu reordenar les categories com al servidor?",
  reordenarMandaServidor: "Mana l'ordre del servidor «{servidor}»: als altres terminals, cada categoria passa a la tecla que hi té.",
  reordenarCambianTecla: "1 categoria canvia de tecla: al seu terminal apareixerà en un altre lloc. | {n} categories canvien de tecla: al seu terminal apareixeran en un altre lloc.",
  reordenarApartadas: "1 categoria que el servidor no té s'aparta a una altra tecla per deixar lloc. | {n} categories que el servidor no té s'aparten a una altra tecla per deixar lloc.",
  reordenarProductosSeVan: "Els productes se'n van amb la seva categoria: cap no canvia de categoria.",
  reordenarNombresNoSeTocan: "No es canvia cap nom. Si després queda alguna diferència de nom, s'arregla amb Unificar.",
  reordenarSinSitio: "No es reordena aquest terminal: no queda cap tecla lliure on apartar les categories que destorben.",
  reordenarSeAparta: "s'aparta",
  reordenarAmbiguos: "No es mouen perquè el seu nom està repetit: {nombres}.",
  reordenarSinCambios: "Les categories ja són a les mateixes tecles que al servidor.",
  ordenPrimeroTitulo: "Abans convé reordenar",
  ordenPrimeroTexto: "Hi ha terminals amb les categories en altres tecles que al servidor. Convé reordenar-les abans de fer això: si no, es poden produir canvis erronis —per exemple, posar un nom damunt d'una altra categoria— i no es garanteix que tot funcioni bé després.",
  continuarIgualmente: "Continuar igualment",
  reordenarPrimero: "Reordenar primer",
  // Els "Com ho soluciono?" dels avisos. Text fix: es pinta amb v-html.
  comoLoSoluciono: "Com ho soluciono?",
  consejoOrdenAvisos: "Arregla'ls de dalt a baix: cada arranjament pot canviar o treure els avisos de sota. Recarrega la pantalla després de cadascun.",
  consejoOrdenDistinto: "<p>Sol passar quan algú ha creat o mogut categories des del mateix TPV: la mateixa categoria és en una tecla al servidor i en una altra en aquell terminal.</p><ol><li>Prem <b>Reordenar</b>. L'avís mostra, terminal per terminal, quina categoria passa a quina tecla.</li><li>Confirma. Els productes se'n van amb la seva categoria: no cal tornar-los a col·locar.</li><li>Espera que el terminal sincronitzi i comprova-hi que cada tecla té els seus productes.</li><li>Recarrega la pantalla i continua amb la resta d'avisos: ara ja compten bé.</li></ol><p>Si un terminal surt com a «no s'ha pogut reordenar», és que té les 40 tecles ocupades. Elimina-hi les categories que sobrin i torna a reordenar.</p><p>Mentre aquest avís hi sigui, no unifiquis noms: posaries el nom a la tecla que no toca.</p>",
  consejoOtroNombre: "<p>Gairebé sempre és que algú l'ha reanomenat al TPV. El servidor mana.</p><ul><li><b>Si val el nom del servidor:</b> prem <b>Unificar</b> i tots els terminals passen a anomenar-la així.</li><li><b>Si val el del terminal:</b> edita-la amb el llapis i escriu aquest nom. Es desa a tots els terminals.</li><li><b>Si els dos noms semblen de categories diferents</b> (per exemple, «AMPOLLES» i «XUPITOS»), no és un nom canviat sinó tecles creuades: reordena primer.</li></ul><p>Fins que no estigui resolt, aquest grup no es pot reindexar.</p>",
  consejoSoloEnClientes: "<p>S'ha creat en un terminal client i no al servidor. Abans de decidir, mira quants productes té i, si dubtes, pregunta al local si la fan servir.</p><ul><li><b>Si la fan servir:</b> prem <b>Crear al servidor</b>. Es crea al servidor i als terminals on falti, a la mateixa tecla.</li><li><b>Si sobra:</b> prem <b>Treure del terminal</b> i tria a quina categoria passen els seus productes, perquè no es quedin sense categoria.</li></ul>",
  consejoNombreRepetido: "<p>Dues tecles amb el mateix nom confonen el cambrer, i Reordenar no les mou perquè no sap quina és quina.</p><ul><li><b>Si calen totes dues:</b> edita'n una amb el llapis i posa-li un nom que la distingeixi (per exemple, «VINS BLANCS»).</li><li><b>Si una sobra:</b> elimina-la amb la X i passa'n els productes a l'altra.</li></ul><p>Normalment la bona és la que té més productes.</p>",
  consejoDesiguales: "<p>Passa amb terminals que estaven apagats o sense connexió quan es va crear la categoria, o amb terminals que s'han afegit després. A cada fila, l'estat en ambre diu en quants terminals falta.</p><ol><li>Si hi ha avisos vermells de nom diferent, arregla'ls abans: aquestes categories se salten.</li><li>Prem <b>Aplicar a tots</b>. Abans d'escriure, mostra quin terminal rep què.</li><li>Confirma i espera que els terminals sincronitzin.</li></ol><p>Si després de sincronitzar encara falta en un terminal, comprova que està encès i amb connexió.</p>",
  consejoTerminalesSinCategorias: "<p>El negoci encara no té categories per portar-li. Crea-les amb <b>Afegir categoria</b> a cada grup: es creen alhora a tots els terminals.</p><p>Si aquell terminal ja no es fa servir, demana que el donin de baixa perquè deixi de comptar aquí.</p>",
  consejoProductosSinCategoria: "<p>Solen venir d'eliminar una categoria sense triar destinació, o de productes creats al TPV sense categoria. Es continuen venent, però el cambrer només els troba cercant-los.</p><ol><li>Si no existeix la categoria on haurien d'anar, crea-la abans amb <b>Afegir categoria</b>.</li><li>Prem <b>Veure productes</b>, marca els que van junts i tria la categoria.</li><li>Prem <b>Assignar aquesta categoria</b>. Es mouen a tots els terminals.</li><li>Repeteix amb la resta.</li></ol><p>Els d'un grup concret també es veuen des de l'ull de la seva fila «Sense categoria».</p>",
  consejoTerminalPendiente: "<p>No cal fer res aquí. Encén el terminal amb connexió: copiarà la carta del servidor i, en pujar-la, entrarà en aquests comptes com un més.</p><p>Si passa el temps i continua sortint, comprova que el terminal s'ha encès i té connexió.</p>",
};



// WEBPACK FOOTER //
// ./src/language/catalan.js